webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

  __webpack_require__(263);
  __webpack_require__(388);
  module.exports = __webpack_require__(258);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

  var global    = __webpack_require__(10)
    , core      = __webpack_require__(31)
    , hide      = __webpack_require__(27)
    , redefine  = __webpack_require__(22)
    , ctx       = __webpack_require__(25)
    , PROTOTYPE = 'prototype';
  
  var $export = function(type, name, source){
    var IS_FORCED = type & $export.F
      , IS_GLOBAL = type & $export.G
      , IS_STATIC = type & $export.S
      , IS_PROTO  = type & $export.P
      , IS_BIND   = type & $export.B
      , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
      , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
      , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
      , key, own, out, exp;
    if(IS_GLOBAL)source = name;
    for(key in source){
      // contains in native
      own = !IS_FORCED && target && key in target;
      // export native or passed
      out = (own ? target : source)[key];
      // bind timers to global for call from export context
      exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
      // extend global
      if(target && !own)redefine(target, key, out);
      // export
      if(exports[key] != out)hide(exports, key, exp);
      if(IS_PROTO && expProto[key] != out)expProto[key] = out;
    }
  };
  global.core = core;
  // type bitmap
  $export.F = 1;  // forced
  $export.G = 2;  // global
  $export.S = 4;  // static
  $export.P = 8;  // proto
  $export.B = 16; // bind
  $export.W = 32; // wrap
  module.exports = $export;

/***/ },
/* 2 */,
/* 3 */
/***/ function(module, exports) {

  var $Object = Object;
  module.exports = {
    create:     $Object.create,
    getProto:   $Object.getPrototypeOf,
    isEnum:     {}.propertyIsEnumerable,
    getDesc:    $Object.getOwnPropertyDescriptor,
    setDesc:    $Object.defineProperty,
    setDescs:   $Object.defineProperties,
    getKeys:    $Object.keys,
    getNames:   $Object.getOwnPropertyNames,
    getSymbols: $Object.getOwnPropertySymbols,
    each:       [].forEach
  };

/***/ },
/* 4 */,
/* 5 */,
/* 6 */
/***/ function(module, exports) {

  module.exports = function(it){
    return typeof it === 'object' ? it !== null : typeof it === 'function';
  };

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

  var isObject = __webpack_require__(6);
  module.exports = function(it){
    if(!isObject(it))throw TypeError(it + ' is not an object!');
    return it;
  };

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

  var store  = __webpack_require__(158)('wks')
    , uid    = __webpack_require__(45)
    , Symbol = __webpack_require__(10).Symbol;
  module.exports = function(name){
    return store[name] || (store[name] =
      Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
  };

/***/ },
/* 9 */,
/* 10 */
/***/ function(module, exports) {

  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math
    ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
  if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 11 */
/***/ function(module, exports) {

  module.exports = function(exec){
    try {
      return !!exec();
    } catch(e){
      return true;
    }
  };

/***/ },
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ function(module, exports) {

  var hasOwnProperty = {}.hasOwnProperty;
  module.exports = function(it, key){
    return hasOwnProperty.call(it, key);
  };

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

  // 7.1.15 ToLength
  var toInteger = __webpack_require__(55)
    , min       = Math.min;
  module.exports = function(it){
    return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
  };

/***/ },
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ function(module, exports, __webpack_require__) {

  // Thank's IE8 for his funny defineProperty
  module.exports = !__webpack_require__(11)(function(){
    return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
  });

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

  // most Object methods by ES6 should accept primitives
  var $export = __webpack_require__(1)
    , core    = __webpack_require__(31)
    , fails   = __webpack_require__(11);
  module.exports = function(KEY, exec){
    var fn  = (core.Object || {})[KEY] || Object[KEY]
      , exp = {};
    exp[KEY] = exec(fn);
    $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
  };

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

  // add fake Function#toString
  // for correct work wrapped methods / constructors with methods like LoDash isNative
  var global    = __webpack_require__(10)
    , hide      = __webpack_require__(27)
    , SRC       = __webpack_require__(45)('src')
    , TO_STRING = 'toString'
    , $toString = Function[TO_STRING]
    , TPL       = ('' + $toString).split(TO_STRING);
  
  __webpack_require__(31).inspectSource = function(it){
    return $toString.call(it);
  };
  
  (module.exports = function(O, key, val, safe){
    if(typeof val == 'function'){
      val.hasOwnProperty(SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
      val.hasOwnProperty('name') || hide(val, 'name', key);
    }
    if(O === global){
      O[key] = val;
    } else {
      if(!safe)delete O[key];
      hide(O, key, val);
    }
  })(Function.prototype, TO_STRING, function toString(){
    return typeof this == 'function' && this[SRC] || $toString.call(this);
  });

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

  // to indexed object, toObject with fallback for non-array-like ES3 strings
  var IObject = __webpack_require__(69)
    , defined = __webpack_require__(26);
  module.exports = function(it){
    return IObject(defined(it));
  };

/***/ },
/* 24 */,
/* 25 */
/***/ function(module, exports, __webpack_require__) {

  // optional / simple context binding
  var aFunction = __webpack_require__(43);
  module.exports = function(fn, that, length){
    aFunction(fn);
    if(that === undefined)return fn;
    switch(length){
      case 1: return function(a){
        return fn.call(that, a);
      };
      case 2: return function(a, b){
        return fn.call(that, a, b);
      };
      case 3: return function(a, b, c){
        return fn.call(that, a, b, c);
      };
    }
    return function(/* ...args */){
      return fn.apply(that, arguments);
    };
  };

/***/ },
/* 26 */
/***/ function(module, exports) {

  // 7.2.1 RequireObjectCoercible(argument)
  module.exports = function(it){
    if(it == undefined)throw TypeError("Can't call method on  " + it);
    return it;
  };

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

  var $          = __webpack_require__(3)
    , createDesc = __webpack_require__(36);
  module.exports = __webpack_require__(20) ? function(object, key, value){
    return $.setDesc(object, key, createDesc(1, value));
  } : function(object, key, value){
    object[key] = value;
    return object;
  };

/***/ },
/* 28 */,
/* 29 */,
/* 30 */
/***/ function(module, exports) {

  var toString = {}.toString;
  
  module.exports = function(it){
    return toString.call(it).slice(8, -1);
  };

/***/ },
/* 31 */
/***/ function(module, exports) {

  var core = module.exports = {version: '1.2.6'};
  if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

  // 7.1.13 ToObject(argument)
  var defined = __webpack_require__(26);
  module.exports = function(it){
    return Object(defined(it));
  };

/***/ },
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ function(module, exports) {

  module.exports = function(bitmap, value){
    return {
      enumerable  : !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable    : !(bitmap & 4),
      value       : value
    };
  };

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

  /* WEBPACK VAR INJECTION */(function(module, global) {var checkGlobal = __webpack_require__(441);
  
  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };
  
  /** Detect free variable `exports`. */
  var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
    ? exports
    : undefined;
  
  /** Detect free variable `module`. */
  var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
    ? module
    : undefined;
  
  /** Detect free variable `global` from Node.js. */
  var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);
  
  /** Detect free variable `self`. */
  var freeSelf = checkGlobal(objectTypes[typeof self] && self);
  
  /** Detect free variable `window`. */
  var freeWindow = checkGlobal(objectTypes[typeof window] && window);
  
  /** Detect `this` as the global object. */
  var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
  
  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal ||
    ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
      freeSelf || thisGlobal || Function('return this')();
  
  module.exports = root;
  
  /* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(239)(module), (function() { return this; }())))

/***/ },
/* 38 */
/***/ function(module, exports) {

  /**
   * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
   * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
  }
  
  module.exports = isObject;


/***/ },
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.STORAGE_KEY = exports.GAME_WON_TILE = exports.INITIAL_STATE = undefined;
  
  var _immutable = __webpack_require__(34);
  
  var U = undefined;
  
  var INITIAL_STATE = exports.INITIAL_STATE = (0, _immutable.fromJS)({
    isLoading: false,
  
    game: {
      state: [// :off
      [U, U, U, U], [U, U, U, U], [U, U, U, U], [U, U, U, U]], // :on
  
      meta: {
        score: 0,
  
        topScore: 0,
  
        inProgress: false,
  
        gameOver: false,
  
        gameWon: false
      }
    }
  });
  
  var GAME_WON_TILE = exports.GAME_WON_TILE = 2048;
  var STORAGE_KEY = exports.STORAGE_KEY = '2048_state';

/***/ },
/* 43 */
/***/ function(module, exports) {

  module.exports = function(it){
    if(typeof it != 'function')throw TypeError(it + ' is not a function!');
    return it;
  };

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

  // 22.1.3.31 Array.prototype[@@unscopables]
  var UNSCOPABLES = __webpack_require__(8)('unscopables')
    , ArrayProto  = Array.prototype;
  if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(27)(ArrayProto, UNSCOPABLES, {});
  module.exports = function(key){
    ArrayProto[UNSCOPABLES][key] = true;
  };

/***/ },
/* 45 */
/***/ function(module, exports) {

  var id = 0
    , px = Math.random();
  module.exports = function(key){
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
  };

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

  var getNative = __webpack_require__(76),
      root = __webpack_require__(37);
  
  /* Built-in method references that are verified to be native. */
  var Map = getNative(root, 'Map');
  
  module.exports = Map;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

  var isObject = __webpack_require__(38);
  
  /** `Object#toString` result references. */
  var funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]';
  
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  
  /**
   * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
   * of values.
   */
  var objectToString = objectProto.toString;
  
  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8 which returns 'object' for typed array constructors, and
    // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
  }
  
  module.exports = isFunction;


/***/ },
/* 48 */,
/* 49 */,
/* 50 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CREATE_TILE = exports.SHIFT_DOWN = exports.SHIFT_UP = exports.SHIFT_RIGHT = exports.SHIFT_LEFT = exports.NEW_GAME = undefined;
  exports.default = reducer;
  exports.handleNewGame = handleNewGame;
  exports.handleShiftLeft = handleShiftLeft;
  exports.handleShiftRight = handleShiftRight;
  exports.handleShiftDown = handleShiftDown;
  exports.handleShiftUp = handleShiftUp;
  exports.handleCreateTiles = handleCreateTiles;
  
  var _model = __webpack_require__(255);
  
  var _utils = __webpack_require__(137);
  
  var NEW_GAME = exports.NEW_GAME = '2048/game/NEW_GAME';
  var SHIFT_LEFT = exports.SHIFT_LEFT = '2048/game/SHIFT_LEFT';
  var SHIFT_RIGHT = exports.SHIFT_RIGHT = '2048/game/SHIFT_RIGHT';
  var SHIFT_UP = exports.SHIFT_UP = '2048/game/SHIFT_UP';
  var SHIFT_DOWN = exports.SHIFT_DOWN = '2048/game/SHIFT_DOWN';
  var CREATE_TILE = exports.CREATE_TILE = '2048/game/CREATE_TILE';
  
  function reducer(state, action) {
    switch (action.type) {
      case NEW_GAME:
        return state.update('state', _model.newGame).update('meta', function (meta) {
          return meta.merge({
            score: 0, inProgress: true, gameWon: false, gameOver: false
          });
        });
      case SHIFT_LEFT:
        return state.update('state', _model.updateTilesFromValue).update('state', _model.shiftLeft).update('state', _model.updateTilesCoordinates).update(_model.updateMeta);
      case SHIFT_RIGHT:
        return state.update('state', _model.updateTilesFromValue).update('state', _model.shiftRight).update('state', _model.updateTilesCoordinates).update(_model.updateMeta);
      case SHIFT_UP:
        return state.update('state', _model.updateTilesFromValue).update('state', _model.shiftUp).update('state', _model.updateTilesCoordinates).update(_model.updateMeta);
      case SHIFT_DOWN:
        return state.update('state', _model.updateTilesFromValue).update('state', _model.shiftDown).update('state', _model.updateTilesCoordinates).update(_model.updateMeta);
      case CREATE_TILE:
        // eslint-disable-line no-case-declarations
        var newTiles = action.payload.map(function (_ref) {
          var value = _ref.value;
          var col = _ref.col;
          var row = _ref.row;
          var id = _ref.id;
          return (0, _utils.tileFactory)(value, col, row, id);
        });
        return state.update('state', _model.updateTilesCoordinates).update('state', (0, _model.pushTiles)(newTiles));
      default:
        return state;
    }
  }
  
  function handleNewGame() {
    return { type: NEW_GAME };
  }
  
  function handleShiftLeft() {
    return { type: SHIFT_LEFT };
  }
  
  function handleShiftRight() {
    return { type: SHIFT_RIGHT };
  }
  
  function handleShiftDown() {
    return { type: SHIFT_DOWN };
  }
  
  function handleShiftUp() {
    return { type: SHIFT_UP };
  }
  
  function handleCreateTiles(payload) {
    return {
      type: CREATE_TILE, payload: payload
    };
  }

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

  var ctx         = __webpack_require__(25)
    , call        = __webpack_require__(151)
    , isArrayIter = __webpack_require__(148)
    , anObject    = __webpack_require__(7)
    , toLength    = __webpack_require__(16)
    , getIterFn   = __webpack_require__(162);
  module.exports = function(iterable, entries, fn, that){
    var iterFn = getIterFn(iterable)
      , f      = ctx(fn, that, entries ? 2 : 1)
      , index  = 0
      , length, step, iterator;
    if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
    // fast case for arrays with default iterator
    if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
      entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
      call(iterator, f, step.value, entries);
    }
  };

/***/ },
/* 52 */
/***/ function(module, exports) {

  module.exports = {};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

  var def = __webpack_require__(3).setDesc
    , has = __webpack_require__(15)
    , TAG = __webpack_require__(8)('toStringTag');
  
  module.exports = function(it, tag, stat){
    if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
  };

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

  var toInteger = __webpack_require__(55)
    , max       = Math.max
    , min       = Math.min;
  module.exports = function(index, length){
    index = toInteger(index);
    return index < 0 ? max(index + length, 0) : min(index, length);
  };

/***/ },
/* 55 */
/***/ function(module, exports) {

  // 7.1.4 ToInteger
  var ceil  = Math.ceil
    , floor = Math.floor;
  module.exports = function(it){
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
  };

/***/ },
/* 56 */,
/* 57 */
/***/ function(module, exports) {

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @type {Function}
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;
  
  module.exports = isArray;


/***/ },
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ function(module, exports, __webpack_require__) {

  // 0 -> Array#forEach
  // 1 -> Array#map
  // 2 -> Array#filter
  // 3 -> Array#some
  // 4 -> Array#every
  // 5 -> Array#find
  // 6 -> Array#findIndex
  var ctx      = __webpack_require__(25)
    , IObject  = __webpack_require__(69)
    , toObject = __webpack_require__(32)
    , toLength = __webpack_require__(16)
    , asc      = __webpack_require__(269);
  module.exports = function(TYPE){
    var IS_MAP        = TYPE == 1
      , IS_FILTER     = TYPE == 2
      , IS_SOME       = TYPE == 3
      , IS_EVERY      = TYPE == 4
      , IS_FIND_INDEX = TYPE == 6
      , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that){
      var O      = toObject($this)
        , self   = IObject(O)
        , f      = ctx(callbackfn, that, 3)
        , length = toLength(self.length)
        , index  = 0
        , result = IS_MAP ? asc($this, length) : IS_FILTER ? asc($this, 0) : undefined
        , val, res;
      for(;length > index; index++)if(NO_HOLES || index in self){
        val = self[index];
        res = f(val, index, O);
        if(TYPE){
          if(IS_MAP)result[index] = res;            // map
          else if(res)switch(TYPE){
            case 3: return true;                    // some
            case 5: return val;                     // find
            case 6: return index;                   // findIndex
            case 2: result.push(val);               // filter
          } else if(IS_EVERY)return false;          // every
        }
      }
      return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
    };
  };

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

  // getting tag from 19.1.3.6 Object.prototype.toString()
  var cof = __webpack_require__(30)
    , TAG = __webpack_require__(8)('toStringTag')
    // ES3 wrong here
    , ARG = cof(function(){ return arguments; }()) == 'Arguments';
  
  module.exports = function(it){
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null'
      // @@toStringTag case
      : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
      // builtinTag case
      : ARG ? cof(O)
      // ES3 arguments fallback
      : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
  };

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var global         = __webpack_require__(10)
    , $export        = __webpack_require__(1)
    , redefine       = __webpack_require__(22)
    , redefineAll    = __webpack_require__(70)
    , forOf          = __webpack_require__(51)
    , strictNew      = __webpack_require__(72)
    , isObject       = __webpack_require__(6)
    , fails          = __webpack_require__(11)
    , $iterDetect    = __webpack_require__(96)
    , setToStringTag = __webpack_require__(53);
  
  module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
    var Base  = global[NAME]
      , C     = Base
      , ADDER = IS_MAP ? 'set' : 'add'
      , proto = C && C.prototype
      , O     = {};
    var fixMethod = function(KEY){
      var fn = proto[KEY];
      redefine(proto, KEY,
        KEY == 'delete' ? function(a){
          return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'has' ? function has(a){
          return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'get' ? function get(a){
          return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
          : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
      );
    };
    if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
      new C().entries().next();
    }))){
      // create collection constructor
      C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
      redefineAll(C.prototype, methods);
    } else {
      var instance             = new C
        // early implementations not supports chaining
        , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
        // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
        , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
        // for early implementations -0 and +0 not the same
        , BUGGY_ZERO;
      if(!ACCEPT_ITERABLES){ 
        C = wrapper(function(target, iterable){
          strictNew(target, C, NAME);
          var that = new Base;
          if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
          return that;
        });
        C.prototype = proto;
        proto.constructor = C;
      }
      IS_WEAK || instance.forEach(function(val, key){
        BUGGY_ZERO = 1 / key === -Infinity;
      });
      if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
        fixMethod('delete');
        fixMethod('has');
        IS_MAP && fixMethod('get');
      }
      if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
      // weak collections should not contains .clear method
      if(IS_WEAK && proto.clear)delete proto.clear;
    }
  
    setToStringTag(C, NAME);
  
    O[NAME] = C;
    $export($export.G + $export.W + $export.F * (C != Base), O);
  
    if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
  
    return C;
  };

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var hide     = __webpack_require__(27)
    , redefine = __webpack_require__(22)
    , fails    = __webpack_require__(11)
    , defined  = __webpack_require__(26)
    , wks      = __webpack_require__(8);
  
  module.exports = function(KEY, length, exec){
    var SYMBOL   = wks(KEY)
      , original = ''[KEY];
    if(fails(function(){
      var O = {};
      O[SYMBOL] = function(){ return 7; };
      return ''[KEY](O) != 7;
    })){
      redefine(String.prototype, KEY, exec(defined, SYMBOL, original));
      hide(RegExp.prototype, SYMBOL, length == 2
        // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
        // 21.2.5.11 RegExp.prototype[@@split](string, limit)
        ? function(string, arg){ return original.call(string, this, arg); }
        // 21.2.5.6 RegExp.prototype[@@match](string)
        // 21.2.5.9 RegExp.prototype[@@search](string)
        : function(string){ return original.call(string, this); }
      );
    }
  };

/***/ },
/* 68 */
/***/ function(module, exports) {

  // fast apply, http://jsperf.lnkit.com/fast-apply/5
  module.exports = function(fn, args, that){
    var un = that === undefined;
    switch(args.length){
      case 0: return un ? fn()
                        : fn.call(that);
      case 1: return un ? fn(args[0])
                        : fn.call(that, args[0]);
      case 2: return un ? fn(args[0], args[1])
                        : fn.call(that, args[0], args[1]);
      case 3: return un ? fn(args[0], args[1], args[2])
                        : fn.call(that, args[0], args[1], args[2]);
      case 4: return un ? fn(args[0], args[1], args[2], args[3])
                        : fn.call(that, args[0], args[1], args[2], args[3]);
    } return              fn.apply(that, args);
  };

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

  // fallback for non-array-like ES3 and non-enumerable old V8 strings
  var cof = __webpack_require__(30);
  module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
    return cof(it) == 'String' ? it.split('') : Object(it);
  };

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

  var redefine = __webpack_require__(22);
  module.exports = function(target, src){
    for(var key in src)redefine(target, key, src[key]);
    return target;
  };

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var global      = __webpack_require__(10)
    , $           = __webpack_require__(3)
    , DESCRIPTORS = __webpack_require__(20)
    , SPECIES     = __webpack_require__(8)('species');
  
  module.exports = function(KEY){
    var C = global[KEY];
    if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
      configurable: true,
      get: function(){ return this; }
    });
  };

/***/ },
/* 72 */
/***/ function(module, exports) {

  module.exports = function(it, Constructor, name){
    if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
    return it;
  };

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

  var $export = __webpack_require__(1)
    , defined = __webpack_require__(26)
    , fails   = __webpack_require__(11)
    , spaces  = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
        '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF'
    , space   = '[' + spaces + ']'
    , non     = '\u200b\u0085'
    , ltrim   = RegExp('^' + space + space + '*')
    , rtrim   = RegExp(space + space + '*$');
  
  var exporter = function(KEY, exec){
    var exp  = {};
    exp[KEY] = exec(trim);
    $export($export.P + $export.F * fails(function(){
      return !!spaces[KEY]() || non[KEY]() != non;
    }), 'String', exp);
  };
  
  // 1 -> String#trimLeft
  // 2 -> String#trimRight
  // 3 -> String#trim
  var trim = exporter.trim = function(string, TYPE){
    string = String(defined(string));
    if(TYPE & 1)string = string.replace(ltrim, '');
    if(TYPE & 2)string = string.replace(rtrim, '');
    return string;
  };
  
  module.exports = exporter;

/***/ },
/* 74 */,
/* 75 */
/***/ function(module, exports, __webpack_require__) {

  var eq = __webpack_require__(79);
  
  /**
   * Gets the index at which the first occurrence of `key` is found in `array`
   * of key-value pairs.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  
  module.exports = assocIndexOf;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

  var isNative = __webpack_require__(474);
  
  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */
  function getNative(object, key) {
    var value = object == null ? undefined : object[key];
    return isNative(value) ? value : undefined;
  }
  
  module.exports = getNative;


/***/ },
/* 77 */
/***/ function(module, exports) {

  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */
  function isKeyable(value) {
    var type = typeof value;
    return type == 'number' || type == 'boolean' ||
      (type == 'string' && value != '__proto__') || value == null;
  }
  
  module.exports = isKeyable;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

  var getNative = __webpack_require__(76);
  
  /* Built-in method references that are verified to be native. */
  var nativeCreate = getNative(Object, 'create');
  
  module.exports = nativeCreate;


/***/ },
/* 79 */
/***/ function(module, exports) {

  /**
   * Performs a [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'user': 'fred' };
   * var other = { 'user': 'fred' };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || (value !== value && other !== other);
  }
  
  module.exports = eq;


/***/ },
/* 80 */
/***/ function(module, exports) {

  /**
   * This method returns the first argument given to it.
   *
   * @static
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'user': 'fred' };
   *
   * _.identity(object) === object;
   * // => true
   */
  function identity(value) {
    return value;
  }
  
  module.exports = identity;


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

  var getLength = __webpack_require__(453),
      isFunction = __webpack_require__(47),
      isLength = __webpack_require__(108);
  
  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */
  function isArrayLike(value) {
    return value != null &&
      !(typeof value == 'function' && isFunction(value)) && isLength(getLength(value));
  }
  
  module.exports = isArrayLike;


/***/ },
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ function(module, exports, __webpack_require__) {

  var MATCH = __webpack_require__(8)('match');
  module.exports = function(KEY){
    var re = /./;
    try {
      '/./'[KEY](re);
    } catch(e){
      try {
        re[MATCH] = false;
        return !'/./'[KEY](re);
      } catch(f){ /* empty */ }
    } return true;
  };

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

  // 7.2.2 IsArray(argument)
  var cof = __webpack_require__(30);
  module.exports = Array.isArray || function(arg){
    return cof(arg) == 'Array';
  };

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var LIBRARY        = __webpack_require__(97)
    , $export        = __webpack_require__(1)
    , redefine       = __webpack_require__(22)
    , hide           = __webpack_require__(27)
    , has            = __webpack_require__(15)
    , Iterators      = __webpack_require__(52)
    , $iterCreate    = __webpack_require__(152)
    , setToStringTag = __webpack_require__(53)
    , getProto       = __webpack_require__(3).getProto
    , ITERATOR       = __webpack_require__(8)('iterator')
    , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
    , FF_ITERATOR    = '@@iterator'
    , KEYS           = 'keys'
    , VALUES         = 'values';
  
  var returnThis = function(){ return this; };
  
  module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
    $iterCreate(Constructor, NAME, next);
    var getMethod = function(kind){
      if(!BUGGY && kind in proto)return proto[kind];
      switch(kind){
        case KEYS: return function keys(){ return new Constructor(this, kind); };
        case VALUES: return function values(){ return new Constructor(this, kind); };
      } return function entries(){ return new Constructor(this, kind); };
    };
    var TAG        = NAME + ' Iterator'
      , DEF_VALUES = DEFAULT == VALUES
      , VALUES_BUG = false
      , proto      = Base.prototype
      , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
      , $default   = $native || getMethod(DEFAULT)
      , methods, key;
    // Fix native
    if($native){
      var IteratorPrototype = getProto($default.call(new Base));
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // FF fix
      if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
      // fix Array#{values, @@iterator}.name in V8 / FF
      if(DEF_VALUES && $native.name !== VALUES){
        VALUES_BUG = true;
        $default = function values(){ return $native.call(this); };
      }
    }
    // Define iterator
    if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
      hide(proto, ITERATOR, $default);
    }
    // Plug for library
    Iterators[NAME] = $default;
    Iterators[TAG]  = returnThis;
    if(DEFAULT){
      methods = {
        values:  DEF_VALUES  ? $default : getMethod(VALUES),
        keys:    IS_SET      ? $default : getMethod(KEYS),
        entries: !DEF_VALUES ? $default : getMethod('entries')
      };
      if(FORCED)for(key in methods){
        if(!(key in proto))redefine(proto, key, methods[key]);
      } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
  };

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

  var ITERATOR     = __webpack_require__(8)('iterator')
    , SAFE_CLOSING = false;
  
  try {
    var riter = [7][ITERATOR]();
    riter['return'] = function(){ SAFE_CLOSING = true; };
    Array.from(riter, function(){ throw 2; });
  } catch(e){ /* empty */ }
  
  module.exports = function(exec, skipClosing){
    if(!skipClosing && !SAFE_CLOSING)return false;
    var safe = false;
    try {
      var arr  = [7]
        , iter = arr[ITERATOR]();
      iter.next = function(){ safe = true; };
      arr[ITERATOR] = function(){ return iter; };
      exec(arr);
    } catch(e){ /* empty */ }
    return safe;
  };

/***/ },
/* 97 */
/***/ function(module, exports) {

  module.exports = false;

/***/ },
/* 98 */
/***/ function(module, exports) {

  // 20.2.2.14 Math.expm1(x)
  module.exports = Math.expm1 || function expm1(x){
    return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
  };

/***/ },
/* 99 */
/***/ function(module, exports) {

  // 20.2.2.28 Math.sign(x)
  module.exports = Math.sign || function sign(x){
    return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
  };

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

  // Works with __proto__ only. Old v8 can't work with null proto objects.
  /* eslint-disable no-proto */
  var getDesc  = __webpack_require__(3).getDesc
    , isObject = __webpack_require__(6)
    , anObject = __webpack_require__(7);
  var check = function(O, proto){
    anObject(O);
    if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
  };
  module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
      function(test, buggy, set){
        try {
          set = __webpack_require__(25)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
          set(test, []);
          buggy = !(test instanceof Array);
        } catch(e){ buggy = true; }
        return function setPrototypeOf(O, proto){
          check(O, proto);
          if(buggy)O.__proto__ = proto;
          else set(O, proto);
          return O;
        };
      }({}, false) : undefined),
    check: check
  };

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

  var toInteger = __webpack_require__(55)
    , defined   = __webpack_require__(26);
  // true  -> String#at
  // false -> String#codePointAt
  module.exports = function(TO_STRING){
    return function(that, pos){
      var s = String(defined(that))
        , i = toInteger(pos)
        , l = s.length
        , a, b;
      if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
      a = s.charCodeAt(i);
      return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
        ? TO_STRING ? s.charAt(i) : a
        : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
  };

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

  // helper for String#{startsWith, endsWith, includes}
  var isRegExp = __webpack_require__(150)
    , defined  = __webpack_require__(26);
  
  module.exports = function(that, searchString, NAME){
    if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
    return String(defined(that));
  };

/***/ },
/* 103 */
/***/ function(module, exports) {

  /**
   * Copies the values of `source` to `array`.
   *
   * @private
   * @param {Array} source The array to copy values from.
   * @param {Array} [array=[]] The array to copy values to.
   * @returns {Array} Returns `array`.
   */
  function copyArray(source, array) {
    var index = -1,
        length = source.length;
  
    array || (array = Array(length));
    while (++index < length) {
      array[index] = source[index];
    }
    return array;
  }
  
  module.exports = copyArray;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

  var copyObjectWith = __webpack_require__(448);
  
  /**
   * Copies properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy properties from.
   * @param {Array} props The property names to copy.
   * @param {Object} [object={}] The object to copy properties to.
   * @returns {Object} Returns `object`.
   */
  function copyObject(source, props, object) {
    return copyObjectWith(source, props, object);
  }
  
  module.exports = copyObject;


/***/ },
/* 105 */,
/* 106 */
/***/ function(module, exports) {

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;
  
  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;
  
  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */
  function isIndex(value, length) {
    value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return value > -1 && value % 1 == 0 && value < length;
  }
  
  module.exports = isIndex;


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

  var isFunction = __webpack_require__(47);
  
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  
  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */
  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = (isFunction(Ctor) && Ctor.prototype) || objectProto;
  
    return value === proto;
  }
  
  module.exports = isPrototype;


/***/ },
/* 108 */
/***/ function(module, exports) {

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;
  
  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This function is loosely based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */
  function isLength(value) {
    return typeof value == 'number' &&
      value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  
  module.exports = isLength;


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

  var baseHas = __webpack_require__(431),
      baseKeys = __webpack_require__(432),
      indexKeys = __webpack_require__(185),
      isArrayLike = __webpack_require__(81),
      isIndex = __webpack_require__(106),
      isPrototype = __webpack_require__(107);
  
  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */
  function keys(object) {
    var isProto = isPrototype(object);
    if (!(isProto || isArrayLike(object))) {
      return baseKeys(object);
    }
    var indexes = indexKeys(object),
        skipIndexes = !!indexes,
        result = indexes || [],
        length = result.length;
  
    for (var key in object) {
      if (baseHas(object, key) &&
          !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
          !(isProto && key == 'constructor')) {
        result.push(key);
      }
    }
    return result;
  }
  
  module.exports = keys;


/***/ },
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ function(module, exports) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var titlePrefix = exports.titlePrefix = '2048';
  var description = exports.description = '2048 Clone';
  var googleAnalyticsId = exports.googleAnalyticsId = 'UA-XXXXX-X';

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  
  var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
  
  exports.NewGameButton = NewGameButton;
  
  var _react = __webpack_require__(9);
  
  var _react2 = _interopRequireDefault(_react);
  
  var _NewGameButton = __webpack_require__(396);
  
  var _NewGameButton2 = _interopRequireDefault(_NewGameButton);
  
  var _reactRedux = __webpack_require__(39);
  
  var _redux = __webpack_require__(63);
  
  var _game = __webpack_require__(50);
  
  var actionCreators = _interopRequireWildcard(_game);
  
  function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  
  function NewGameButton(_ref) {
    var handleNewGame = _ref.handleNewGame;
    var children = _ref.children;
  
    return _react2.default.createElement(
      'button',
      {
        className: _NewGameButton2.default.NewGameButton,
        onClick: handleNewGame
      },
      children
    );
  }
  
  NewGameButton.propTypes = { // :off
    handleNewGame: _react.PropTypes.func.isRequired,
    children: _react.PropTypes.string.isRequired
  }; // :on
  
  exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(NewGameButton);
  
  
  function mapDispatchToProps(dispatch) {
    var handleNewGame = actionCreators.handleNewGame;
  
    return _extends({}, (0, _redux.bindActionCreators)({ handleNewGame: handleNewGame }, dispatch));
  }

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  
  var _range = __webpack_require__(475);
  
  var _range2 = _interopRequireDefault(_range);
  
  exports.tileFactory = tileFactory;
  exports.transpose = transpose;
  exports.shift = shift;
  exports.tileNeighbors = tileNeighbors;
  
  var _immutable = __webpack_require__(34);
  
  var _nodeUuid = __webpack_require__(198);
  
  var _nodeUuid2 = _interopRequireDefault(_nodeUuid);
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  
  var _marked = [tileNeighbors].map(regeneratorRuntime.mark);
  
  function tileFactory(value) {
    var col = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
    var row = arguments.length <= 2 || arguments[2] === undefined ? 0 : arguments[2];
    var id = arguments.length <= 3 || arguments[3] === undefined ? undefined : arguments[3];
  
    return (0, _immutable.fromJS)({ value: value, col: col, row: row, fromValue: value, id: id || _nodeUuid2.default.v4() });
  }
  
  function transpose(state) {
    return state.asMutable().update(function (value) {
      return value.map(function (col, index) {
        return state.map(function (row) {
          return row.get(index);
        });
      });
    }).asImmutable();
  }
  
  function shift() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.List)() : arguments[0];
  
    return state.update(function (value) {
      return _shift(undefined, value.toStack());
    }).toList().setSize(state.size);
  
    function _shift(x) {
      var xs = arguments.length <= 1 || arguments[1] === undefined ? (0, _immutable.Stack)() : arguments[1];
  
      // Guard last item.
      if (!xs.size) {
        return xs.withMutations(function (stack) {
          return stack.unshift(x);
        });
      }
  
      // Guard shift undefined
      if (!x) {
        return _shift(xs.first(), xs.shift());
      }
  
      // Guard next is undefined
      if (!xs.first()) {
        return _shift(x, xs.shift());
      }
  
      // next
      var y = xs.first();
      var ys = xs.shift();
  
      // combine blocks
      if (x.get('value') === y.get('value')) {
        return _shift(ys.first(), ys.shift()).withMutations(function (stack) {
          return stack.unshift(y.update('value', function (v) {
            return v * 2;
          }));
        });
      }
  
      // concat blocks
      return _shift(y, ys).withMutations(function (stack) {
        return stack.unshift(x);
      });
    }
  }
  
  function tileNeighbors(size) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, x, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, y, z;
  
    return regeneratorRuntime.wrap(function tileNeighbors$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 3;
            _iterator = (0, _range2.default)(size - 1)[Symbol.iterator]();
  
          case 5:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context.next = 36;
              break;
            }
  
            x = _step.value;
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            _context.prev = 10;
            _iterator2 = (0, _range2.default)(size - 1)[Symbol.iterator]();
  
          case 12:
            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
              _context.next = 19;
              break;
            }
  
            y = _step2.value;
            _context.next = 16;
            return [[x, y], [x + 1, y], [x, y + 1]];
  
          case 16:
            _iteratorNormalCompletion2 = true;
            _context.next = 12;
            break;
  
          case 19:
            _context.next = 25;
            break;
  
          case 21:
            _context.prev = 21;
            _context.t0 = _context['catch'](10);
            _didIteratorError2 = true;
            _iteratorError2 = _context.t0;
  
          case 25:
            _context.prev = 25;
            _context.prev = 26;
  
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
  
          case 28:
            _context.prev = 28;
  
            if (!_didIteratorError2) {
              _context.next = 31;
              break;
            }
  
            throw _iteratorError2;
  
          case 31:
            return _context.finish(28);
  
          case 32:
            return _context.finish(25);
  
          case 33:
            _iteratorNormalCompletion = true;
            _context.next = 5;
            break;
  
          case 36:
            _context.next = 42;
            break;
  
          case 38:
            _context.prev = 38;
            _context.t1 = _context['catch'](3);
            _didIteratorError = true;
            _iteratorError = _context.t1;
  
          case 42:
            _context.prev = 42;
            _context.prev = 43;
  
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
  
          case 45:
            _context.prev = 45;
  
            if (!_didIteratorError) {
              _context.next = 48;
              break;
            }
  
            throw _iteratorError;
  
          case 48:
            return _context.finish(45);
  
          case 49:
            return _context.finish(42);
  
          case 50:
            z = size - 1;
            _context.next = 53;
            return [[z, z], [z - 1, z], [z, z - 1]];
  
          case 53:
          case 'end':
            return _context.stop();
        }
      }
    }, _marked[0], this, [[3, 38, 42, 50], [10, 21, 25, 33], [26,, 28, 32], [43,, 45, 49]]);
  }

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = reducer;
  exports.setState = setState;
  
  var _constants = __webpack_require__(42);
  
  function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { return step("next", value); }, function (err) { return step("throw", err); }); } } return step("next"); }); }; }
  
  var SET_STATE_INIT = '2048/root/SET_STATE_INIT';
  var SET_STATE_COMPLETE = '2048/root/SET_STATE_COMPLETE';
  
  function reducer(state, action) {
    switch (action.type) {
      case SET_STATE_INIT:
        return state.set('isLoading', true);
      case SET_STATE_COMPLETE:
        return state.merge(action.payload).set('isLoading', false);
      default:
        return state;
    }
  }
  
  function setStateInit() {
    return { type: SET_STATE_INIT };
  }
  
  function setStateComplete(payload) {
    return { type: SET_STATE_COMPLETE, payload: payload };
  }
  
  function setState(payload) {
    var _this2 = this;
  
    return function () {
      var ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch(setStateInit());
                _context.t0 = _constants.INITIAL_STATE;
                _context.next = 4;
                return payload;
  
              case 4:
                _context.t1 = _context.sent;
                _context.t2 = _context.t0.merge.call(_context.t0, _context.t1).toJS();
                _context.t3 = setStateComplete(_context.t2);
                dispatch(_context.t3);
  
              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      })),
          _this = _this2;
  
      return function (_x) {
        return ref.apply(_this, arguments);
      };
    }();
  }

/***/ },
/* 139 */,
/* 140 */
/***/ function(module, exports, __webpack_require__) {

  // false -> Array#indexOf
  // true  -> Array#includes
  var toIObject = __webpack_require__(23)
    , toLength  = __webpack_require__(16)
    , toIndex   = __webpack_require__(54);
  module.exports = function(IS_INCLUDES){
    return function($this, el, fromIndex){
      var O      = toIObject($this)
        , length = toLength(O.length)
        , index  = toIndex(fromIndex, length)
        , value;
      // Array#includes uses SameValueZero equality algorithm
      if(IS_INCLUDES && el != el)while(length > index){
        value = O[index++];
        if(value != value)return true;
      // Array#toIndex ignores holes, Array#includes - not
      } else for(;length > index; index++)if(IS_INCLUDES || index in O){
        if(O[index] === el)return IS_INCLUDES || index;
      } return !IS_INCLUDES && -1;
    };
  };

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var $            = __webpack_require__(3)
    , hide         = __webpack_require__(27)
    , redefineAll  = __webpack_require__(70)
    , ctx          = __webpack_require__(25)
    , strictNew    = __webpack_require__(72)
    , defined      = __webpack_require__(26)
    , forOf        = __webpack_require__(51)
    , $iterDefine  = __webpack_require__(95)
    , step         = __webpack_require__(153)
    , ID           = __webpack_require__(45)('id')
    , $has         = __webpack_require__(15)
    , isObject     = __webpack_require__(6)
    , setSpecies   = __webpack_require__(71)
    , DESCRIPTORS  = __webpack_require__(20)
    , isExtensible = Object.isExtensible || isObject
    , SIZE         = DESCRIPTORS ? '_s' : 'size'
    , id           = 0;
  
  var fastKey = function(it, create){
    // return primitive with prefix
    if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if(!$has(it, ID)){
      // can't set id to frozen object
      if(!isExtensible(it))return 'F';
      // not necessary to add id
      if(!create)return 'E';
      // add missing object id
      hide(it, ID, ++id);
    // return object id with prefix
    } return 'O' + it[ID];
  };
  
  var getEntry = function(that, key){
    // fast case
    var index = fastKey(key), entry;
    if(index !== 'F')return that._i[index];
    // frozen object case
    for(entry = that._f; entry; entry = entry.n){
      if(entry.k == key)return entry;
    }
  };
  
  module.exports = {
    getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
      var C = wrapper(function(that, iterable){
        strictNew(that, C, NAME);
        that._i = $.create(null); // index
        that._f = undefined;      // first entry
        that._l = undefined;      // last entry
        that[SIZE] = 0;           // size
        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
      });
      redefineAll(C.prototype, {
        // 23.1.3.1 Map.prototype.clear()
        // 23.2.3.2 Set.prototype.clear()
        clear: function clear(){
          for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
            entry.r = true;
            if(entry.p)entry.p = entry.p.n = undefined;
            delete data[entry.i];
          }
          that._f = that._l = undefined;
          that[SIZE] = 0;
        },
        // 23.1.3.3 Map.prototype.delete(key)
        // 23.2.3.4 Set.prototype.delete(value)
        'delete': function(key){
          var that  = this
            , entry = getEntry(that, key);
          if(entry){
            var next = entry.n
              , prev = entry.p;
            delete that._i[entry.i];
            entry.r = true;
            if(prev)prev.n = next;
            if(next)next.p = prev;
            if(that._f == entry)that._f = next;
            if(that._l == entry)that._l = prev;
            that[SIZE]--;
          } return !!entry;
        },
        // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
        // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
        forEach: function forEach(callbackfn /*, that = undefined */){
          var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
            , entry;
          while(entry = entry ? entry.n : this._f){
            f(entry.v, entry.k, this);
            // revert to the last existing entry
            while(entry && entry.r)entry = entry.p;
          }
        },
        // 23.1.3.7 Map.prototype.has(key)
        // 23.2.3.7 Set.prototype.has(value)
        has: function has(key){
          return !!getEntry(this, key);
        }
      });
      if(DESCRIPTORS)$.setDesc(C.prototype, 'size', {
        get: function(){
          return defined(this[SIZE]);
        }
      });
      return C;
    },
    def: function(that, key, value){
      var entry = getEntry(that, key)
        , prev, index;
      // change existing entry
      if(entry){
        entry.v = value;
      // create new entry
      } else {
        that._l = entry = {
          i: index = fastKey(key, true), // <- index
          k: key,                        // <- key
          v: value,                      // <- value
          p: prev = that._l,             // <- previous entry
          n: undefined,                  // <- next entry
          r: false                       // <- removed
        };
        if(!that._f)that._f = entry;
        if(prev)prev.n = entry;
        that[SIZE]++;
        // add to index
        if(index !== 'F')that._i[index] = entry;
      } return that;
    },
    getEntry: getEntry,
    setStrong: function(C, NAME, IS_MAP){
      // add .keys, .values, .entries, [@@iterator]
      // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
      $iterDefine(C, NAME, function(iterated, kind){
        this._t = iterated;  // target
        this._k = kind;      // kind
        this._l = undefined; // previous
      }, function(){
        var that  = this
          , kind  = that._k
          , entry = that._l;
        // revert to the last existing entry
        while(entry && entry.r)entry = entry.p;
        // get next entry
        if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
          // or finish the iteration
          that._t = undefined;
          return step(1);
        }
        // return step by kind
        if(kind == 'keys'  )return step(0, entry.k);
        if(kind == 'values')return step(0, entry.v);
        return step(0, [entry.k, entry.v]);
      }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
  
      // add [@@species], 23.1.2.2, 23.2.2.2
      setSpecies(NAME);
    }
  };

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

  // https://github.com/DavidBruant/Map-Set.prototype.toJSON
  var forOf   = __webpack_require__(51)
    , classof = __webpack_require__(65);
  module.exports = function(NAME){
    return function toJSON(){
      if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
      var arr = [];
      forOf(this, false, arr.push, arr);
      return arr;
    };
  };

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var hide              = __webpack_require__(27)
    , redefineAll       = __webpack_require__(70)
    , anObject          = __webpack_require__(7)
    , isObject          = __webpack_require__(6)
    , strictNew         = __webpack_require__(72)
    , forOf             = __webpack_require__(51)
    , createArrayMethod = __webpack_require__(64)
    , $has              = __webpack_require__(15)
    , WEAK              = __webpack_require__(45)('weak')
    , isExtensible      = Object.isExtensible || isObject
    , arrayFind         = createArrayMethod(5)
    , arrayFindIndex    = createArrayMethod(6)
    , id                = 0;
  
  // fallback for frozen keys
  var frozenStore = function(that){
    return that._l || (that._l = new FrozenStore);
  };
  var FrozenStore = function(){
    this.a = [];
  };
  var findFrozen = function(store, key){
    return arrayFind(store.a, function(it){
      return it[0] === key;
    });
  };
  FrozenStore.prototype = {
    get: function(key){
      var entry = findFrozen(this, key);
      if(entry)return entry[1];
    },
    has: function(key){
      return !!findFrozen(this, key);
    },
    set: function(key, value){
      var entry = findFrozen(this, key);
      if(entry)entry[1] = value;
      else this.a.push([key, value]);
    },
    'delete': function(key){
      var index = arrayFindIndex(this.a, function(it){
        return it[0] === key;
      });
      if(~index)this.a.splice(index, 1);
      return !!~index;
    }
  };
  
  module.exports = {
    getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
      var C = wrapper(function(that, iterable){
        strictNew(that, C, NAME);
        that._i = id++;      // collection id
        that._l = undefined; // leak store for frozen objects
        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
      });
      redefineAll(C.prototype, {
        // 23.3.3.2 WeakMap.prototype.delete(key)
        // 23.4.3.3 WeakSet.prototype.delete(value)
        'delete': function(key){
          if(!isObject(key))return false;
          if(!isExtensible(key))return frozenStore(this)['delete'](key);
          return $has(key, WEAK) && $has(key[WEAK], this._i) && delete key[WEAK][this._i];
        },
        // 23.3.3.4 WeakMap.prototype.has(key)
        // 23.4.3.4 WeakSet.prototype.has(value)
        has: function has(key){
          if(!isObject(key))return false;
          if(!isExtensible(key))return frozenStore(this).has(key);
          return $has(key, WEAK) && $has(key[WEAK], this._i);
        }
      });
      return C;
    },
    def: function(that, key, value){
      if(!isExtensible(anObject(key))){
        frozenStore(that).set(key, value);
      } else {
        $has(key, WEAK) || hide(key, WEAK, {});
        key[WEAK][that._i] = value;
      } return that;
    },
    frozenStore: frozenStore,
    WEAK: WEAK
  };

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

  var isObject = __webpack_require__(6)
    , document = __webpack_require__(10).document
    // in old IE typeof document.createElement is 'object'
    , is = isObject(document) && isObject(document.createElement);
  module.exports = function(it){
    return is ? document.createElement(it) : {};
  };

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  // 21.2.5.3 get RegExp.prototype.flags
  var anObject = __webpack_require__(7);
  module.exports = function(){
    var that   = anObject(this)
      , result = '';
    if(that.global)     result += 'g';
    if(that.ignoreCase) result += 'i';
    if(that.multiline)  result += 'm';
    if(that.unicode)    result += 'u';
    if(that.sticky)     result += 'y';
    return result;
  };

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

  // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
  var toIObject = __webpack_require__(23)
    , getNames  = __webpack_require__(3).getNames
    , toString  = {}.toString;
  
  var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
    ? Object.getOwnPropertyNames(window) : [];
  
  var getWindowNames = function(it){
    try {
      return getNames(it);
    } catch(e){
      return windowNames.slice();
    }
  };
  
  module.exports.get = function getOwnPropertyNames(it){
    if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
    return getNames(toIObject(it));
  };

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

  module.exports = __webpack_require__(10).document && document.documentElement;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

  // check on default Array iterator
  var Iterators  = __webpack_require__(52)
    , ITERATOR   = __webpack_require__(8)('iterator')
    , ArrayProto = Array.prototype;
  
  module.exports = function(it){
    return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
  };

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

  // 20.1.2.3 Number.isInteger(number)
  var isObject = __webpack_require__(6)
    , floor    = Math.floor;
  module.exports = function isInteger(it){
    return !isObject(it) && isFinite(it) && floor(it) === it;
  };

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

  // 7.2.8 IsRegExp(argument)
  var isObject = __webpack_require__(6)
    , cof      = __webpack_require__(30)
    , MATCH    = __webpack_require__(8)('match');
  module.exports = function(it){
    var isRegExp;
    return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
  };

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

  // call something on iterator step with safe closing on error
  var anObject = __webpack_require__(7);
  module.exports = function(iterator, fn, value, entries){
    try {
      return entries ? fn(anObject(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch(e){
      var ret = iterator['return'];
      if(ret !== undefined)anObject(ret.call(iterator));
      throw e;
    }
  };

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var $              = __webpack_require__(3)
    , descriptor     = __webpack_require__(36)
    , setToStringTag = __webpack_require__(53)
    , IteratorPrototype = {};
  
  // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
  __webpack_require__(27)(IteratorPrototype, __webpack_require__(8)('iterator'), function(){ return this; });
  
  module.exports = function(Constructor, NAME, next){
    Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
    setToStringTag(Constructor, NAME + ' Iterator');
  };

/***/ },
/* 153 */
/***/ function(module, exports) {

  module.exports = function(done, value){
    return {value: value, done: !!done};
  };

/***/ },
/* 154 */
/***/ function(module, exports) {

  // 20.2.2.20 Math.log1p(x)
  module.exports = Math.log1p || function log1p(x){
    return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
  };

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

  var $         = __webpack_require__(3)
    , toIObject = __webpack_require__(23)
    , isEnum    = $.isEnum;
  module.exports = function(isEntries){
    return function(it){
      var O      = toIObject(it)
        , keys   = $.getKeys(O)
        , length = keys.length
        , i      = 0
        , result = []
        , key;
      while(length > i)if(isEnum.call(O, key = keys[i++])){
        result.push(isEntries ? [key, O[key]] : O[key]);
      } return result;
    };
  };

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

  // all object keys, includes non-enumerable and symbols
  var $        = __webpack_require__(3)
    , anObject = __webpack_require__(7)
    , Reflect  = __webpack_require__(10).Reflect;
  module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
    var keys       = $.getNames(anObject(it))
      , getSymbols = $.getSymbols;
    return getSymbols ? keys.concat(getSymbols(it)) : keys;
  };

/***/ },
/* 157 */
/***/ function(module, exports) {

  // 7.2.9 SameValue(x, y)
  module.exports = Object.is || function is(x, y){
    return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
  };

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

  var global = __webpack_require__(10)
    , SHARED = '__core-js_shared__'
    , store  = global[SHARED] || (global[SHARED] = {});
  module.exports = function(key){
    return store[key] || (store[key] = {});
  };

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

  // https://github.com/ljharb/proposal-string-pad-left-right
  var toLength = __webpack_require__(16)
    , repeat   = __webpack_require__(160)
    , defined  = __webpack_require__(26);
  
  module.exports = function(that, maxLength, fillString, left){
    var S            = String(defined(that))
      , stringLength = S.length
      , fillStr      = fillString === undefined ? ' ' : String(fillString)
      , intMaxLength = toLength(maxLength);
    if(intMaxLength <= stringLength)return S;
    if(fillStr == '')fillStr = ' ';
    var fillLen = intMaxLength - stringLength
      , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
    if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
    return left ? stringFiller + S : S + stringFiller;
  };

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var toInteger = __webpack_require__(55)
    , defined   = __webpack_require__(26);
  
  module.exports = function repeat(count){
    var str = String(defined(this))
      , res = ''
      , n   = toInteger(count);
    if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
    for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
    return res;
  };

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

  var ctx                = __webpack_require__(25)
    , invoke             = __webpack_require__(68)
    , html               = __webpack_require__(147)
    , cel                = __webpack_require__(144)
    , global             = __webpack_require__(10)
    , process            = global.process
    , setTask            = global.setImmediate
    , clearTask          = global.clearImmediate
    , MessageChannel     = global.MessageChannel
    , counter            = 0
    , queue              = {}
    , ONREADYSTATECHANGE = 'onreadystatechange'
    , defer, channel, port;
  var run = function(){
    var id = +this;
    if(queue.hasOwnProperty(id)){
      var fn = queue[id];
      delete queue[id];
      fn();
    }
  };
  var listner = function(event){
    run.call(event.data);
  };
  // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
  if(!setTask || !clearTask){
    setTask = function setImmediate(fn){
      var args = [], i = 1;
      while(arguments.length > i)args.push(arguments[i++]);
      queue[++counter] = function(){
        invoke(typeof fn == 'function' ? fn : Function(fn), args);
      };
      defer(counter);
      return counter;
    };
    clearTask = function clearImmediate(id){
      delete queue[id];
    };
    // Node.js 0.8-
    if(__webpack_require__(30)(process) == 'process'){
      defer = function(id){
        process.nextTick(ctx(run, id, 1));
      };
    // Browsers with MessageChannel, includes WebWorkers
    } else if(MessageChannel){
      channel = new MessageChannel;
      port    = channel.port2;
      channel.port1.onmessage = listner;
      defer = ctx(port.postMessage, port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
      defer = function(id){
        global.postMessage(id + '', '*');
      };
      global.addEventListener('message', listner, false);
    // IE8-
    } else if(ONREADYSTATECHANGE in cel('script')){
      defer = function(id){
        html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
          html.removeChild(this);
          run.call(id);
        };
      };
    // Rest old browsers
    } else {
      defer = function(id){
        setTimeout(ctx(run, id, 1), 0);
      };
    }
  }
  module.exports = {
    set:   setTask,
    clear: clearTask
  };

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

  var classof   = __webpack_require__(65)
    , ITERATOR  = __webpack_require__(8)('iterator')
    , Iterators = __webpack_require__(52);
  module.exports = __webpack_require__(31).getIteratorMethod = function(it){
    if(it != undefined)return it[ITERATOR]
      || it['@@iterator']
      || Iterators[classof(it)];
  };

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var addToUnscopables = __webpack_require__(44)
    , step             = __webpack_require__(153)
    , Iterators        = __webpack_require__(52)
    , toIObject        = __webpack_require__(23);
  
  // 22.1.3.4 Array.prototype.entries()
  // 22.1.3.13 Array.prototype.keys()
  // 22.1.3.29 Array.prototype.values()
  // 22.1.3.30 Array.prototype[@@iterator]()
  module.exports = __webpack_require__(95)(Array, 'Array', function(iterated, kind){
    this._t = toIObject(iterated); // target
    this._i = 0;                   // next index
    this._k = kind;                // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
  }, function(){
    var O     = this._t
      , kind  = this._k
      , index = this._i++;
    if(!O || index >= O.length){
      this._t = undefined;
      return step(1);
    }
    if(kind == 'keys'  )return step(0, index);
    if(kind == 'values')return step(0, O[index]);
    return step(0, [index, O[index]]);
  }, 'values');
  
  // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
  Iterators.Arguments = Iterators.Array;
  
  addToUnscopables('keys');
  addToUnscopables('values');
  addToUnscopables('entries');

/***/ },
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ function(module, exports, __webpack_require__) {

  var stackClear = __webpack_require__(466),
      stackDelete = __webpack_require__(467),
      stackGet = __webpack_require__(468),
      stackHas = __webpack_require__(469),
      stackSet = __webpack_require__(470);
  
  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [values] The values to cache.
   */
  function Stack(values) {
    var index = -1,
        length = values ? values.length : 0;
  
    this.clear();
    while (++index < length) {
      var entry = values[index];
      this.set(entry[0], entry[1]);
    }
  }
  
  // Add functions to the `Stack` cache.
  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  
  module.exports = Stack;


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

  var root = __webpack_require__(37);
  
  /** Built-in value references. */
  var Symbol = root.Symbol;
  
  module.exports = Symbol;


/***/ },
/* 174 */
/***/ function(module, exports) {

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array.length;
  
    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }
  
  module.exports = arrayEach;


/***/ },
/* 175 */
/***/ function(module, exports) {

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array.length;
  
    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }
  
  module.exports = arrayReduce;


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

  var eq = __webpack_require__(79);
  
  /**
   * This function is like `assignValue` except that it doesn't assign `undefined` values.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function assignMergeValue(object, key, value) {
    if ((value !== undefined && !eq(object[key], value)) ||
        (typeof key == 'number' && value === undefined && !(key in object))) {
      object[key] = value;
    }
  }
  
  module.exports = assignMergeValue;


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

  var eq = __webpack_require__(79);
  
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  
  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;
  
  /**
   * Assigns `value` to `key` of `object` if the existing value is not equivalent
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
   * for equality comparisons.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
        (value === undefined && !(key in object))) {
      object[key] = value;
    }
  }
  
  module.exports = assignValue;


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

  var assocIndexOf = __webpack_require__(75);
  
  /** Used for built-in method references. */
  var arrayProto = Array.prototype;
  
  /** Built-in value references. */
  var splice = arrayProto.splice;
  
  /**
   * Removes `key` and its value from the associative array.
   *
   * @private
   * @param {Array} array The array to query.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function assocDelete(array, key) {
    var index = assocIndexOf(array, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = array.length - 1;
    if (index == lastIndex) {
      array.pop();
    } else {
      splice.call(array, index, 1);
    }
    return true;
  }
  
  module.exports = assocDelete;


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

  var assocIndexOf = __webpack_require__(75);
  
  /**
   * Gets the associative array value for `key`.
   *
   * @private
   * @param {Array} array The array to query.
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function assocGet(array, key) {
    var index = assocIndexOf(array, key);
    return index < 0 ? undefined : array[index][1];
  }
  
  module.exports = assocGet;


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

  var assocIndexOf = __webpack_require__(75);
  
  /**
   * Checks if an associative array value for `key` exists.
   *
   * @private
   * @param {Array} array The array to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function assocHas(array, key) {
    return assocIndexOf(array, key) > -1;
  }
  
  module.exports = assocHas;


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

  var assocIndexOf = __webpack_require__(75);
  
  /**
   * Sets the associative array `key` to `value`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   */
  function assocSet(array, key, value) {
    var index = assocIndexOf(array, key);
    if (index < 0) {
      array.push([key, value]);
    } else {
      array[index][1] = value;
    }
  }
  
  module.exports = assocSet;


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

  var Uint8Array = __webpack_require__(419);
  
  /**
   * Creates a clone of `arrayBuffer`.
   *
   * @private
   * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
   * @returns {ArrayBuffer} Returns the cloned array buffer.
   */
  function cloneArrayBuffer(arrayBuffer) {
    var Ctor = arrayBuffer.constructor,
        result = new Ctor(arrayBuffer.byteLength),
        view = new Uint8Array(result);
  
    view.set(new Uint8Array(arrayBuffer));
    return result;
  }
  
  module.exports = cloneArrayBuffer;


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

  var Map = __webpack_require__(46),
      Set = __webpack_require__(418),
      WeakMap = __webpack_require__(420);
  
  /** `Object#toString` result references. */
  var mapTag = '[object Map]',
      objectTag = '[object Object]',
      setTag = '[object Set]',
      weakMapTag = '[object WeakMap]';
  
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  
  /** Used to resolve the decompiled source of functions. */
  var funcToString = Function.prototype.toString;
  
  /**
   * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
   * of values.
   */
  var objectToString = objectProto.toString;
  
  /** Used to detect maps, sets, and weakmaps. */
  var mapCtorString = Map ? funcToString.call(Map) : '',
      setCtorString = Set ? funcToString.call(Set) : '',
      weakMapCtorString = WeakMap ? funcToString.call(WeakMap) : '';
  
  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function getTag(value) {
    return objectToString.call(value);
  }
  
  // Fallback for IE 11 providing `toStringTag` values for maps, sets, and weakmaps.
  if ((Map && getTag(new Map) != mapTag) ||
      (Set && getTag(new Set) != setTag) ||
      (WeakMap && getTag(new WeakMap) != weakMapTag)) {
    getTag = function(value) {
      var result = objectToString.call(value),
          Ctor = result == objectTag ? value.constructor : null,
          ctorString = typeof Ctor == 'function' ? funcToString.call(Ctor) : '';
  
      if (ctorString) {
        switch (ctorString) {
          case mapCtorString: return mapTag;
          case setCtorString: return setTag;
          case weakMapCtorString: return weakMapTag;
        }
      }
      return result;
    };
  }
  
  module.exports = getTag;


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

  var nativeCreate = __webpack_require__(78);
  
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  
  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;
  
  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @param {Object} hash The hash to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function hashHas(hash, key) {
    return nativeCreate ? hash[key] !== undefined : hasOwnProperty.call(hash, key);
  }
  
  module.exports = hashHas;


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

  var baseTimes = __webpack_require__(439),
      isArguments = __webpack_require__(190),
      isArray = __webpack_require__(57),
      isLength = __webpack_require__(108),
      isString = __webpack_require__(192);
  
  /**
   * Creates an array of index keys for `object` values of arrays,
   * `arguments` objects, and strings, otherwise `null` is returned.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array|null} Returns index keys, else `null`.
   */
  function indexKeys(object) {
    var length = object ? object.length : undefined;
    if (isLength(length) &&
        (isArray(object) || isString(object) || isArguments(object))) {
      return baseTimes(length, String);
    }
    return null;
  }
  
  module.exports = indexKeys;


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

  var eq = __webpack_require__(79),
      isArrayLike = __webpack_require__(81),
      isIndex = __webpack_require__(106),
      isObject = __webpack_require__(38);
  
  /**
   * Checks if the given arguments are from an iteratee call.
   *
   * @private
   * @param {*} value The potential iteratee value argument.
   * @param {*} index The potential iteratee index or key argument.
   * @param {*} object The potential iteratee object argument.
   * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
   */
  function isIterateeCall(value, index, object) {
    if (!isObject(object)) {
      return false;
    }
    var type = typeof index;
    if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)) {
      return eq(object[index], value);
    }
    return false;
  }
  
  module.exports = isIterateeCall;


/***/ },
/* 187 */
/***/ function(module, exports) {

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];
  
    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }
  
  module.exports = iteratorToArray;


/***/ },
/* 188 */
/***/ function(module, exports) {

  /**
   * Converts `map` to an array.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the converted array.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);
  
    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }
  
  module.exports = mapToArray;


/***/ },
/* 189 */
/***/ function(module, exports) {

  /**
   * Converts `set` to an array.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the converted array.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);
  
    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }
  
  module.exports = setToArray;


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

  var isArrayLikeObject = __webpack_require__(191);
  
  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]';
  
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  
  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;
  
  /**
   * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
   * of values.
   */
  var objectToString = objectProto.toString;
  
  /** Built-in value references. */
  var propertyIsEnumerable = objectProto.propertyIsEnumerable;
  
  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  function isArguments(value) {
    // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
      (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
  }
  
  module.exports = isArguments;


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

  var isArrayLike = __webpack_require__(81),
      isObjectLike = __webpack_require__(58);
  
  /**
   * This method is like `_.isArrayLike` except that it also checks if `value`
   * is an object.
   *
   * @static
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array-like object, else `false`.
   * @example
   *
   * _.isArrayLikeObject([1, 2, 3]);
   * // => true
   *
   * _.isArrayLikeObject(document.body.children);
   * // => true
   *
   * _.isArrayLikeObject('abc');
   * // => false
   *
   * _.isArrayLikeObject(_.noop);
   * // => false
   */
  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }
  
  module.exports = isArrayLikeObject;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

  var isArray = __webpack_require__(57),
      isObjectLike = __webpack_require__(58);
  
  /** `Object#toString` result references. */
  var stringTag = '[object String]';
  
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  
  /**
   * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
   * of values.
   */
  var objectToString = objectProto.toString;
  
  /**
   * Checks if `value` is classified as a `String` primitive or object.
   *
   * @static
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   * @example
   *
   * _.isString('abc');
   * // => true
   *
   * _.isString(1);
   * // => false
   */
  function isString(value) {
    return typeof value == 'string' ||
      (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
  }
  
  module.exports = isString;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

  var isLength = __webpack_require__(108),
      isObjectLike = __webpack_require__(58);
  
  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';
  
  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';
  
  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  
  /**
   * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
   * of values.
   */
  var objectToString = objectProto.toString;
  
  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */
  function isTypedArray(value) {
    return isObjectLike(value) &&
      isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
  }
  
  module.exports = isTypedArray;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

  var baseKeysIn = __webpack_require__(433),
      indexKeys = __webpack_require__(185),
      isIndex = __webpack_require__(106),
      isPrototype = __webpack_require__(107);
  
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  
  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;
  
  /**
   * Creates an array of the own and inherited enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keysIn(new Foo);
   * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
   */
  function keysIn(object) {
    var index = -1,
        isProto = isPrototype(object),
        props = baseKeysIn(object),
        propsLength = props.length,
        indexes = indexKeys(object),
        skipIndexes = !!indexes,
        result = indexes || [],
        length = result.length;
  
    while (++index < propsLength) {
      var key = props[index];
      if (!(skipIndexes && (key == 'length' || isIndex(key, length))) &&
          !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
        result.push(key);
      }
    }
    return result;
  }
  
  module.exports = keysIn;


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

  var baseMerge = __webpack_require__(434),
      createAssigner = __webpack_require__(450);
  
  /**
   * Recursively merges own and inherited enumerable properties of source objects
   * into the destination object. Source properties that resolve to `undefined`
   * are skipped if a destination value exists. Array and plain object properties
   * are merged recursively. Other objects and value types are overridden by
   * assignment. Source objects are applied from left to right. Subsequent
   * sources overwrite property assignments of previous sources.
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} [sources] The source objects.
   * @returns {Object} Returns `object`.
   * @example
   *
   * var users = {
   *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
   * };
   *
   * var ages = {
   *   'data': [{ 'age': 36 }, { 'age': 40 }]
   * };
   *
   * _.merge(users, ages);
   * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
   */
  var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
  });
  
  module.exports = merge;


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

  var toNumber = __webpack_require__(197);
  
  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_INTEGER = 1.7976931348623157e+308;
  
  /**
   * Converts `value` to an integer.
   *
   * **Note:** This function is loosely based on [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
   *
   * @static
   * @memberOf _
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {number} Returns the converted integer.
   * @example
   *
   * _.toInteger(3);
   * // => 3
   *
   * _.toInteger(Number.MIN_VALUE);
   * // => 0
   *
   * _.toInteger(Infinity);
   * // => 1.7976931348623157e+308
   *
   * _.toInteger('3');
   * // => 3
   */
  function toInteger(value) {
    if (!value) {
      return value === 0 ? value : 0;
    }
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
      var sign = (value < 0 ? -1 : 1);
      return sign * MAX_INTEGER;
    }
    var remainder = value % 1;
    return value === value ? (remainder ? value - remainder : value) : 0;
  }
  
  module.exports = toInteger;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

  var isFunction = __webpack_require__(47),
      isObject = __webpack_require__(38);
  
  /** Used as references for various `Number` constants. */
  var NAN = 0 / 0;
  
  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g;
  
  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
  
  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;
  
  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;
  
  /** Built-in method references without a dependency on `root`. */
  var freeParseInt = parseInt;
  
  /**
   * Converts `value` to a number.
   *
   * @static
   * @memberOf _
   * @category Lang
   * @param {*} value The value to process.
   * @returns {number} Returns the number.
   * @example
   *
   * _.toNumber(3);
   * // => 3
   *
   * _.toNumber(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toNumber(Infinity);
   * // => Infinity
   *
   * _.toNumber('3');
   * // => 3
   */
  function toNumber(value) {
    if (isObject(value)) {
      var other = isFunction(value.valueOf) ? value.valueOf() : value;
      value = isObject(other) ? (other + '') : other;
    }
    if (typeof value != 'string') {
      return value === 0 ? value : +value;
    }
    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return (isBinary || reIsOctal.test(value))
      ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
      : (reIsBadHex.test(value) ? NAN : +value);
  }
  
  module.exports = toNumber;


/***/ },
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ function(module, exports, __webpack_require__) {

  /**
   * This is a straight rip-off of the React.js ReactPropTypes.js proptype validators,
   * modified to make it possible to validate Immutable.js data.
   *     ImmutableTypes.listOf is patterned after React.PropTypes.arrayOf, but for Immutable.List
   *     ImmutableTypes.shape  is based on React.PropTypes.shape, but for any Immutable.Iterable
   */
  "use strict";
  
  var Immutable = __webpack_require__(34);
  
  var ANONYMOUS = "<<anonymous>>";
  
  var ImmutablePropTypes = {
    listOf: createListOfTypeChecker,
    mapOf: createMapOfTypeChecker,
    orderedMapOf: createOrderedMapOfTypeChecker,
    setOf: createSetOfTypeChecker,
    orderedSetOf: createOrderedSetOfTypeChecker,
    stackOf: createStackOfTypeChecker,
    iterableOf: createIterableOfTypeChecker,
    recordOf: createRecordOfTypeChecker,
    shape: createShapeChecker,
    contains: createShapeChecker,
    mapContains: createMapContainsChecker,
    // Primitive Types
    list: createImmutableTypeChecker("List", Immutable.List.isList),
    map: createImmutableTypeChecker("Map", Immutable.Map.isMap),
    orderedMap: createImmutableTypeChecker("OrderedMap", Immutable.OrderedMap.isOrderedMap),
    set: createImmutableTypeChecker("Set", Immutable.Set.isSet),
    orderedSet: createImmutableTypeChecker("OrderedSet", Immutable.OrderedSet.isOrderedSet),
    stack: createImmutableTypeChecker("Stack", Immutable.Stack.isStack),
    seq: createImmutableTypeChecker("Seq", Immutable.Seq.isSeq),
    record: createImmutableTypeChecker("Record", function (isRecord) {
      return isRecord instanceof Immutable.Record;
    }),
    iterable: createImmutableTypeChecker("Iterable", Immutable.Iterable.isIterable)
  };
  
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return "array";
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return "object";
    }
    if (propValue instanceof Immutable.Iterable) {
      return "Immutable." + propValue.toSource().split(" ")[0];
    }
    return propType;
  }
  
  function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location) {
      componentName = componentName || ANONYMOUS;
      if (props[propName] == null) {
        var locationName = location;
        if (isRequired) {
          return new Error("Required " + locationName + " `" + propName + "` was not specified in " + ("`" + componentName + "`."));
        }
      } else {
        return validate(props, propName, componentName, location);
      }
    }
  
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
  
    return chainedCheckType;
  }
  
  function createImmutableTypeChecker(immutableClassName, immutableClassTypeValidator) {
    function validate(props, propName, componentName, location) {
      var propValue = props[propName];
      if (!immutableClassTypeValidator(propValue)) {
        var propType = getPropType(propValue);
        return new Error("Invalid " + location + " `" + propName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `" + immutableClassName + "`."));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  
  function createIterableTypeChecker(typeChecker, immutableClassName, immutableClassTypeValidator) {
  
    function validate(props, propName, componentName, location) {
      var propValue = props[propName];
      if (!immutableClassTypeValidator(propValue)) {
        var locationName = location;
        var propType = getPropType(propValue);
        return new Error("Invalid " + locationName + " `" + propName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
      }
  
      if (typeof typeChecker !== "function") {
        return new Error("Invalid typeChecker supplied to `" + componentName + "` " + ("for propType `" + propName + "`, expected a function."));
      }
  
      var propValues = propValue.toArray();
      for (var i = 0, len = propValues.length; i < len; i++) {
        var error = typeChecker(propValues, i, componentName, location);
        if (error instanceof Error) {
          return error;
        }
      }
    }
    return createChainableTypeChecker(validate);
  }
  
  function createListOfTypeChecker(typeChecker) {
    return createIterableTypeChecker(typeChecker, "List", Immutable.List.isList);
  }
  
  function createMapOfTypeChecker(typeChecker) {
    return createIterableTypeChecker(typeChecker, "Map", Immutable.Map.isMap);
  }
  
  function createOrderedMapOfTypeChecker(typeChecker) {
    return createIterableTypeChecker(typeChecker, "OrderedMap", Immutable.OrderedMap.isOrderedMap);
  }
  
  function createSetOfTypeChecker(typeChecker) {
    return createIterableTypeChecker(typeChecker, "Set", Immutable.Set.isSet);
  }
  
  function createOrderedSetOfTypeChecker(typeChecker) {
    return createIterableTypeChecker(typeChecker, "OrderedSet", Immutable.OrderedSet.isOrderedSet);
  }
  
  function createStackOfTypeChecker(typeChecker) {
    return createIterableTypeChecker(typeChecker, "Stack", Immutable.Stack.isStack);
  }
  
  function createIterableOfTypeChecker(typeChecker) {
    return createIterableTypeChecker(typeChecker, "Iterable", Immutable.Iterable.isIterable);
  }
  
  function createRecordOfTypeChecker(recordKeys) {
    function validate(props, propName, componentName, location) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (!(propValue instanceof Immutable.Record)) {
        var locationName = location;
        return new Error("Invalid " + locationName + " `" + propName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js Record."));
      }
      for (var key in recordKeys) {
        var checker = recordKeys[key];
        if (!checker) {
          continue;
        }
        var mutablePropValue = propValue.toObject();
        var error = checker(mutablePropValue, key, componentName, location);
        if (error) {
          return error;
        }
      }
    }
    return createChainableTypeChecker(validate);
  }
  
  // there is some irony in the fact that shapeTypes is a standard hash and not an immutable collection
  function createShapeTypeChecker(shapeTypes) {
    var immutableClassName = arguments[1] === undefined ? "Iterable" : arguments[1];
    var immutableClassTypeValidator = arguments[2] === undefined ? Immutable.Iterable.isIterable : arguments[2];
  
    function validate(props, propName, componentName, location) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (!immutableClassTypeValidator(propValue)) {
        var locationName = location;
        return new Error("Invalid " + locationName + " `" + propName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
      }
      var mutablePropValue = propValue.toObject();
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(mutablePropValue, key, componentName, location);
        if (error) {
          return error;
        }
      }
    }
    return createChainableTypeChecker(validate);
  }
  
  function createShapeChecker(shapeTypes) {
    return createShapeTypeChecker(shapeTypes);
  }
  
  function createMapContainsChecker(shapeTypes) {
    return createShapeTypeChecker(shapeTypes, "Map", Immutable.Map.isMap);
  }
  
  module.exports = ImmutablePropTypes;

/***/ },
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ function(module, exports) {

  module.exports = function(module) {
  	if(!module.webpackPolyfill) {
  		module.deprecate = function() {};
  		module.paths = [];
  		// module.parent = undefined by default
  		module.children = [];
  		module.webpackPolyfill = 1;
  	}
  	return module;
  }


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Grid = Grid;
  
  var _react = __webpack_require__(9);
  
  var _react2 = _interopRequireDefault(_react);
  
  var _Grid = __webpack_require__(390);
  
  var _Grid2 = _interopRequireDefault(_Grid);
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  
  function Grid() {
    return _react2.default.createElement(
      'div',
      { className: _Grid2.default.Grid },
      _react2.default.createElement(
        'div',
        { className: _Grid2.default.row },
        _react2.default.createElement('div', { className: _Grid2.default.cell }),
        _react2.default.createElement('div', { className: _Grid2.default.cell }),
        _react2.default.createElement('div', { className: _Grid2.default.cell }),
        _react2.default.createElement('div', { className: _Grid2.default.cell })
      ),
      _react2.default.createElement(
        'div',
        { className: _Grid2.default.row },
        _react2.default.createElement('div', { className: _Grid2.default.cell }),
        _react2.default.createElement('div', { className: _Grid2.default.cell }),
        _react2.default.createElement('div', { className: _Grid2.default.cell }),
        _react2.default.createElement('div', { className: _Grid2.default.cell })
      ),
      _react2.default.createElement(
        'div',
        { className: _Grid2.default.row },
        _react2.default.createElement('div', { className: _Grid2.default.cell }),
        _react2.default.createElement('div', { className: _Grid2.default.cell }),
        _react2.default.createElement('div', { className: _Grid2.default.cell }),
        _react2.default.createElement('div', { className: _Grid2.default.cell })
      ),
      _react2.default.createElement(
        'div',
        { className: _Grid2.default.row },
        _react2.default.createElement('div', { className: _Grid2.default.cell }),
        _react2.default.createElement('div', { className: _Grid2.default.cell }),
        _react2.default.createElement('div', { className: _Grid2.default.cell }),
        _react2.default.createElement('div', { className: _Grid2.default.cell })
      )
    );
  }

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Layout = Layout;
  exports.Title = Title;
  exports.Description = Description;
  
  var _react = __webpack_require__(9);
  
  var _react2 = _interopRequireDefault(_react);
  
  var _Game = __webpack_require__(246);
  
  var _Game2 = _interopRequireDefault(_Game);
  
  var _KeyboardControls = __webpack_require__(247);
  
  var _KeyboardControls2 = _interopRequireDefault(_KeyboardControls);
  
  var _Layout = __webpack_require__(391);
  
  var _Layout2 = _interopRequireDefault(_Layout);
  
  var _Score = __webpack_require__(249);
  
  var _Score2 = _interopRequireDefault(_Score);
  
  var _NewGameButton = __webpack_require__(136);
  
  var _NewGameButton2 = _interopRequireDefault(_NewGameButton);
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  
  function Layout() {
    return _react2.default.createElement(
      'div',
      { className: _Layout2.default.Layout },
      _react2.default.createElement(Title, null),
      _react2.default.createElement(Description, null),
      _react2.default.createElement(_Game2.default, null),
      _react2.default.createElement(_KeyboardControls2.default, null)
    );
  }
  
  function Title() {
    return _react2.default.createElement(
      'div',
      { className: _Layout2.default.Title },
      _react2.default.createElement(
        'h1',
        null,
        '2048'
      ),
      _react2.default.createElement(
        'div',
        { className: _Layout2.default.scores },
        _react2.default.createElement(
          _Score2.default,
          { name: 'score' },
          'Score'
        ),
        _react2.default.createElement(
          _Score2.default,
          { name: 'topScore' },
          'Top'
        )
      )
    );
  }
  
  function Description() {
    return _react2.default.createElement(
      'div',
      { className: _Layout2.default.Description },
      _react2.default.createElement(
        'p',
        null,
        'Join the tiles to get a ',
        _react2.default.createElement(
          'b',
          null,
          '2048 tile!'
        )
      ),
      _react2.default.createElement(
        _NewGameButton2.default,
        null,
        'New Game'
      )
    );
  }

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  
  var _merge = __webpack_require__(195);
  
  var _merge2 = _interopRequireDefault(_merge);
  
  exports.Tile = Tile;
  
  var _react = __webpack_require__(9);
  
  var _react2 = _interopRequireDefault(_react);
  
  var _reactMotion = __webpack_require__(203);
  
  var _classnames = __webpack_require__(139);
  
  var _classnames2 = _interopRequireDefault(_classnames);
  
  var _Tile = __webpack_require__(392);
  
  var _Tile2 = _interopRequireDefault(_Tile);
  
  var _constants = __webpack_require__(243);
  
  var _constants2 = __webpack_require__(42);
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  
  function Tile(_ref) {
    var tile = _ref.tile;
    var value = tile.value;
    var row = tile.row;
    var col = tile.col;
    var id = tile.id;
  
  
    var tileClass = (0, _classnames2.default)( // :off
    _Tile2.default.Tile, _Tile2.default['value-' + getValueText(value)]); // :on
  
    return _react2.default.createElement(
      _reactMotion.Motion,
      getMotionProps(row, col),
      function (style) {
        return renderTile(style, { tileClass: tileClass, value: value, id: id });
      }
    );
  }
  
  Tile.propTypes = {
    tile: _react.PropTypes.shape({
      value: _react.PropTypes.number.isRequired,
      row: _react.PropTypes.number.isRequired,
      col: _react.PropTypes.number.isRequired,
      id: _react.PropTypes.string.isRequired,
      isNew: _react.PropTypes.bool.isRequired
    })
  };
  
  function renderTile(style, _ref2) {
    var tileClass = _ref2.tileClass;
    var value = _ref2.value;
    var id = _ref2.id;
  
    var nextStyle = (0, _merge2.default)({}, style, { transform: 'scale(' + style.scale + ')' });
  
    return _react2.default.createElement(
      'div',
      {
        key: id,
        className: tileClass,
        style: nextStyle
      },
      _react2.default.createElement(
        'div',
        { className: _Tile2.default.inner },
        value
      )
    );
  }
  
  function getValueText(value) {
    return value <= _constants2.GAME_WON_TILE ? value : 'super';
  }
  
  function getMotionProps(row, col) {
    return { // :off
      defaultStyle: {
        left: _constants.CELL_SPACE * col,
        top: _constants.CELL_SPACE * row,
        scale: 0
      },
      style: {
        left: (0, _reactMotion.spring)(_constants.CELL_SPACE * col, _constants.tileSlideConfig),
        top: (0, _reactMotion.spring)(_constants.CELL_SPACE * row, _constants.tileSlideConfig),
        scale: (0, _reactMotion.spring)(1, _constants.tileNewConfig)
      }
    }; // :on
  }

/***/ },
/* 243 */
/***/ function(module, exports) {

  "use strict";
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var CELL_SPACE = exports.CELL_SPACE = 115 + 8;
  var tileSlideConfig = exports.tileSlideConfig = { stiffness: 210, damping: 18 };
  var tileNewConfig = exports.tileNewConfig = { stiffness: 210, damping: 15 };

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Tiles = Tiles;
  
  var _react = __webpack_require__(9);
  
  var _react2 = _interopRequireDefault(_react);
  
  var _reactImmutableProptypes = __webpack_require__(201);
  
  var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
  
  var _Tile = __webpack_require__(242);
  
  var _Tiles = __webpack_require__(393);
  
  var _Tiles2 = _interopRequireDefault(_Tiles);
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  
  function Tiles(_ref) {
    var tiles = _ref.tiles;
  
    return _react2.default.createElement(
      'div',
      { className: _Tiles2.default.Tiles },
      tiles.map(function (tile) {
        return _react2.default.createElement(_Tile.Tile, {
          tile: tile.toObject(),
          key: tile.get('id')
        });
      })
    );
  }
  
  Tiles.propTypes = {
    tiles: _reactImmutableProptypes2.default.setOf(_reactImmutableProptypes2.default.map).isRequired
  };

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.App = App;
  
  var _react = __webpack_require__(9);
  
  var _react2 = _interopRequireDefault(_react);
  
  var _reactRedux = __webpack_require__(39);
  
  var _reactDocumentTitle = __webpack_require__(199);
  
  var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
  
  var _config = __webpack_require__(135);
  
  var _Layout = __webpack_require__(241);
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  
  function App(_ref) {
    var store = _ref.store;
    var title = _ref.title;
  
    return _react2.default.createElement(
      _reactRedux.Provider,
      { store: store },
      _react2.default.createElement(
        _reactDocumentTitle2.default,
        { title: title || _config.titlePrefix },
        _react2.default.createElement(_Layout.Layout, null)
      )
    );
  }
  
  App.propTypes = { // :off
    store: _react.PropTypes.object.isRequired,
    title: _react.PropTypes.string
  }; // :on

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Game = Game;
  
  var _react = __webpack_require__(9);
  
  var _react2 = _interopRequireDefault(_react);
  
  var _reactImmutableProptypes = __webpack_require__(201);
  
  var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
  
  var _Grid = __webpack_require__(240);
  
  var _Tiles = __webpack_require__(244);
  
  var _Message = __webpack_require__(248);
  
  var _Message2 = _interopRequireDefault(_Message);
  
  var _reactRedux = __webpack_require__(39);
  
  var _Game = __webpack_require__(394);
  
  var _Game2 = _interopRequireDefault(_Game);
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  
  function Game(_ref) {
    var tiles = _ref.tiles;
  
    return _react2.default.createElement(
      'div',
      { className: _Game2.default.Game },
      _react2.default.createElement(_Grid.Grid, null),
      _react2.default.createElement(_Tiles.Tiles, { tiles: tiles }),
      _react2.default.createElement(_Message2.default, null)
    );
  }
  
  Game.propTypes = {
    tiles: _reactImmutableProptypes2.default.setOf(_reactImmutableProptypes2.default.map).isRequired
  };
  
  exports.default = (0, _reactRedux.connect)(mapStateToProps)(Game);
  
  
  function mapStateToProps(state) {
    return { // :off
      tiles: state.getIn(['game', 'state']).toTileSet(),
      isLoading: state.get('isLoading') }; // :on
  }

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.KeyboardControls = undefined;
  
  var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
  
  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
  
  var _react = __webpack_require__(9);
  
  var _react2 = _interopRequireDefault(_react);
  
  var _game = __webpack_require__(50);
  
  var actionCreators = _interopRequireWildcard(_game);
  
  var _redux = __webpack_require__(63);
  
  var _reactRedux = __webpack_require__(39);
  
  function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  
  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  
  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
  
  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
  
  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
  
  var KeyboardControls = exports.KeyboardControls = function (_Component) {
    _inherits(KeyboardControls, _Component);
  
    function KeyboardControls(props) {
      var _this$keymap;
  
      _classCallCheck(this, KeyboardControls);
  
      var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(KeyboardControls).call(this, props));
  
      _this.keymap = (_this$keymap = {}, _defineProperty(_this$keymap, 37, _this.props.handleShiftLeft), _defineProperty(_this$keymap, 38, _this.props.handleShiftUp), _defineProperty(_this$keymap, 39, _this.props.handleShiftRight), _defineProperty(_this$keymap, 40, _this.props.handleShiftDown), _this$keymap);
  
      _this.onKeyDown = _this.onKeyDown.bind(_this);
      return _this;
    }
  
    _createClass(KeyboardControls, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        document.addEventListener('keydown', this.onKeyDown, false);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyDown, false);
      }
    }, {
      key: 'onKeyDown',
      value: function onKeyDown(event) {
        var handler = this.keymap[event.keyCode];
  
        if (!handler) {
          return;
        }
  
        event.preventDefault();
        handler(event);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          'span',
          null,
          ' '
        );
      }
    }]);
  
    return KeyboardControls;
  }(_react.Component);
  
  KeyboardControls.propTypes = {
    handleShiftLeft: _react.PropTypes.func.isRequired,
    handleShiftRight: _react.PropTypes.func.isRequired,
    handleShiftDown: _react.PropTypes.func.isRequired,
    handleShiftUp: _react.PropTypes.func.isRequired
  };
  
  exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(KeyboardControls);
  
  
  function mapDispatchToProps(dispatch) {
    return _extends({}, (0, _redux.bindActionCreators)(actionCreators, dispatch));
  }

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Message = Message;
  
  var _react = __webpack_require__(9);
  
  var _react2 = _interopRequireDefault(_react);
  
  var _Message = __webpack_require__(395);
  
  var _Message2 = _interopRequireDefault(_Message);
  
  var _NewGameButton = __webpack_require__(136);
  
  var _NewGameButton2 = _interopRequireDefault(_NewGameButton);
  
  var _reactRedux = __webpack_require__(39);
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  
  function Message(_ref) {
    var gameOver = _ref.gameOver;
    var gameWon = _ref.gameWon;
  
    if (gameOver) {
      return renderGameOver();
    }
  
    if (gameWon) {
      return renderGameWon();
    }
  
    return _react2.default.createElement('span', null);
  }
  
  Message.propTypes = { // :off
    gameOver: _react.PropTypes.bool.isRequired,
    gameWon: _react.PropTypes.bool.isRequired
  }; // :on
  
  function renderGameOver() {
    return _react2.default.createElement(
      'div',
      { className: _Message2.default.Message },
      _react2.default.createElement(
        'h1',
        null,
        'Game Over!'
      ),
      _react2.default.createElement(
        _NewGameButton2.default,
        null,
        'Try Again'
      )
    );
  }
  
  function renderGameWon() {
    return _react2.default.createElement(
      'div',
      { className: _Message2.default.Message },
      _react2.default.createElement(
        'h1',
        null,
        'Game Won!'
      ),
      _react2.default.createElement(
        _NewGameButton2.default,
        null,
        'Play Again'
      )
    );
  }
  
  exports.default = (0, _reactRedux.connect)(mapStateToProps)(Message);
  
  
  function mapStateToProps(state) {
    var gameMeta = state.getIn(['game', 'meta']);
    return { // :off
      gameOver: gameMeta.get('gameOver'),
      gameWon: gameMeta.get('gameWon')
    }; // :on
  }

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Score = Score;
  
  var _react = __webpack_require__(9);
  
  var _react2 = _interopRequireDefault(_react);
  
  var _Score = __webpack_require__(397);
  
  var _Score2 = _interopRequireDefault(_Score);
  
  var _reactRedux = __webpack_require__(39);
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  
  function Score(props) {
    return _react2.default.createElement(
      'div',
      { className: _Score2.default.Score },
      _react2.default.createElement(
        'p',
        { className: _Score2.default.title },
        props.children
      ),
      _react2.default.createElement(
        'p',
        { className: _Score2.default.value },
        props[props.name]
      )
    );
  }
  
  Score.propTypes = {
    score: _react.PropTypes.number.isRequired,
  
    topScore: _react.PropTypes.number.isRequired,
  
    name: _react.PropTypes.string.isRequired,
  
    children: _react.PropTypes.string.isRequired
  };
  
  exports.default = (0, _reactRedux.connect)(mapStateToProps)(Score);
  
  
  function mapStateToProps(state) {
    var gameMeta = state.getIn(['game', 'meta']);
    return { // :off
      score: gameMeta.get('score', 0),
      topScore: gameMeta.get('topScore', 0)
    }; // :on
  }

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.configureStore = configureStore;
  
  var _redux = __webpack_require__(63);
  
  var _modules = __webpack_require__(256);
  
  var _constants = __webpack_require__(42);
  
  var _middleware = __webpack_require__(254);
  
  function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
  
  /**
   * Create a redux store for the production environment.
   * @param {object|immutable.Map} initialState
   * @return {object} Store
   * */
  function configureStore() {
    var initialState = arguments.length <= 0 || arguments[0] === undefined ? _constants.INITIAL_STATE : arguments[0];
  
    var enhancer = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, _toConsumableArray(_middleware.middleware)));
    return (0, _redux.createStore)(_modules.reducer, initialState, enhancer);
  }

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var loadedModule = undefined;
  
  if (false) {
    loadedModule = require('./configureStore.dev').configureStore;
  } else {
    loadedModule = __webpack_require__(250).configureStore;
  }
  
  var configureStore = exports.configureStore = loadedModule;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  
  var _identity = __webpack_require__(80);
  
  var _identity2 = _interopRequireDefault(_identity);
  
  var _actionDispatch;
  
  exports.createTilesMiddleware = createTilesMiddleware;
  
  var _utils = __webpack_require__(253);
  
  var _game = __webpack_require__(50);
  
  var ACTION = _interopRequireWildcard(_game);
  
  function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  
  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  
  var actionDispatch = (_actionDispatch = {}, _defineProperty(_actionDispatch, ACTION.SHIFT_DOWN, createTiles(function () {
    return 1;
  })), _defineProperty(_actionDispatch, ACTION.SHIFT_LEFT, createTiles(function () {
    return 1;
  })), _defineProperty(_actionDispatch, ACTION.SHIFT_UP, createTiles(function () {
    return 1;
  })), _defineProperty(_actionDispatch, ACTION.SHIFT_RIGHT, createTiles(function () {
    return 1;
  })), _defineProperty(_actionDispatch, ACTION.NEW_GAME, createTiles(_utils.randomTileQuantity)), _actionDispatch); // :on
  
  function createTilesMiddleware(_ref) {
    var getState = _ref.getState;
  
    return function (next) {
      return function (action) {
        var handleAction = actionDispatch[action.type];
  
        // Guard, uninteresting actions.
        if (!handleAction) {
          return next(action);
        }
  
        return handleAction({ getState: getState }, next, action);
      };
    };
  }
  
  function createTiles(n) {
    return function (_ref2, next, action) {
      var getState = _ref2.getState;
  
      // setup
      var gameState = getState().getIn(['game', 'state']);
      var nextHandle = next(action);
      var nextGameState = getState().getIn(['game', 'state']);
  
      // Guard, no change and grid has tiles
      var nextGameStateTiles = nextGameState.tileValues();
      var hasNotChanged = function hasNotChanged() {
        return gameState.tileValues().equals(nextGameStateTiles);
      };
      var hasTiles = function hasTiles() {
        return nextGameStateTiles.filter(_identity2.default).size;
      };
      if (hasNotChanged() && hasTiles()) {
        return nextHandle;
      }
  
      var newTileAction = (0, _utils.createRandomTileAction)(nextGameState, n());
  
      // Guard, couldn't create a new tile.  (Board is full.)
      if (!newTileAction) {
        // TODO fix this
        console.error('no empty tiles', 'newTile', newTileAction); // eslint-disable-line no-console
        return nextHandle;
      }
  
      // dispatch action.
      return next(newTileAction);
    };
  }

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  
  var _merge = __webpack_require__(195);
  
  var _merge2 = _interopRequireDefault(_merge);
  
  var _sampleSize = __webpack_require__(477);
  
  var _sampleSize2 = _interopRequireDefault(_sampleSize);
  
  exports.createRandomTileAction = createRandomTileAction;
  exports.randomTileQuantity = randomTileQuantity;
  
  var _game = __webpack_require__(50);
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  
  function createRandomTileAction(gameState) {
    var quantity = arguments.length <= 1 || arguments[1] === undefined ? 1 : arguments[1];
  
    // get empty tiles
    var emptyTiles = gameState.getEmptyTiles().toJS();
  
    // Guard, no empty tiles
    if (!emptyTiles.length) {
      return undefined;
    }
  
    // choose random tiles from the grid
    var randomTileSample = (0, _sampleSize2.default)(emptyTiles, Math.min(quantity, emptyTiles.length));
  
    // create tiles
    var newTiles = randomTileSample.map(function (tile) {
      return (0, _merge2.default)(tile, { value: randomTileValue() });
    });
  
    return (0, _game.handleCreateTiles)(newTiles);
  }
  
  function randomTileValue() {
    var random = Math.random();
    if (random >= 0.95) {
      return 8;
    }
  
    if (random >= 0.70) {
      return 4;
    }
  
    return 2;
  }
  
  function randomTileQuantity() {
    return Math.random() > 0.75 ? 3 : 2;
  }

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.middleware = undefined;
  
  var _identity = __webpack_require__(80);
  
  var _identity2 = _interopRequireDefault(_identity);
  
  var _reduxThunk = __webpack_require__(235);
  
  var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
  
  var _createTilesMiddleware = __webpack_require__(252);
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  
  var middleware = exports.middleware = [// :off
  _reduxThunk2.default, _createTilesMiddleware.createTilesMiddleware,  false ? require('./loggerMiddleware').loggerMiddleware : undefined].filter(_identity2.default); // :on

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  
  var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
  
  exports.shiftLeft = shiftLeft;
  exports.shiftUp = shiftUp;
  exports.shiftRight = shiftRight;
  exports.shiftDown = shiftDown;
  exports.newGame = newGame;
  exports.pushTiles = pushTiles;
  exports.updateTilesFromValue = updateTilesFromValue;
  exports.updateTilesCoordinates = updateTilesCoordinates;
  exports.updateMeta = updateMeta;
  
  var _immutable = __webpack_require__(34);
  
  var _utils = __webpack_require__(137);
  
  var _constants = __webpack_require__(42);
  
  function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
  
  function shiftLeft() {
    var gameState = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.List)() : arguments[0];
  
    return gameState.update(function (value) {
      return value.map(_utils.shift);
    });
  }
  
  function shiftUp() {
    var gameState = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.List)() : arguments[0];
  
    return gameState.update(function (value) {
      return (0, _utils.transpose)(shiftLeft((0, _utils.transpose)(value)));
    });
  }
  
  function shiftRight() {
    var gameState = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.List)() : arguments[0];
  
    return gameState.update(function (value) {
      return value.map(function (col) {
        return (0, _utils.shift)(col.reverse()).reverse();
      });
    });
  }
  
  function shiftDown() {
    var gameState = arguments.length <= 0 || arguments[0] === undefined ? (0, _immutable.List)() : arguments[0];
  
    return gameState.update(function (value) {
      return (0, _utils.transpose)(shiftRight((0, _utils.transpose)(value)));
    });
  }
  
  function newGame() {
    return _constants.INITIAL_STATE.getIn(['game', 'state']);
  }
  
  function pushTiles(tiles) {
    return function (gameState) {
      return gameState.withMutations(function (updater) {
        tiles.forEach(pushTile(updater));
        return updater;
      });
    };
  
    function pushTile(state) {
      return function (tile) {
        var keyPath = [tile.get('row'), tile.get('col')];
  
        if (state.getIn(keyPath)) {
          return;
        }
  
        state.setIn(keyPath, tile.set('isNew', true));
      };
    }
  }
  
  function updateTilesFromValue(gameState) {
    return gameState.map(function (row) {
      return row.map(updateTileFromValue);
    });
  
    function updateTileFromValue(tile) {
      if (!tile) {
        return tile;
      }
  
      return tile.set('fromValue', tile.get('value', 0));
    }
  }
  
  function updateTilesCoordinates(gameState) {
    return gameState.update(function (updater) {
      return updater.map(function (row, rowIndex) {
        return row.map(function (tile, colIndex) {
          return tile ? tile.updateGrid(colIndex, rowIndex, false) : undefined;
        });
      });
    });
  }
  
  function updateMeta(game) {
    return game.update('meta', function (gameMeta) {
      return gameMeta.update('score', function (gameScore) {
        return game.get('state').toTileSet().reduce(sumPoints, gameScore);
      });
    }).update('meta', function (gameMeta) {
      return gameMeta.update('topScore', function (topScore) {
        return Math.max(topScore, gameMeta.get('score'));
      });
    }).update(function (_game) {
      return _game.setIn(['meta', 'gameWon'], gameIsWon(_game.get('state')));
    }).update(function (_game) {
      return _game.setIn(['meta', 'gameOver'], gameIsOver(_game.get('state')));
    });
  
    function gameIsWon(gameState) {
      var largestTile = gameState.tileValues().reduce(function (left, right) {
        return right ? Math.max(left, right) : left;
      }, 0);
      return largestTile >= _constants.GAME_WON_TILE;
    }
  
    function gameIsOver(gameState) {
      if (gameState.getEmptyTiles().size) {
        return false;
      }
  
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;
  
      try {
        for (var _iterator = (0, _utils.tileNeighbors)(gameState.size)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 3);
  
          var cell = _step$value[0];
          var down = _step$value[1];
          var right = _step$value[2];
  
          var cellValue = gameState.getIn([].concat(_toConsumableArray(cell), ['value']));
  
          if (cellValue === gameState.getIn([].concat(_toConsumableArray(down), ['value']))) {
            return false;
          }
  
          if (cellValue === gameState.getIn([].concat(_toConsumableArray(right), ['value']))) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
  
      return true;
    }
  
    function sumPoints(left, right) {
      if (right.get('value') === right.get('fromValue')) {
        return left;
      }
  
      return left + right.get('value');
    }
  }

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.reducer = undefined;
  
  var _identity = __webpack_require__(80);
  
  var _identity2 = _interopRequireDefault(_identity);
  
  var _reduxImmutable = __webpack_require__(233);
  
  var _root = __webpack_require__(138);
  
  var _root2 = _interopRequireDefault(_root);
  
  var _game = __webpack_require__(50);
  
  var _game2 = _interopRequireDefault(_game);
  
  var _immutable = __webpack_require__(34);
  
  var _utils = __webpack_require__(257);
  
  var _constants = __webpack_require__(42);
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  
  /**
   * Core redux reducer.
   * @function reducer
   */
  var reducer = exports.reducer = (0, _utils.pipe)( // :off
  _constants.INITIAL_STATE, // initial state
  toImmutable, // ...reducers
  _root2.default, (0, _reduxImmutable.combineReducers)({ game: _game2.default, isLoading: _identity2.default })); // :on
  
  /**
   * Ensure state is an immutable map.
   *
   * @param {(object|immutable.Map)} state
   * @returns {immutable.Map} immutable state.
   */
  function toImmutable(state) {
    return (0, _immutable.fromJS)(state);
  }

/***/ },
/* 257 */
/***/ function(module, exports) {

  "use strict";
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.pipe = pipe;
  /**
   * Create a pipeline from reducers.
   *
   * @param {(object|immutable.Map)} initialState
   * @param {...Function} reducers - Reducers to chain.
   * @returns {Function} A single reducer.
   */
  function pipe(initialState) {
    for (var _len = arguments.length, reducers = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      reducers[_key - 1] = arguments[_key];
    }
  
    return function reducer() {
      var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
      var action = arguments[1];
  
      return reducers.reduce(function (nextState, nextReducer) {
        return nextReducer(nextState, action);
      }, state);
    };
  }

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  var _react = __webpack_require__(9);
  
  var _react2 = _interopRequireDefault(_react);
  
  var _reactDom = __webpack_require__(200);
  
  var _App = __webpack_require__(245);
  
  var _configureStore = __webpack_require__(251);
  
  var _config = __webpack_require__(135);
  
  var _root = __webpack_require__(138);
  
  var _constants = __webpack_require__(42);
  
  var _storage = __webpack_require__(262);
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  
  function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { return step("next", value); }, function (err) { return step("throw", err); }); } } return step("next"); }); }; }
  
  __webpack_require__(259);
  __webpack_require__(398);
  
  var store = (0, _configureStore.configureStore)();
  
  // TODO deal with game not in progress.
  store.dispatch((0, _root.setState)(_storage.storage.get(_constants.STORAGE_KEY)));
  
  store.subscribe(_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _storage.storage.set(_constants.STORAGE_KEY, store.getState().toJS());
  
          case 2:
            return _context.abrupt('return', _context.sent);
  
          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  })));
  
  (0, _reactDom.render)(_react2.default.createElement(_App.App, { store: store, title: _config.titlePrefix }), document.getElementById('app'));

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  var _identity = __webpack_require__(80);
  
  var _identity2 = _interopRequireDefault(_identity);
  
  var _immutable = __webpack_require__(34);
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  
  function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint no-extend-native: 0 */
  
  
  _immutable.List.prototype.getEmptyTiles = function getEmptyTiles() {
    return this.map(function (row, rowIndex) {
      return row.map(function (cell, colIndex) {
        return cell ? undefined : (0, _immutable.Map)({ row: rowIndex, col: colIndex });
      });
    }).flatten(true).filter(_identity2.default);
  };
  
  _immutable.List.prototype.toTileSet = function toTileSet() {
    return this.flatten(true).toSet().filter(_identity2.default);
  };
  
  _immutable.Map.prototype.updateGrid = function updateGrid(col, row) {
    var isNew = arguments.length <= 2 || arguments[2] === undefined ? undefined : arguments[2];
  
    return this.merge(isNew === undefined ? { col: col, row: row } : { col: col, row: row, isNew: isNew });
  };
  
  _immutable.List.prototype.tileValues = function tileValues() {
    return this.flatten(true).map(function (tile) {
      return !tile ? tile : tile.get('value');
    });
  };
  
  _immutable.Iterable.prototype.log = function log(key, msg) {
    var _console;
  
    var target = key ? this.get(key) : this;
    (_console = console).log.apply(_console, _toConsumableArray(msg ? [msg, target.toJS()] : [target.toJS()])); // eslint-disable-line no-console
    return this;
  };
  
  _immutable.Iterable.prototype.logIn = function logIn(path, msg) {
    var _console2;
  
    var target = this.get(path);
    (_console2 = console).log.apply(_console2, _toConsumableArray(msg ? [msg, target.toJS()] : [target.toJS()])); // eslint-disable-line no-console
    return this;
  };

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  module.exports = __webpack_require__(171);

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var storageProvider = exports.storageProvider = __webpack_require__(260);

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.storage = undefined;
  
  var _provider = __webpack_require__(261);
  
  function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { return step("next", value); }, function (err) { return step("throw", err); }); } } return step("next"); }); }; }
  
  var storage = exports.storage = {
    get: function get(key) {
      var _this = this;
  
      return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.t0 = JSON;
                _context.next = 4;
                return _provider.storageProvider.getItem(key);
  
              case 4:
                _context.t1 = _context.sent;
  
                if (_context.t1) {
                  _context.next = 7;
                  break;
                }
  
                _context.t1 = '{}';
  
              case 7:
                _context.t2 = _context.t1;
                return _context.abrupt('return', _context.t0.parse.call(_context.t0, _context.t2));
  
              case 11:
                _context.prev = 11;
                _context.t3 = _context['catch'](0);
  
                // TODO handle this
                console.error('unknown error', _context.t3); // eslint-disable-line no-console
                return _context.abrupt('return', {});
  
              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 11]]);
      }))();
    },
    set: function set(key, value) {
      var _this2 = this;
  
      return _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _provider.storageProvider.setItem(key, JSON.stringify(value));
  
              case 2:
                return _context2.abrupt('return', _context2.sent);
  
              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  };

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

  /* WEBPACK VAR INJECTION */(function(global) {"use strict";
  
  __webpack_require__(381);
  
  __webpack_require__(264);
  
  if (global._babelPolyfill) {
    throw new Error("only one instance of babel-polyfill is allowed");
  }
  global._babelPolyfill = true;
  /* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

  /* WEBPACK VAR INJECTION */(function(global, process) {/**
   * Copyright (c) 2014, Facebook, Inc.
   * All rights reserved.
   *
   * This source code is licensed under the BSD-style license found in the
   * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
   * additional grant of patent rights can be found in the PATENTS file in
   * the same directory.
   */
  
  !(function(global) {
    "use strict";
  
    var hasOwn = Object.prototype.hasOwnProperty;
    var undefined; // More compressible than void 0.
    var iteratorSymbol =
      typeof Symbol === "function" && Symbol.iterator || "@@iterator";
  
    var inModule = typeof module === "object";
    var runtime = global.regeneratorRuntime;
    if (runtime) {
      if (inModule) {
        // If regeneratorRuntime is defined globally and we're in a module,
        // make the exports object identical to regeneratorRuntime.
        module.exports = runtime;
      }
      // Don't bother evaluating the rest of this file if the runtime was
      // already defined globally.
      return;
    }
  
    // Define the runtime globally (as expected by generated code) as either
    // module.exports (if we're in a module) or a new, empty object.
    runtime = global.regeneratorRuntime = inModule ? module.exports : {};
  
    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided, then outerFn.prototype instanceof Generator.
      var generator = Object.create((outerFn || Generator).prototype);
      var context = new Context(tryLocsList || []);
  
      // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.
      generator._invoke = makeInvokeMethod(innerFn, self, context);
  
      return generator;
    }
    runtime.wrap = wrap;
  
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
      try {
        return { type: "normal", arg: fn.call(obj, arg) };
      } catch (err) {
        return { type: "throw", arg: err };
      }
    }
  
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
  
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
  
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
  
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunction.displayName = "GeneratorFunction";
  
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function(method) {
        prototype[method] = function(arg) {
          return this._invoke(method, arg);
        };
      });
    }
  
    runtime.isGeneratorFunction = function(genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor
        ? ctor === GeneratorFunction ||
          // For the native GeneratorFunction constructor, the best we can
          // do is to check its .name property.
          (ctor.displayName || ctor.name) === "GeneratorFunction"
        : false;
    };
  
    runtime.mark = function(genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
      }
      genFun.prototype = Object.create(Gp);
      return genFun;
    };
  
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `value instanceof AwaitArgument` to determine if the yielded value is
    // meant to be awaited. Some may consider the name of this method too
    // cutesy, but they are curmudgeons.
    runtime.awrap = function(arg) {
      return new AwaitArgument(arg);
    };
  
    function AwaitArgument(arg) {
      this.arg = arg;
    }
  
    function AsyncIterator(generator) {
      // This invoke function is written in a style that assumes some
      // calling function (or Promise) will handle exceptions.
      function invoke(method, arg) {
        var result = generator[method](arg);
        var value = result.value;
        return value instanceof AwaitArgument
          ? Promise.resolve(value.arg).then(invokeNext, invokeThrow)
          : Promise.resolve(value).then(function(unwrapped) {
              // When a yielded Promise is resolved, its final value becomes
              // the .value of the Promise<{value,done}> result for the
              // current iteration. If the Promise is rejected, however, the
              // result for this iteration will be rejected with the same
              // reason. Note that rejections of yielded Promises are not
              // thrown back into the generator function, as is the case
              // when an awaited Promise is rejected. This difference in
              // behavior between yield and await is important, because it
              // allows the consumer to decide what to do with the yielded
              // rejection (swallow it and continue, manually .throw it back
              // into the generator, abandon iteration, whatever). With
              // await, by contrast, there is no opportunity to examine the
              // rejection reason outside the generator function, so the
              // only option is to throw it from the await expression, and
              // let the generator function handle the exception.
              result.value = unwrapped;
              return result;
            });
      }
  
      if (typeof process === "object" && process.domain) {
        invoke = process.domain.bind(invoke);
      }
  
      var invokeNext = invoke.bind(generator, "next");
      var invokeThrow = invoke.bind(generator, "throw");
      var invokeReturn = invoke.bind(generator, "return");
      var previousPromise;
  
      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return invoke(method, arg);
        }
  
        return previousPromise =
          // If enqueue has been called before, then we want to wait until
          // all previous Promises have been resolved before calling invoke,
          // so that results are always delivered in the correct order. If
          // enqueue has not been called before, then it is important to
          // call invoke immediately, without waiting on a callback to fire,
          // so that the async generator function has the opportunity to do
          // any necessary setup in a predictable way. This predictability
          // is why the Promise constructor synchronously invokes its
          // executor callback, and why async functions synchronously
          // execute code before the first await. Since we implement simple
          // async functions in terms of async generators, it is especially
          // important to get this right, even though it requires care.
          previousPromise ? previousPromise.then(
            callInvokeWithMethodAndArg,
            // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg
          ) : new Promise(function (resolve) {
            resolve(callInvokeWithMethodAndArg());
          });
      }
  
      // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).
      this._invoke = enqueue;
    }
  
    defineIteratorMethods(AsyncIterator.prototype);
  
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    runtime.async = function(innerFn, outerFn, self, tryLocsList) {
      var iter = new AsyncIterator(
        wrap(innerFn, outerFn, self, tryLocsList)
      );
  
      return runtime.isGeneratorFunction(outerFn)
        ? iter // If outerFn is a generator, return the full iterator.
        : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
          });
    };
  
    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
  
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }
  
        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          }
  
          // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
          return doneResult();
        }
  
        while (true) {
          var delegate = context.delegate;
          if (delegate) {
            if (method === "return" ||
                (method === "throw" && delegate.iterator[method] === undefined)) {
              // A return or throw (when the delegate iterator has no throw
              // method) always terminates the yield* loop.
              context.delegate = null;
  
              // If the delegate iterator has a return method, give it a
              // chance to clean up.
              var returnMethod = delegate.iterator["return"];
              if (returnMethod) {
                var record = tryCatch(returnMethod, delegate.iterator, arg);
                if (record.type === "throw") {
                  // If the return method threw an exception, let that
                  // exception prevail over the original return or throw.
                  method = "throw";
                  arg = record.arg;
                  continue;
                }
              }
  
              if (method === "return") {
                // Continue with the outer return, now that the delegate
                // iterator has been terminated.
                continue;
              }
            }
  
            var record = tryCatch(
              delegate.iterator[method],
              delegate.iterator,
              arg
            );
  
            if (record.type === "throw") {
              context.delegate = null;
  
              // Like returning generator.throw(uncaught), but without the
              // overhead of an extra function call.
              method = "throw";
              arg = record.arg;
              continue;
            }
  
            // Delegate generator ran and handled its own exceptions so
            // regardless of what the method was, we continue as if it is
            // "next" with an undefined arg.
            method = "next";
            arg = undefined;
  
            var info = record.arg;
            if (info.done) {
              context[delegate.resultName] = info.value;
              context.next = delegate.nextLoc;
            } else {
              state = GenStateSuspendedYield;
              return info;
            }
  
            context.delegate = null;
          }
  
          if (method === "next") {
            context._sent = arg;
  
            if (state === GenStateSuspendedYield) {
              context.sent = arg;
            } else {
              context.sent = undefined;
            }
          } else if (method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw arg;
            }
  
            if (context.dispatchException(arg)) {
              // If the dispatched exception was caught by a catch block,
              // then let that catch block handle the exception normally.
              method = "next";
              arg = undefined;
            }
  
          } else if (method === "return") {
            context.abrupt("return", arg);
          }
  
          state = GenStateExecuting;
  
          var record = tryCatch(innerFn, self, context);
          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done
              ? GenStateCompleted
              : GenStateSuspendedYield;
  
            var info = {
              value: record.arg,
              done: context.done
            };
  
            if (record.arg === ContinueSentinel) {
              if (context.delegate && method === "next") {
                // Deliberately forget the last sent value so that we don't
                // accidentally pass it on to the delegate.
                arg = undefined;
              }
            } else {
              return info;
            }
  
          } else if (record.type === "throw") {
            state = GenStateCompleted;
            // Dispatch the exception by looping back around to the
            // context.dispatchException(arg) call above.
            method = "throw";
            arg = record.arg;
          }
        }
      };
    }
  
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
  
    Gp[iteratorSymbol] = function() {
      return this;
    };
  
    Gp.toString = function() {
      return "[object Generator]";
    };
  
    function pushTryEntry(locs) {
      var entry = { tryLoc: locs[0] };
  
      if (1 in locs) {
        entry.catchLoc = locs[1];
      }
  
      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }
  
      this.tryEntries.push(entry);
    }
  
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }
  
    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{ tryLoc: "root" }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }
  
    runtime.keys = function(object) {
      var keys = [];
      for (var key in object) {
        keys.push(key);
      }
      keys.reverse();
  
      // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.
      return function next() {
        while (keys.length) {
          var key = keys.pop();
          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        }
  
        // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.
        next.done = true;
        return next;
      };
    };
  
    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }
  
        if (typeof iterable.next === "function") {
          return iterable;
        }
  
        if (!isNaN(iterable.length)) {
          var i = -1, next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }
  
            next.value = undefined;
            next.done = true;
  
            return next;
          };
  
          return next.next = next;
        }
      }
  
      // Return an iterator with no values.
      return { next: doneResult };
    }
    runtime.values = values;
  
    function doneResult() {
      return { value: undefined, done: true };
    }
  
    Context.prototype = {
      constructor: Context,
  
      reset: function(skipTempReset) {
        this.prev = 0;
        this.next = 0;
        this.sent = undefined;
        this.done = false;
        this.delegate = null;
  
        this.tryEntries.forEach(resetTryEntry);
  
        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" &&
                hasOwn.call(this, name) &&
                !isNaN(+name.slice(1))) {
              this[name] = undefined;
            }
          }
        }
      },
  
      stop: function() {
        this.done = true;
  
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;
        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }
  
        return this.rval;
      },
  
      dispatchException: function(exception) {
        if (this.done) {
          throw exception;
        }
  
        var context = this;
        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;
          return !!caught;
        }
  
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;
  
          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }
  
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");
  
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
  
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
  
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
  
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
  
      abrupt: function(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev &&
              hasOwn.call(entry, "finallyLoc") &&
              this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
  
        if (finallyEntry &&
            (type === "break" ||
             type === "continue") &&
            finallyEntry.tryLoc <= arg &&
            arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }
  
        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;
  
        if (finallyEntry) {
          this.next = finallyEntry.finallyLoc;
        } else {
          this.complete(record);
        }
  
        return ContinueSentinel;
      },
  
      complete: function(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }
  
        if (record.type === "break" ||
            record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = record.arg;
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }
      },
  
      finish: function(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
  
      "catch": function(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
  
        // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.
        throw new Error("illegal catch attempt");
      },
  
      delegateYield: function(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };
  
        return ContinueSentinel;
      }
    };
  })(
    // Among the various tricks for obtaining a reference to the global
    // object, this seems to be the most reliable technique that does not
    // use indirect eval (which violates Content Security Policy).
    typeof global === "object" ? global :
    typeof window === "object" ? window :
    typeof self === "object" ? self : this
  );
  
  /* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(84)))

/***/ },
/* 265 */,
/* 266 */,
/* 267 */
/***/ function(module, exports, __webpack_require__) {

  // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
  'use strict';
  var toObject = __webpack_require__(32)
    , toIndex  = __webpack_require__(54)
    , toLength = __webpack_require__(16);
  
  module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
    var O     = toObject(this)
      , len   = toLength(O.length)
      , to    = toIndex(target, len)
      , from  = toIndex(start, len)
      , $$    = arguments
      , end   = $$.length > 2 ? $$[2] : undefined
      , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
      , inc   = 1;
    if(from < to && to < from + count){
      inc  = -1;
      from += count - 1;
      to   += count - 1;
    }
    while(count-- > 0){
      if(from in O)O[to] = O[from];
      else delete O[to];
      to   += inc;
      from += inc;
    } return O;
  };

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

  // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
  'use strict';
  var toObject = __webpack_require__(32)
    , toIndex  = __webpack_require__(54)
    , toLength = __webpack_require__(16);
  module.exports = [].fill || function fill(value /*, start = 0, end = @length */){
    var O      = toObject(this)
      , length = toLength(O.length)
      , $$     = arguments
      , $$len  = $$.length
      , index  = toIndex($$len > 1 ? $$[1] : undefined, length)
      , end    = $$len > 2 ? $$[2] : undefined
      , endPos = end === undefined ? length : toIndex(end, length);
    while(endPos > index)O[index++] = value;
    return O;
  };

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

  // 9.4.2.3 ArraySpeciesCreate(originalArray, length)
  var isObject = __webpack_require__(6)
    , isArray  = __webpack_require__(94)
    , SPECIES  = __webpack_require__(8)('species');
  module.exports = function(original, length){
    var C;
    if(isArray(original)){
      C = original.constructor;
      // cross-realm fallback
      if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
      if(isObject(C)){
        C = C[SPECIES];
        if(C === null)C = undefined;
      }
    } return new (C === undefined ? Array : C)(length);
  };

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

  // all enumerable object keys, includes symbols
  var $ = __webpack_require__(3);
  module.exports = function(it){
    var keys       = $.getKeys(it)
      , getSymbols = $.getSymbols;
    if(getSymbols){
      var symbols = getSymbols(it)
        , isEnum  = $.isEnum
        , i       = 0
        , key;
      while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
    }
    return keys;
  };

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

  var $         = __webpack_require__(3)
    , toIObject = __webpack_require__(23);
  module.exports = function(object, el){
    var O      = toIObject(object)
      , keys   = $.getKeys(O)
      , length = keys.length
      , index  = 0
      , key;
    while(length > index)if(O[key = keys[index++]] === el)return key;
  };

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

  var global    = __webpack_require__(10)
    , macrotask = __webpack_require__(161).set
    , Observer  = global.MutationObserver || global.WebKitMutationObserver
    , process   = global.process
    , Promise   = global.Promise
    , isNode    = __webpack_require__(30)(process) == 'process'
    , head, last, notify;
  
  var flush = function(){
    var parent, domain, fn;
    if(isNode && (parent = process.domain)){
      process.domain = null;
      parent.exit();
    }
    while(head){
      domain = head.domain;
      fn     = head.fn;
      if(domain)domain.enter();
      fn(); // <- currently we use it only for Promise - try / catch not required
      if(domain)domain.exit();
      head = head.next;
    } last = undefined;
    if(parent)parent.enter();
  };
  
  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = 1
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = -toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    notify = function(){
      Promise.resolve().then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }
  
  module.exports = function asap(fn){
    var task = {fn: fn, next: undefined, domain: isNode && process.domain};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

  // 19.1.2.1 Object.assign(target, source, ...)
  var $        = __webpack_require__(3)
    , toObject = __webpack_require__(32)
    , IObject  = __webpack_require__(69);
  
  // should work with symbols and should have deterministic property order (V8 bug)
  module.exports = __webpack_require__(11)(function(){
    var a = Object.assign
      , A = {}
      , B = {}
      , S = Symbol()
      , K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k){ B[k] = k; });
    return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
  }) ? function assign(target, source){ // eslint-disable-line no-unused-vars
    var T     = toObject(target)
      , $$    = arguments
      , $$len = $$.length
      , index = 1
      , getKeys    = $.getKeys
      , getSymbols = $.getSymbols
      , isEnum     = $.isEnum;
    while($$len > index){
      var S      = IObject($$[index++])
        , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
        , length = keys.length
        , j      = 0
        , key;
      while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
    }
    return T;
  } : Object.assign;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var path      = __webpack_require__(275)
    , invoke    = __webpack_require__(68)
    , aFunction = __webpack_require__(43);
  module.exports = function(/* ...pargs */){
    var fn     = aFunction(this)
      , length = arguments.length
      , pargs  = Array(length)
      , i      = 0
      , _      = path._
      , holder = false;
    while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
    return function(/* ...args */){
      var that  = this
        , $$    = arguments
        , $$len = $$.length
        , j = 0, k = 0, args;
      if(!holder && !$$len)return invoke(fn, pargs, that);
      args = pargs.slice();
      if(holder)for(;length > j; j++)if(args[j] === _)args[j] = $$[k++];
      while($$len > k)args.push($$[k++]);
      return invoke(fn, args, that);
    };
  };

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

  module.exports = __webpack_require__(10);

/***/ },
/* 276 */
/***/ function(module, exports) {

  module.exports = function(regExp, replace){
    var replacer = replace === Object(replace) ? function(part){
      return replace[part];
    } : replace;
    return function(it){
      return String(it).replace(regExp, replacer);
    };
  };

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

  // 7.3.20 SpeciesConstructor(O, defaultConstructor)
  var anObject  = __webpack_require__(7)
    , aFunction = __webpack_require__(43)
    , SPECIES   = __webpack_require__(8)('species');
  module.exports = function(O, D){
    var C = anObject(O).constructor, S;
    return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
  };

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

  // 7.1.1 ToPrimitive(input [, PreferredType])
  var isObject = __webpack_require__(6);
  // instead of the ES6 spec version, we didn't implement @@toPrimitive case
  // and the second argument - flag - preferred type is a string
  module.exports = function(it, S){
    if(!isObject(it))return it;
    var fn, val;
    if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
    if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
    if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
    throw TypeError("Can't convert object to primitive value");
  };

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var $                 = __webpack_require__(3)
    , $export           = __webpack_require__(1)
    , DESCRIPTORS       = __webpack_require__(20)
    , createDesc        = __webpack_require__(36)
    , html              = __webpack_require__(147)
    , cel               = __webpack_require__(144)
    , has               = __webpack_require__(15)
    , cof               = __webpack_require__(30)
    , invoke            = __webpack_require__(68)
    , fails             = __webpack_require__(11)
    , anObject          = __webpack_require__(7)
    , aFunction         = __webpack_require__(43)
    , isObject          = __webpack_require__(6)
    , toObject          = __webpack_require__(32)
    , toIObject         = __webpack_require__(23)
    , toInteger         = __webpack_require__(55)
    , toIndex           = __webpack_require__(54)
    , toLength          = __webpack_require__(16)
    , IObject           = __webpack_require__(69)
    , IE_PROTO          = __webpack_require__(45)('__proto__')
    , createArrayMethod = __webpack_require__(64)
    , arrayIndexOf      = __webpack_require__(140)(false)
    , ObjectProto       = Object.prototype
    , ArrayProto        = Array.prototype
    , arraySlice        = ArrayProto.slice
    , arrayJoin         = ArrayProto.join
    , defineProperty    = $.setDesc
    , getOwnDescriptor  = $.getDesc
    , defineProperties  = $.setDescs
    , factories         = {}
    , IE8_DOM_DEFINE;
  
  if(!DESCRIPTORS){
    IE8_DOM_DEFINE = !fails(function(){
      return defineProperty(cel('div'), 'a', {get: function(){ return 7; }}).a != 7;
    });
    $.setDesc = function(O, P, Attributes){
      if(IE8_DOM_DEFINE)try {
        return defineProperty(O, P, Attributes);
      } catch(e){ /* empty */ }
      if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
      if('value' in Attributes)anObject(O)[P] = Attributes.value;
      return O;
    };
    $.getDesc = function(O, P){
      if(IE8_DOM_DEFINE)try {
        return getOwnDescriptor(O, P);
      } catch(e){ /* empty */ }
      if(has(O, P))return createDesc(!ObjectProto.propertyIsEnumerable.call(O, P), O[P]);
    };
    $.setDescs = defineProperties = function(O, Properties){
      anObject(O);
      var keys   = $.getKeys(Properties)
        , length = keys.length
        , i = 0
        , P;
      while(length > i)$.setDesc(O, P = keys[i++], Properties[P]);
      return O;
    };
  }
  $export($export.S + $export.F * !DESCRIPTORS, 'Object', {
    // 19.1.2.6 / 15.2.3.3 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $.getDesc,
    // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
    defineProperty: $.setDesc,
    // 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
    defineProperties: defineProperties
  });
  
    // IE 8- don't enum bug keys
  var keys1 = ('constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,' +
              'toLocaleString,toString,valueOf').split(',')
    // Additional keys for getOwnPropertyNames
    , keys2 = keys1.concat('length', 'prototype')
    , keysLen1 = keys1.length;
  
  // Create object with `null` prototype: use iframe Object with cleared prototype
  var createDict = function(){
    // Thrash, waste and sodomy: IE GC bug
    var iframe = cel('iframe')
      , i      = keysLen1
      , gt     = '>'
      , iframeDocument;
    iframe.style.display = 'none';
    html.appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write('<script>document.F=Object</script' + gt);
    iframeDocument.close();
    createDict = iframeDocument.F;
    while(i--)delete createDict.prototype[keys1[i]];
    return createDict();
  };
  var createGetKeys = function(names, length){
    return function(object){
      var O      = toIObject(object)
        , i      = 0
        , result = []
        , key;
      for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
      // Don't enum bug & hidden keys
      while(length > i)if(has(O, key = names[i++])){
        ~arrayIndexOf(result, key) || result.push(key);
      }
      return result;
    };
  };
  var Empty = function(){};
  $export($export.S, 'Object', {
    // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
    getPrototypeOf: $.getProto = $.getProto || function(O){
      O = toObject(O);
      if(has(O, IE_PROTO))return O[IE_PROTO];
      if(typeof O.constructor == 'function' && O instanceof O.constructor){
        return O.constructor.prototype;
      } return O instanceof Object ? ObjectProto : null;
    },
    // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $.getNames = $.getNames || createGetKeys(keys2, keys2.length, true),
    // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
    create: $.create = $.create || function(O, /*?*/Properties){
      var result;
      if(O !== null){
        Empty.prototype = anObject(O);
        result = new Empty();
        Empty.prototype = null;
        // add "__proto__" for Object.getPrototypeOf shim
        result[IE_PROTO] = O;
      } else result = createDict();
      return Properties === undefined ? result : defineProperties(result, Properties);
    },
    // 19.1.2.14 / 15.2.3.14 Object.keys(O)
    keys: $.getKeys = $.getKeys || createGetKeys(keys1, keysLen1, false)
  });
  
  var construct = function(F, len, args){
    if(!(len in factories)){
      for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
      factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
    }
    return factories[len](F, args);
  };
  
  // 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
  $export($export.P, 'Function', {
    bind: function bind(that /*, args... */){
      var fn       = aFunction(this)
        , partArgs = arraySlice.call(arguments, 1);
      var bound = function(/* args... */){
        var args = partArgs.concat(arraySlice.call(arguments));
        return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
      };
      if(isObject(fn.prototype))bound.prototype = fn.prototype;
      return bound;
    }
  });
  
  // fallback for not array-like ES3 strings and DOM objects
  $export($export.P + $export.F * fails(function(){
    if(html)arraySlice.call(html);
  }), 'Array', {
    slice: function(begin, end){
      var len   = toLength(this.length)
        , klass = cof(this);
      end = end === undefined ? len : end;
      if(klass == 'Array')return arraySlice.call(this, begin, end);
      var start  = toIndex(begin, len)
        , upTo   = toIndex(end, len)
        , size   = toLength(upTo - start)
        , cloned = Array(size)
        , i      = 0;
      for(; i < size; i++)cloned[i] = klass == 'String'
        ? this.charAt(start + i)
        : this[start + i];
      return cloned;
    }
  });
  $export($export.P + $export.F * (IObject != Object), 'Array', {
    join: function join(separator){
      return arrayJoin.call(IObject(this), separator === undefined ? ',' : separator);
    }
  });
  
  // 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
  $export($export.S, 'Array', {isArray: __webpack_require__(94)});
  
  var createArrayReduce = function(isRight){
    return function(callbackfn, memo){
      aFunction(callbackfn);
      var O      = IObject(this)
        , length = toLength(O.length)
        , index  = isRight ? length - 1 : 0
        , i      = isRight ? -1 : 1;
      if(arguments.length < 2)for(;;){
        if(index in O){
          memo = O[index];
          index += i;
          break;
        }
        index += i;
        if(isRight ? index < 0 : length <= index){
          throw TypeError('Reduce of empty array with no initial value');
        }
      }
      for(;isRight ? index >= 0 : length > index; index += i)if(index in O){
        memo = callbackfn(memo, O[index], index, this);
      }
      return memo;
    };
  };
  
  var methodize = function($fn){
    return function(arg1/*, arg2 = undefined */){
      return $fn(this, arg1, arguments[1]);
    };
  };
  
  $export($export.P, 'Array', {
    // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
    forEach: $.each = $.each || methodize(createArrayMethod(0)),
    // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
    map: methodize(createArrayMethod(1)),
    // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
    filter: methodize(createArrayMethod(2)),
    // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
    some: methodize(createArrayMethod(3)),
    // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
    every: methodize(createArrayMethod(4)),
    // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
    reduce: createArrayReduce(false),
    // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
    reduceRight: createArrayReduce(true),
    // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
    indexOf: methodize(arrayIndexOf),
    // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
    lastIndexOf: function(el, fromIndex /* = @[*-1] */){
      var O      = toIObject(this)
        , length = toLength(O.length)
        , index  = length - 1;
      if(arguments.length > 1)index = Math.min(index, toInteger(fromIndex));
      if(index < 0)index = toLength(length + index);
      for(;index >= 0; index--)if(index in O)if(O[index] === el)return index;
      return -1;
    }
  });
  
  // 20.3.3.1 / 15.9.4.4 Date.now()
  $export($export.S, 'Date', {now: function(){ return +new Date; }});
  
  var lz = function(num){
    return num > 9 ? num : '0' + num;
  };
  
  // 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
  // PhantomJS / old WebKit has a broken implementations
  $export($export.P + $export.F * (fails(function(){
    return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
  }) || !fails(function(){
    new Date(NaN).toISOString();
  })), 'Date', {
    toISOString: function toISOString(){
      if(!isFinite(this))throw RangeError('Invalid time value');
      var d = this
        , y = d.getUTCFullYear()
        , m = d.getUTCMilliseconds()
        , s = y < 0 ? '-' : y > 9999 ? '+' : '';
      return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
        '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
        'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
        ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
    }
  });

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

  // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
  var $export = __webpack_require__(1);
  
  $export($export.P, 'Array', {copyWithin: __webpack_require__(267)});
  
  __webpack_require__(44)('copyWithin');

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

  // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
  var $export = __webpack_require__(1);
  
  $export($export.P, 'Array', {fill: __webpack_require__(268)});
  
  __webpack_require__(44)('fill');

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  // 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
  var $export = __webpack_require__(1)
    , $find   = __webpack_require__(64)(6)
    , KEY     = 'findIndex'
    , forced  = true;
  // Shouldn't skip holes
  if(KEY in [])Array(1)[KEY](function(){ forced = false; });
  $export($export.P + $export.F * forced, 'Array', {
    findIndex: function findIndex(callbackfn/*, that = undefined */){
      return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
  __webpack_require__(44)(KEY);

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  // 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
  var $export = __webpack_require__(1)
    , $find   = __webpack_require__(64)(5)
    , KEY     = 'find'
    , forced  = true;
  // Shouldn't skip holes
  if(KEY in [])Array(1)[KEY](function(){ forced = false; });
  $export($export.P + $export.F * forced, 'Array', {
    find: function find(callbackfn/*, that = undefined */){
      return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
  __webpack_require__(44)(KEY);

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var ctx         = __webpack_require__(25)
    , $export     = __webpack_require__(1)
    , toObject    = __webpack_require__(32)
    , call        = __webpack_require__(151)
    , isArrayIter = __webpack_require__(148)
    , toLength    = __webpack_require__(16)
    , getIterFn   = __webpack_require__(162);
  $export($export.S + $export.F * !__webpack_require__(96)(function(iter){ Array.from(iter); }), 'Array', {
    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
    from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
      var O       = toObject(arrayLike)
        , C       = typeof this == 'function' ? this : Array
        , $$      = arguments
        , $$len   = $$.length
        , mapfn   = $$len > 1 ? $$[1] : undefined
        , mapping = mapfn !== undefined
        , index   = 0
        , iterFn  = getIterFn(O)
        , length, result, step, iterator;
      if(mapping)mapfn = ctx(mapfn, $$len > 2 ? $$[2] : undefined, 2);
      // if object isn't iterable or it's array with default iterator - use simple case
      if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
        for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
          result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
        }
      } else {
        length = toLength(O.length);
        for(result = new C(length); length > index; index++){
          result[index] = mapping ? mapfn(O[index], index) : O[index];
        }
      }
      result.length = index;
      return result;
    }
  });


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var $export = __webpack_require__(1);
  
  // WebKit Array.of isn't generic
  $export($export.S + $export.F * __webpack_require__(11)(function(){
    function F(){}
    return !(Array.of.call(F) instanceof F);
  }), 'Array', {
    // 22.1.2.3 Array.of( ...items)
    of: function of(/* ...args */){
      var index  = 0
        , $$     = arguments
        , $$len  = $$.length
        , result = new (typeof this == 'function' ? this : Array)($$len);
      while($$len > index)result[index] = $$[index++];
      result.length = $$len;
      return result;
    }
  });

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

  __webpack_require__(71)('Array');

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var $             = __webpack_require__(3)
    , isObject      = __webpack_require__(6)
    , HAS_INSTANCE  = __webpack_require__(8)('hasInstance')
    , FunctionProto = Function.prototype;
  // 19.2.3.6 Function.prototype[@@hasInstance](V)
  if(!(HAS_INSTANCE in FunctionProto))$.setDesc(FunctionProto, HAS_INSTANCE, {value: function(O){
    if(typeof this != 'function' || !isObject(O))return false;
    if(!isObject(this.prototype))return O instanceof this;
    // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
    while(O = $.getProto(O))if(this.prototype === O)return true;
    return false;
  }});

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

  var setDesc    = __webpack_require__(3).setDesc
    , createDesc = __webpack_require__(36)
    , has        = __webpack_require__(15)
    , FProto     = Function.prototype
    , nameRE     = /^\s*function ([^ (]*)/
    , NAME       = 'name';
  // 19.2.4.2 name
  NAME in FProto || __webpack_require__(20) && setDesc(FProto, NAME, {
    configurable: true,
    get: function(){
      var match = ('' + this).match(nameRE)
        , name  = match ? match[1] : '';
      has(this, NAME) || setDesc(this, NAME, createDesc(5, name));
      return name;
    }
  });

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var strong = __webpack_require__(141);
  
  // 23.1 Map Objects
  __webpack_require__(66)('Map', function(get){
    return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
  }, {
    // 23.1.3.6 Map.prototype.get(key)
    get: function get(key){
      var entry = strong.getEntry(this, key);
      return entry && entry.v;
    },
    // 23.1.3.9 Map.prototype.set(key, value)
    set: function set(key, value){
      return strong.def(this, key === 0 ? 0 : key, value);
    }
  }, strong, true);

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

  // 20.2.2.3 Math.acosh(x)
  var $export = __webpack_require__(1)
    , log1p   = __webpack_require__(154)
    , sqrt    = Math.sqrt
    , $acosh  = Math.acosh;
  
  // V8 bug https://code.google.com/p/v8/issues/detail?id=3509
  $export($export.S + $export.F * !($acosh && Math.floor($acosh(Number.MAX_VALUE)) == 710), 'Math', {
    acosh: function acosh(x){
      return (x = +x) < 1 ? NaN : x > 94906265.62425156
        ? Math.log(x) + Math.LN2
        : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
    }
  });

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

  // 20.2.2.5 Math.asinh(x)
  var $export = __webpack_require__(1);
  
  function asinh(x){
    return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
  }
  
  $export($export.S, 'Math', {asinh: asinh});

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

  // 20.2.2.7 Math.atanh(x)
  var $export = __webpack_require__(1);
  
  $export($export.S, 'Math', {
    atanh: function atanh(x){
      return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
    }
  });

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

  // 20.2.2.9 Math.cbrt(x)
  var $export = __webpack_require__(1)
    , sign    = __webpack_require__(99);
  
  $export($export.S, 'Math', {
    cbrt: function cbrt(x){
      return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
    }
  });

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

  // 20.2.2.11 Math.clz32(x)
  var $export = __webpack_require__(1);
  
  $export($export.S, 'Math', {
    clz32: function clz32(x){
      return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
    }
  });

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

  // 20.2.2.12 Math.cosh(x)
  var $export = __webpack_require__(1)
    , exp     = Math.exp;
  
  $export($export.S, 'Math', {
    cosh: function cosh(x){
      return (exp(x = +x) + exp(-x)) / 2;
    }
  });

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

  // 20.2.2.14 Math.expm1(x)
  var $export = __webpack_require__(1);
  
  $export($export.S, 'Math', {expm1: __webpack_require__(98)});

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

  // 20.2.2.16 Math.fround(x)
  var $export   = __webpack_require__(1)
    , sign      = __webpack_require__(99)
    , pow       = Math.pow
    , EPSILON   = pow(2, -52)
    , EPSILON32 = pow(2, -23)
    , MAX32     = pow(2, 127) * (2 - EPSILON32)
    , MIN32     = pow(2, -126);
  
  var roundTiesToEven = function(n){
    return n + 1 / EPSILON - 1 / EPSILON;
  };
  
  
  $export($export.S, 'Math', {
    fround: function fround(x){
      var $abs  = Math.abs(x)
        , $sign = sign(x)
        , a, result;
      if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
      a = (1 + EPSILON32 / EPSILON) * $abs;
      result = a - (a - $abs);
      if(result > MAX32 || result != result)return $sign * Infinity;
      return $sign * result;
    }
  });

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

  // 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
  var $export = __webpack_require__(1)
    , abs     = Math.abs;
  
  $export($export.S, 'Math', {
    hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
      var sum   = 0
        , i     = 0
        , $$    = arguments
        , $$len = $$.length
        , larg  = 0
        , arg, div;
      while(i < $$len){
        arg = abs($$[i++]);
        if(larg < arg){
          div  = larg / arg;
          sum  = sum * div * div + 1;
          larg = arg;
        } else if(arg > 0){
          div  = arg / larg;
          sum += div * div;
        } else sum += arg;
      }
      return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
    }
  });

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

  // 20.2.2.18 Math.imul(x, y)
  var $export = __webpack_require__(1)
    , $imul   = Math.imul;
  
  // some WebKit versions fails with big numbers, some has wrong arity
  $export($export.S + $export.F * __webpack_require__(11)(function(){
    return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
  }), 'Math', {
    imul: function imul(x, y){
      var UINT16 = 0xffff
        , xn = +x
        , yn = +y
        , xl = UINT16 & xn
        , yl = UINT16 & yn;
      return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
    }
  });

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

  // 20.2.2.21 Math.log10(x)
  var $export = __webpack_require__(1);
  
  $export($export.S, 'Math', {
    log10: function log10(x){
      return Math.log(x) / Math.LN10;
    }
  });

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

  // 20.2.2.20 Math.log1p(x)
  var $export = __webpack_require__(1);
  
  $export($export.S, 'Math', {log1p: __webpack_require__(154)});

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

  // 20.2.2.22 Math.log2(x)
  var $export = __webpack_require__(1);
  
  $export($export.S, 'Math', {
    log2: function log2(x){
      return Math.log(x) / Math.LN2;
    }
  });

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

  // 20.2.2.28 Math.sign(x)
  var $export = __webpack_require__(1);
  
  $export($export.S, 'Math', {sign: __webpack_require__(99)});

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

  // 20.2.2.30 Math.sinh(x)
  var $export = __webpack_require__(1)
    , expm1   = __webpack_require__(98)
    , exp     = Math.exp;
  
  // V8 near Chromium 38 has a problem with very small numbers
  $export($export.S + $export.F * __webpack_require__(11)(function(){
    return !Math.sinh(-2e-17) != -2e-17;
  }), 'Math', {
    sinh: function sinh(x){
      return Math.abs(x = +x) < 1
        ? (expm1(x) - expm1(-x)) / 2
        : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
    }
  });

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

  // 20.2.2.33 Math.tanh(x)
  var $export = __webpack_require__(1)
    , expm1   = __webpack_require__(98)
    , exp     = Math.exp;
  
  $export($export.S, 'Math', {
    tanh: function tanh(x){
      var a = expm1(x = +x)
        , b = expm1(-x);
      return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
    }
  });

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

  // 20.2.2.34 Math.trunc(x)
  var $export = __webpack_require__(1);
  
  $export($export.S, 'Math', {
    trunc: function trunc(it){
      return (it > 0 ? Math.floor : Math.ceil)(it);
    }
  });

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var $           = __webpack_require__(3)
    , global      = __webpack_require__(10)
    , has         = __webpack_require__(15)
    , cof         = __webpack_require__(30)
    , toPrimitive = __webpack_require__(278)
    , fails       = __webpack_require__(11)
    , $trim       = __webpack_require__(73).trim
    , NUMBER      = 'Number'
    , $Number     = global[NUMBER]
    , Base        = $Number
    , proto       = $Number.prototype
    // Opera ~12 has broken Object#toString
    , BROKEN_COF  = cof($.create(proto)) == NUMBER
    , TRIM        = 'trim' in String.prototype;
  
  // 7.1.3 ToNumber(argument)
  var toNumber = function(argument){
    var it = toPrimitive(argument, false);
    if(typeof it == 'string' && it.length > 2){
      it = TRIM ? it.trim() : $trim(it, 3);
      var first = it.charCodeAt(0)
        , third, radix, maxCode;
      if(first === 43 || first === 45){
        third = it.charCodeAt(2);
        if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
      } else if(first === 48){
        switch(it.charCodeAt(1)){
          case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
          case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
          default : return +it;
        }
        for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
          code = digits.charCodeAt(i);
          // parseInt parses a string to a first unavailable symbol
          // but ToNumber should return NaN if a string contains unavailable symbols
          if(code < 48 || code > maxCode)return NaN;
        } return parseInt(digits, radix);
      }
    } return +it;
  };
  
  if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
    $Number = function Number(value){
      var it = arguments.length < 1 ? 0 : value
        , that = this;
      return that instanceof $Number
        // check on 1..constructor(foo) case
        && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
          ? new Base(toNumber(it)) : toNumber(it);
    };
    $.each.call(__webpack_require__(20) ? $.getNames(Base) : (
      // ES3:
      'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
      // ES6 (in case, if modules with ES6 Number statics required before):
      'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
      'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
    ).split(','), function(key){
      if(has(Base, key) && !has($Number, key)){
        $.setDesc($Number, key, $.getDesc(Base, key));
      }
    });
    $Number.prototype = proto;
    proto.constructor = $Number;
    __webpack_require__(22)(global, NUMBER, $Number);
  }

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

  // 20.1.2.1 Number.EPSILON
  var $export = __webpack_require__(1);
  
  $export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

  // 20.1.2.2 Number.isFinite(number)
  var $export   = __webpack_require__(1)
    , _isFinite = __webpack_require__(10).isFinite;
  
  $export($export.S, 'Number', {
    isFinite: function isFinite(it){
      return typeof it == 'number' && _isFinite(it);
    }
  });

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

  // 20.1.2.3 Number.isInteger(number)
  var $export = __webpack_require__(1);
  
  $export($export.S, 'Number', {isInteger: __webpack_require__(149)});

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

  // 20.1.2.4 Number.isNaN(number)
  var $export = __webpack_require__(1);
  
  $export($export.S, 'Number', {
    isNaN: function isNaN(number){
      return number != number;
    }
  });

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

  // 20.1.2.5 Number.isSafeInteger(number)
  var $export   = __webpack_require__(1)
    , isInteger = __webpack_require__(149)
    , abs       = Math.abs;
  
  $export($export.S, 'Number', {
    isSafeInteger: function isSafeInteger(number){
      return isInteger(number) && abs(number) <= 0x1fffffffffffff;
    }
  });

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

  // 20.1.2.6 Number.MAX_SAFE_INTEGER
  var $export = __webpack_require__(1);
  
  $export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

  // 20.1.2.10 Number.MIN_SAFE_INTEGER
  var $export = __webpack_require__(1);
  
  $export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

  // 20.1.2.12 Number.parseFloat(string)
  var $export = __webpack_require__(1);
  
  $export($export.S, 'Number', {parseFloat: parseFloat});

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

  // 20.1.2.13 Number.parseInt(string, radix)
  var $export = __webpack_require__(1);
  
  $export($export.S, 'Number', {parseInt: parseInt});

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

  // 19.1.3.1 Object.assign(target, source)
  var $export = __webpack_require__(1);
  
  $export($export.S + $export.F, 'Object', {assign: __webpack_require__(273)});

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

  // 19.1.2.5 Object.freeze(O)
  var isObject = __webpack_require__(6);
  
  __webpack_require__(21)('freeze', function($freeze){
    return function freeze(it){
      return $freeze && isObject(it) ? $freeze(it) : it;
    };
  });

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  var toIObject = __webpack_require__(23);
  
  __webpack_require__(21)('getOwnPropertyDescriptor', function($getOwnPropertyDescriptor){
    return function getOwnPropertyDescriptor(it, key){
      return $getOwnPropertyDescriptor(toIObject(it), key);
    };
  });

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

  // 19.1.2.7 Object.getOwnPropertyNames(O)
  __webpack_require__(21)('getOwnPropertyNames', function(){
    return __webpack_require__(146).get;
  });

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

  // 19.1.2.9 Object.getPrototypeOf(O)
  var toObject = __webpack_require__(32);
  
  __webpack_require__(21)('getPrototypeOf', function($getPrototypeOf){
    return function getPrototypeOf(it){
      return $getPrototypeOf(toObject(it));
    };
  });

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

  // 19.1.2.11 Object.isExtensible(O)
  var isObject = __webpack_require__(6);
  
  __webpack_require__(21)('isExtensible', function($isExtensible){
    return function isExtensible(it){
      return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
    };
  });

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

  // 19.1.2.12 Object.isFrozen(O)
  var isObject = __webpack_require__(6);
  
  __webpack_require__(21)('isFrozen', function($isFrozen){
    return function isFrozen(it){
      return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
    };
  });

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

  // 19.1.2.13 Object.isSealed(O)
  var isObject = __webpack_require__(6);
  
  __webpack_require__(21)('isSealed', function($isSealed){
    return function isSealed(it){
      return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
    };
  });

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

  // 19.1.3.10 Object.is(value1, value2)
  var $export = __webpack_require__(1);
  $export($export.S, 'Object', {is: __webpack_require__(157)});

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

  // 19.1.2.14 Object.keys(O)
  var toObject = __webpack_require__(32);
  
  __webpack_require__(21)('keys', function($keys){
    return function keys(it){
      return $keys(toObject(it));
    };
  });

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

  // 19.1.2.15 Object.preventExtensions(O)
  var isObject = __webpack_require__(6);
  
  __webpack_require__(21)('preventExtensions', function($preventExtensions){
    return function preventExtensions(it){
      return $preventExtensions && isObject(it) ? $preventExtensions(it) : it;
    };
  });

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

  // 19.1.2.17 Object.seal(O)
  var isObject = __webpack_require__(6);
  
  __webpack_require__(21)('seal', function($seal){
    return function seal(it){
      return $seal && isObject(it) ? $seal(it) : it;
    };
  });

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

  // 19.1.3.19 Object.setPrototypeOf(O, proto)
  var $export = __webpack_require__(1);
  $export($export.S, 'Object', {setPrototypeOf: __webpack_require__(100).set});

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  // 19.1.3.6 Object.prototype.toString()
  var classof = __webpack_require__(65)
    , test    = {};
  test[__webpack_require__(8)('toStringTag')] = 'z';
  if(test + '' != '[object z]'){
    __webpack_require__(22)(Object.prototype, 'toString', function toString(){
      return '[object ' + classof(this) + ']';
    }, true);
  }

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var $          = __webpack_require__(3)
    , LIBRARY    = __webpack_require__(97)
    , global     = __webpack_require__(10)
    , ctx        = __webpack_require__(25)
    , classof    = __webpack_require__(65)
    , $export    = __webpack_require__(1)
    , isObject   = __webpack_require__(6)
    , anObject   = __webpack_require__(7)
    , aFunction  = __webpack_require__(43)
    , strictNew  = __webpack_require__(72)
    , forOf      = __webpack_require__(51)
    , setProto   = __webpack_require__(100).set
    , same       = __webpack_require__(157)
    , SPECIES    = __webpack_require__(8)('species')
    , speciesConstructor = __webpack_require__(277)
    , asap       = __webpack_require__(272)
    , PROMISE    = 'Promise'
    , process    = global.process
    , isNode     = classof(process) == 'process'
    , P          = global[PROMISE]
    , Wrapper;
  
  var testResolve = function(sub){
    var test = new P(function(){});
    if(sub)test.constructor = Object;
    return P.resolve(test) === test;
  };
  
  var USE_NATIVE = function(){
    var works = false;
    function P2(x){
      var self = new P(x);
      setProto(self, P2.prototype);
      return self;
    }
    try {
      works = P && P.resolve && testResolve();
      setProto(P2, P);
      P2.prototype = $.create(P.prototype, {constructor: {value: P2}});
      // actual Firefox has broken subclass support, test that
      if(!(P2.resolve(5).then(function(){}) instanceof P2)){
        works = false;
      }
      // actual V8 bug, https://code.google.com/p/v8/issues/detail?id=4162
      if(works && __webpack_require__(20)){
        var thenableThenGotten = false;
        P.resolve($.setDesc({}, 'then', {
          get: function(){ thenableThenGotten = true; }
        }));
        works = thenableThenGotten;
      }
    } catch(e){ works = false; }
    return works;
  }();
  
  // helpers
  var sameConstructor = function(a, b){
    // library wrapper special case
    if(LIBRARY && a === P && b === Wrapper)return true;
    return same(a, b);
  };
  var getConstructor = function(C){
    var S = anObject(C)[SPECIES];
    return S != undefined ? S : C;
  };
  var isThenable = function(it){
    var then;
    return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
  };
  var PromiseCapability = function(C){
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject){
      if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
      resolve = $$resolve;
      reject  = $$reject;
    });
    this.resolve = aFunction(resolve),
    this.reject  = aFunction(reject)
  };
  var perform = function(exec){
    try {
      exec();
    } catch(e){
      return {error: e};
    }
  };
  var notify = function(record, isReject){
    if(record.n)return;
    record.n = true;
    var chain = record.c;
    asap(function(){
      var value = record.v
        , ok    = record.s == 1
        , i     = 0;
      var run = function(reaction){
        var handler = ok ? reaction.ok : reaction.fail
          , resolve = reaction.resolve
          , reject  = reaction.reject
          , result, then;
        try {
          if(handler){
            if(!ok)record.h = true;
            result = handler === true ? value : handler(value);
            if(result === reaction.promise){
              reject(TypeError('Promise-chain cycle'));
            } else if(then = isThenable(result)){
              then.call(result, resolve, reject);
            } else resolve(result);
          } else reject(value);
        } catch(e){
          reject(e);
        }
      };
      while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
      chain.length = 0;
      record.n = false;
      if(isReject)setTimeout(function(){
        var promise = record.p
          , handler, console;
        if(isUnhandled(promise)){
          if(isNode){
            process.emit('unhandledRejection', value, promise);
          } else if(handler = global.onunhandledrejection){
            handler({promise: promise, reason: value});
          } else if((console = global.console) && console.error){
            console.error('Unhandled promise rejection', value);
          }
        } record.a = undefined;
      }, 1);
    });
  };
  var isUnhandled = function(promise){
    var record = promise._d
      , chain  = record.a || record.c
      , i      = 0
      , reaction;
    if(record.h)return false;
    while(chain.length > i){
      reaction = chain[i++];
      if(reaction.fail || !isUnhandled(reaction.promise))return false;
    } return true;
  };
  var $reject = function(value){
    var record = this;
    if(record.d)return;
    record.d = true;
    record = record.r || record; // unwrap
    record.v = value;
    record.s = 2;
    record.a = record.c.slice();
    notify(record, true);
  };
  var $resolve = function(value){
    var record = this
      , then;
    if(record.d)return;
    record.d = true;
    record = record.r || record; // unwrap
    try {
      if(record.p === value)throw TypeError("Promise can't be resolved itself");
      if(then = isThenable(value)){
        asap(function(){
          var wrapper = {r: record, d: false}; // wrap
          try {
            then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
          } catch(e){
            $reject.call(wrapper, e);
          }
        });
      } else {
        record.v = value;
        record.s = 1;
        notify(record, false);
      }
    } catch(e){
      $reject.call({r: record, d: false}, e); // wrap
    }
  };
  
  // constructor polyfill
  if(!USE_NATIVE){
    // 25.4.3.1 Promise(executor)
    P = function Promise(executor){
      aFunction(executor);
      var record = this._d = {
        p: strictNew(this, P, PROMISE),         // <- promise
        c: [],                                  // <- awaiting reactions
        a: undefined,                           // <- checked in isUnhandled reactions
        s: 0,                                   // <- state
        d: false,                               // <- done
        v: undefined,                           // <- value
        h: false,                               // <- handled rejection
        n: false                                // <- notify
      };
      try {
        executor(ctx($resolve, record, 1), ctx($reject, record, 1));
      } catch(err){
        $reject.call(record, err);
      }
    };
    __webpack_require__(70)(P.prototype, {
      // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
      then: function then(onFulfilled, onRejected){
        var reaction = new PromiseCapability(speciesConstructor(this, P))
          , promise  = reaction.promise
          , record   = this._d;
        reaction.ok   = typeof onFulfilled == 'function' ? onFulfilled : true;
        reaction.fail = typeof onRejected == 'function' && onRejected;
        record.c.push(reaction);
        if(record.a)record.a.push(reaction);
        if(record.s)notify(record, false);
        return promise;
      },
      // 25.4.5.1 Promise.prototype.catch(onRejected)
      'catch': function(onRejected){
        return this.then(undefined, onRejected);
      }
    });
  }
  
  $export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: P});
  __webpack_require__(53)(P, PROMISE);
  __webpack_require__(71)(PROMISE);
  Wrapper = __webpack_require__(31)[PROMISE];
  
  // statics
  $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r){
      var capability = new PromiseCapability(this)
        , $$reject   = capability.reject;
      $$reject(r);
      return capability.promise;
    }
  });
  $export($export.S + $export.F * (!USE_NATIVE || testResolve(true)), PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x){
      // instanceof instead of internal slot check because we should fix it without replacement native Promise core
      if(x instanceof P && sameConstructor(x.constructor, this))return x;
      var capability = new PromiseCapability(this)
        , $$resolve  = capability.resolve;
      $$resolve(x);
      return capability.promise;
    }
  });
  $export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(96)(function(iter){
    P.all(iter)['catch'](function(){});
  })), PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable){
      var C          = getConstructor(this)
        , capability = new PromiseCapability(C)
        , resolve    = capability.resolve
        , reject     = capability.reject
        , values     = [];
      var abrupt = perform(function(){
        forOf(iterable, false, values.push, values);
        var remaining = values.length
          , results   = Array(remaining);
        if(remaining)$.each.call(values, function(promise, index){
          var alreadyCalled = false;
          C.resolve(promise).then(function(value){
            if(alreadyCalled)return;
            alreadyCalled = true;
            results[index] = value;
            --remaining || resolve(results);
          }, reject);
        });
        else resolve(results);
      });
      if(abrupt)reject(abrupt.error);
      return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable){
      var C          = getConstructor(this)
        , capability = new PromiseCapability(C)
        , reject     = capability.reject;
      var abrupt = perform(function(){
        forOf(iterable, false, function(promise){
          C.resolve(promise).then(capability.resolve, reject);
        });
      });
      if(abrupt)reject(abrupt.error);
      return capability.promise;
    }
  });

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

  // 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
  var $export = __webpack_require__(1)
    , _apply  = Function.apply;
  
  $export($export.S, 'Reflect', {
    apply: function apply(target, thisArgument, argumentsList){
      return _apply.call(target, thisArgument, argumentsList);
    }
  });

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

  // 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
  var $         = __webpack_require__(3)
    , $export   = __webpack_require__(1)
    , aFunction = __webpack_require__(43)
    , anObject  = __webpack_require__(7)
    , isObject  = __webpack_require__(6)
    , bind      = Function.bind || __webpack_require__(31).Function.prototype.bind;
  
  // MS Edge supports only 2 arguments
  // FF Nightly sets third argument as `new.target`, but does not create `this` from it
  $export($export.S + $export.F * __webpack_require__(11)(function(){
    function F(){}
    return !(Reflect.construct(function(){}, [], F) instanceof F);
  }), 'Reflect', {
    construct: function construct(Target, args /*, newTarget*/){
      aFunction(Target);
      var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
      if(Target == newTarget){
        // w/o altered newTarget, optimization for 0-4 arguments
        if(args != undefined)switch(anObject(args).length){
          case 0: return new Target;
          case 1: return new Target(args[0]);
          case 2: return new Target(args[0], args[1]);
          case 3: return new Target(args[0], args[1], args[2]);
          case 4: return new Target(args[0], args[1], args[2], args[3]);
        }
        // w/o altered newTarget, lot of arguments case
        var $args = [null];
        $args.push.apply($args, args);
        return new (bind.apply(Target, $args));
      }
      // with altered newTarget, not support built-in constructors
      var proto    = newTarget.prototype
        , instance = $.create(isObject(proto) ? proto : Object.prototype)
        , result   = Function.apply.call(Target, instance, args);
      return isObject(result) ? result : instance;
    }
  });

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

  // 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
  var $        = __webpack_require__(3)
    , $export  = __webpack_require__(1)
    , anObject = __webpack_require__(7);
  
  // MS Edge has broken Reflect.defineProperty - throwing instead of returning false
  $export($export.S + $export.F * __webpack_require__(11)(function(){
    Reflect.defineProperty($.setDesc({}, 1, {value: 1}), 1, {value: 2});
  }), 'Reflect', {
    defineProperty: function defineProperty(target, propertyKey, attributes){
      anObject(target);
      try {
        $.setDesc(target, propertyKey, attributes);
        return true;
      } catch(e){
        return false;
      }
    }
  });

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

  // 26.1.4 Reflect.deleteProperty(target, propertyKey)
  var $export  = __webpack_require__(1)
    , getDesc  = __webpack_require__(3).getDesc
    , anObject = __webpack_require__(7);
  
  $export($export.S, 'Reflect', {
    deleteProperty: function deleteProperty(target, propertyKey){
      var desc = getDesc(anObject(target), propertyKey);
      return desc && !desc.configurable ? false : delete target[propertyKey];
    }
  });

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  // 26.1.5 Reflect.enumerate(target)
  var $export  = __webpack_require__(1)
    , anObject = __webpack_require__(7);
  var Enumerate = function(iterated){
    this._t = anObject(iterated); // target
    this._i = 0;                  // next index
    var keys = this._k = []       // keys
      , key;
    for(key in iterated)keys.push(key);
  };
  __webpack_require__(152)(Enumerate, 'Object', function(){
    var that = this
      , keys = that._k
      , key;
    do {
      if(that._i >= keys.length)return {value: undefined, done: true};
    } while(!((key = keys[that._i++]) in that._t));
    return {value: key, done: false};
  });
  
  $export($export.S, 'Reflect', {
    enumerate: function enumerate(target){
      return new Enumerate(target);
    }
  });

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

  // 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
  var $        = __webpack_require__(3)
    , $export  = __webpack_require__(1)
    , anObject = __webpack_require__(7);
  
  $export($export.S, 'Reflect', {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
      return $.getDesc(anObject(target), propertyKey);
    }
  });

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

  // 26.1.8 Reflect.getPrototypeOf(target)
  var $export  = __webpack_require__(1)
    , getProto = __webpack_require__(3).getProto
    , anObject = __webpack_require__(7);
  
  $export($export.S, 'Reflect', {
    getPrototypeOf: function getPrototypeOf(target){
      return getProto(anObject(target));
    }
  });

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

  // 26.1.6 Reflect.get(target, propertyKey [, receiver])
  var $        = __webpack_require__(3)
    , has      = __webpack_require__(15)
    , $export  = __webpack_require__(1)
    , isObject = __webpack_require__(6)
    , anObject = __webpack_require__(7);
  
  function get(target, propertyKey/*, receiver*/){
    var receiver = arguments.length < 3 ? target : arguments[2]
      , desc, proto;
    if(anObject(target) === receiver)return target[propertyKey];
    if(desc = $.getDesc(target, propertyKey))return has(desc, 'value')
      ? desc.value
      : desc.get !== undefined
        ? desc.get.call(receiver)
        : undefined;
    if(isObject(proto = $.getProto(target)))return get(proto, propertyKey, receiver);
  }
  
  $export($export.S, 'Reflect', {get: get});

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

  // 26.1.9 Reflect.has(target, propertyKey)
  var $export = __webpack_require__(1);
  
  $export($export.S, 'Reflect', {
    has: function has(target, propertyKey){
      return propertyKey in target;
    }
  });

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

  // 26.1.10 Reflect.isExtensible(target)
  var $export       = __webpack_require__(1)
    , anObject      = __webpack_require__(7)
    , $isExtensible = Object.isExtensible;
  
  $export($export.S, 'Reflect', {
    isExtensible: function isExtensible(target){
      anObject(target);
      return $isExtensible ? $isExtensible(target) : true;
    }
  });

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

  // 26.1.11 Reflect.ownKeys(target)
  var $export = __webpack_require__(1);
  
  $export($export.S, 'Reflect', {ownKeys: __webpack_require__(156)});

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

  // 26.1.12 Reflect.preventExtensions(target)
  var $export            = __webpack_require__(1)
    , anObject           = __webpack_require__(7)
    , $preventExtensions = Object.preventExtensions;
  
  $export($export.S, 'Reflect', {
    preventExtensions: function preventExtensions(target){
      anObject(target);
      try {
        if($preventExtensions)$preventExtensions(target);
        return true;
      } catch(e){
        return false;
      }
    }
  });

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

  // 26.1.14 Reflect.setPrototypeOf(target, proto)
  var $export  = __webpack_require__(1)
    , setProto = __webpack_require__(100);
  
  if(setProto)$export($export.S, 'Reflect', {
    setPrototypeOf: function setPrototypeOf(target, proto){
      setProto.check(target, proto);
      try {
        setProto.set(target, proto);
        return true;
      } catch(e){
        return false;
      }
    }
  });

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

  // 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
  var $          = __webpack_require__(3)
    , has        = __webpack_require__(15)
    , $export    = __webpack_require__(1)
    , createDesc = __webpack_require__(36)
    , anObject   = __webpack_require__(7)
    , isObject   = __webpack_require__(6);
  
  function set(target, propertyKey, V/*, receiver*/){
    var receiver = arguments.length < 4 ? target : arguments[3]
      , ownDesc  = $.getDesc(anObject(target), propertyKey)
      , existingDescriptor, proto;
    if(!ownDesc){
      if(isObject(proto = $.getProto(target))){
        return set(proto, propertyKey, V, receiver);
      }
      ownDesc = createDesc(0);
    }
    if(has(ownDesc, 'value')){
      if(ownDesc.writable === false || !isObject(receiver))return false;
      existingDescriptor = $.getDesc(receiver, propertyKey) || createDesc(0);
      existingDescriptor.value = V;
      $.setDesc(receiver, propertyKey, existingDescriptor);
      return true;
    }
    return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
  }
  
  $export($export.S, 'Reflect', {set: set});

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

  var $        = __webpack_require__(3)
    , global   = __webpack_require__(10)
    , isRegExp = __webpack_require__(150)
    , $flags   = __webpack_require__(145)
    , $RegExp  = global.RegExp
    , Base     = $RegExp
    , proto    = $RegExp.prototype
    , re1      = /a/g
    , re2      = /a/g
    // "new" creates a new object, old webkit buggy here
    , CORRECT_NEW = new $RegExp(re1) !== re1;
  
  if(__webpack_require__(20) && (!CORRECT_NEW || __webpack_require__(11)(function(){
    re2[__webpack_require__(8)('match')] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
  }))){
    $RegExp = function RegExp(p, f){
      var piRE = isRegExp(p)
        , fiU  = f === undefined;
      return !(this instanceof $RegExp) && piRE && p.constructor === $RegExp && fiU ? p
        : CORRECT_NEW
          ? new Base(piRE && !fiU ? p.source : p, f)
          : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f);
    };
    $.each.call($.getNames(Base), function(key){
      key in $RegExp || $.setDesc($RegExp, key, {
        configurable: true,
        get: function(){ return Base[key]; },
        set: function(it){ Base[key] = it; }
      });
    });
    proto.constructor = $RegExp;
    $RegExp.prototype = proto;
    __webpack_require__(22)(global, 'RegExp', $RegExp);
  }
  
  __webpack_require__(71)('RegExp');

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

  // 21.2.5.3 get RegExp.prototype.flags()
  var $ = __webpack_require__(3);
  if(__webpack_require__(20) && /./g.flags != 'g')$.setDesc(RegExp.prototype, 'flags', {
    configurable: true,
    get: __webpack_require__(145)
  });

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

  // @@match logic
  __webpack_require__(67)('match', 1, function(defined, MATCH){
    // 21.1.3.11 String.prototype.match(regexp)
    return function match(regexp){
      'use strict';
      var O  = defined(this)
        , fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    };
  });

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

  // @@replace logic
  __webpack_require__(67)('replace', 2, function(defined, REPLACE, $replace){
    // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
    return function replace(searchValue, replaceValue){
      'use strict';
      var O  = defined(this)
        , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    };
  });

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

  // @@search logic
  __webpack_require__(67)('search', 1, function(defined, SEARCH){
    // 21.1.3.15 String.prototype.search(regexp)
    return function search(regexp){
      'use strict';
      var O  = defined(this)
        , fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    };
  });

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

  // @@split logic
  __webpack_require__(67)('split', 2, function(defined, SPLIT, $split){
    // 21.1.3.17 String.prototype.split(separator, limit)
    return function split(separator, limit){
      'use strict';
      var O  = defined(this)
        , fn = separator == undefined ? undefined : separator[SPLIT];
      return fn !== undefined
        ? fn.call(separator, O, limit)
        : $split.call(String(O), separator, limit);
    };
  });

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var strong = __webpack_require__(141);
  
  // 23.2 Set Objects
  __webpack_require__(66)('Set', function(get){
    return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
  }, {
    // 23.2.3.1 Set.prototype.add(value)
    add: function add(value){
      return strong.def(this, value = value === 0 ? 0 : value, value);
    }
  }, strong);

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var $export = __webpack_require__(1)
    , $at     = __webpack_require__(101)(false);
  $export($export.P, 'String', {
    // 21.1.3.3 String.prototype.codePointAt(pos)
    codePointAt: function codePointAt(pos){
      return $at(this, pos);
    }
  });

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

  // 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
  'use strict';
  var $export   = __webpack_require__(1)
    , toLength  = __webpack_require__(16)
    , context   = __webpack_require__(102)
    , ENDS_WITH = 'endsWith'
    , $endsWith = ''[ENDS_WITH];
  
  $export($export.P + $export.F * __webpack_require__(93)(ENDS_WITH), 'String', {
    endsWith: function endsWith(searchString /*, endPosition = @length */){
      var that = context(this, searchString, ENDS_WITH)
        , $$   = arguments
        , endPosition = $$.length > 1 ? $$[1] : undefined
        , len    = toLength(that.length)
        , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
        , search = String(searchString);
      return $endsWith
        ? $endsWith.call(that, search, end)
        : that.slice(end - search.length, end) === search;
    }
  });

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

  var $export        = __webpack_require__(1)
    , toIndex        = __webpack_require__(54)
    , fromCharCode   = String.fromCharCode
    , $fromCodePoint = String.fromCodePoint;
  
  // length should be 1, old FF problem
  $export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
    // 21.1.2.2 String.fromCodePoint(...codePoints)
    fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
      var res   = []
        , $$    = arguments
        , $$len = $$.length
        , i     = 0
        , code;
      while($$len > i){
        code = +$$[i++];
        if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
        res.push(code < 0x10000
          ? fromCharCode(code)
          : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
        );
      } return res.join('');
    }
  });

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

  // 21.1.3.7 String.prototype.includes(searchString, position = 0)
  'use strict';
  var $export  = __webpack_require__(1)
    , context  = __webpack_require__(102)
    , INCLUDES = 'includes';
  
  $export($export.P + $export.F * __webpack_require__(93)(INCLUDES), 'String', {
    includes: function includes(searchString /*, position = 0 */){
      return !!~context(this, searchString, INCLUDES)
        .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
    }
  });

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var $at  = __webpack_require__(101)(true);
  
  // 21.1.3.27 String.prototype[@@iterator]()
  __webpack_require__(95)(String, 'String', function(iterated){
    this._t = String(iterated); // target
    this._i = 0;                // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
  }, function(){
    var O     = this._t
      , index = this._i
      , point;
    if(index >= O.length)return {value: undefined, done: true};
    point = $at(O, index);
    this._i += point.length;
    return {value: point, done: false};
  });

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

  var $export   = __webpack_require__(1)
    , toIObject = __webpack_require__(23)
    , toLength  = __webpack_require__(16);
  
  $export($export.S, 'String', {
    // 21.1.2.4 String.raw(callSite, ...substitutions)
    raw: function raw(callSite){
      var tpl   = toIObject(callSite.raw)
        , len   = toLength(tpl.length)
        , $$    = arguments
        , $$len = $$.length
        , res   = []
        , i     = 0;
      while(len > i){
        res.push(String(tpl[i++]));
        if(i < $$len)res.push(String($$[i]));
      } return res.join('');
    }
  });

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

  var $export = __webpack_require__(1);
  
  $export($export.P, 'String', {
    // 21.1.3.13 String.prototype.repeat(count)
    repeat: __webpack_require__(160)
  });

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

  // 21.1.3.18 String.prototype.startsWith(searchString [, position ])
  'use strict';
  var $export     = __webpack_require__(1)
    , toLength    = __webpack_require__(16)
    , context     = __webpack_require__(102)
    , STARTS_WITH = 'startsWith'
    , $startsWith = ''[STARTS_WITH];
  
  $export($export.P + $export.F * __webpack_require__(93)(STARTS_WITH), 'String', {
    startsWith: function startsWith(searchString /*, position = 0 */){
      var that   = context(this, searchString, STARTS_WITH)
        , $$     = arguments
        , index  = toLength(Math.min($$.length > 1 ? $$[1] : undefined, that.length))
        , search = String(searchString);
      return $startsWith
        ? $startsWith.call(that, search, index)
        : that.slice(index, index + search.length) === search;
    }
  });

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  // 21.1.3.25 String.prototype.trim()
  __webpack_require__(73)('trim', function($trim){
    return function trim(){
      return $trim(this, 3);
    };
  });

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  // ECMAScript 6 symbols shim
  var $              = __webpack_require__(3)
    , global         = __webpack_require__(10)
    , has            = __webpack_require__(15)
    , DESCRIPTORS    = __webpack_require__(20)
    , $export        = __webpack_require__(1)
    , redefine       = __webpack_require__(22)
    , $fails         = __webpack_require__(11)
    , shared         = __webpack_require__(158)
    , setToStringTag = __webpack_require__(53)
    , uid            = __webpack_require__(45)
    , wks            = __webpack_require__(8)
    , keyOf          = __webpack_require__(271)
    , $names         = __webpack_require__(146)
    , enumKeys       = __webpack_require__(270)
    , isArray        = __webpack_require__(94)
    , anObject       = __webpack_require__(7)
    , toIObject      = __webpack_require__(23)
    , createDesc     = __webpack_require__(36)
    , getDesc        = $.getDesc
    , setDesc        = $.setDesc
    , _create        = $.create
    , getNames       = $names.get
    , $Symbol        = global.Symbol
    , $JSON          = global.JSON
    , _stringify     = $JSON && $JSON.stringify
    , setter         = false
    , HIDDEN         = wks('_hidden')
    , isEnum         = $.isEnum
    , SymbolRegistry = shared('symbol-registry')
    , AllSymbols     = shared('symbols')
    , useNative      = typeof $Symbol == 'function'
    , ObjectProto    = Object.prototype;
  
  // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
  var setSymbolDesc = DESCRIPTORS && $fails(function(){
    return _create(setDesc({}, 'a', {
      get: function(){ return setDesc(this, 'a', {value: 7}).a; }
    })).a != 7;
  }) ? function(it, key, D){
    var protoDesc = getDesc(ObjectProto, key);
    if(protoDesc)delete ObjectProto[key];
    setDesc(it, key, D);
    if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
  } : setDesc;
  
  var wrap = function(tag){
    var sym = AllSymbols[tag] = _create($Symbol.prototype);
    sym._k = tag;
    DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
      configurable: true,
      set: function(value){
        if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
        setSymbolDesc(this, tag, createDesc(1, value));
      }
    });
    return sym;
  };
  
  var isSymbol = function(it){
    return typeof it == 'symbol';
  };
  
  var $defineProperty = function defineProperty(it, key, D){
    if(D && has(AllSymbols, key)){
      if(!D.enumerable){
        if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
        it[HIDDEN][key] = true;
      } else {
        if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
        D = _create(D, {enumerable: createDesc(0, false)});
      } return setSymbolDesc(it, key, D);
    } return setDesc(it, key, D);
  };
  var $defineProperties = function defineProperties(it, P){
    anObject(it);
    var keys = enumKeys(P = toIObject(P))
      , i    = 0
      , l = keys.length
      , key;
    while(l > i)$defineProperty(it, key = keys[i++], P[key]);
    return it;
  };
  var $create = function create(it, P){
    return P === undefined ? _create(it) : $defineProperties(_create(it), P);
  };
  var $propertyIsEnumerable = function propertyIsEnumerable(key){
    var E = isEnum.call(this, key);
    return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
      ? E : true;
  };
  var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
    var D = getDesc(it = toIObject(it), key);
    if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
    return D;
  };
  var $getOwnPropertyNames = function getOwnPropertyNames(it){
    var names  = getNames(toIObject(it))
      , result = []
      , i      = 0
      , key;
    while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN)result.push(key);
    return result;
  };
  var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
    var names  = getNames(toIObject(it))
      , result = []
      , i      = 0
      , key;
    while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
    return result;
  };
  var $stringify = function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , $$   = arguments
      , replacer, $replacer;
    while($$.length > i)args.push($$[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  };
  var buggyJSON = $fails(function(){
    var S = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
  });
  
  // 19.4.1.1 Symbol([description])
  if(!useNative){
    $Symbol = function Symbol(){
      if(isSymbol(this))throw TypeError('Symbol is not a constructor');
      return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
    };
    redefine($Symbol.prototype, 'toString', function toString(){
      return this._k;
    });
  
    isSymbol = function(it){
      return it instanceof $Symbol;
    };
  
    $.create     = $create;
    $.isEnum     = $propertyIsEnumerable;
    $.getDesc    = $getOwnPropertyDescriptor;
    $.setDesc    = $defineProperty;
    $.setDescs   = $defineProperties;
    $.getNames   = $names.get = $getOwnPropertyNames;
    $.getSymbols = $getOwnPropertySymbols;
  
    if(DESCRIPTORS && !__webpack_require__(97)){
      redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
    }
  }
  
  var symbolStatics = {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key){
      return has(SymbolRegistry, key += '')
        ? SymbolRegistry[key]
        : SymbolRegistry[key] = $Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(key){
      return keyOf(SymbolRegistry, key);
    },
    useSetter: function(){ setter = true; },
    useSimple: function(){ setter = false; }
  };
  // 19.4.2.2 Symbol.hasInstance
  // 19.4.2.3 Symbol.isConcatSpreadable
  // 19.4.2.4 Symbol.iterator
  // 19.4.2.6 Symbol.match
  // 19.4.2.8 Symbol.replace
  // 19.4.2.9 Symbol.search
  // 19.4.2.10 Symbol.species
  // 19.4.2.11 Symbol.split
  // 19.4.2.12 Symbol.toPrimitive
  // 19.4.2.13 Symbol.toStringTag
  // 19.4.2.14 Symbol.unscopables
  $.each.call((
    'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
    'species,split,toPrimitive,toStringTag,unscopables'
  ).split(','), function(it){
    var sym = wks(it);
    symbolStatics[it] = useNative ? sym : wrap(sym);
  });
  
  setter = true;
  
  $export($export.G + $export.W, {Symbol: $Symbol});
  
  $export($export.S, 'Symbol', symbolStatics);
  
  $export($export.S + $export.F * !useNative, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $getOwnPropertySymbols
  });
  
  // 24.3.2 JSON.stringify(value [, replacer [, space]])
  $JSON && $export($export.S + $export.F * (!useNative || buggyJSON), 'JSON', {stringify: $stringify});
  
  // 19.4.3.5 Symbol.prototype[@@toStringTag]
  setToStringTag($Symbol, 'Symbol');
  // 20.2.1.9 Math[@@toStringTag]
  setToStringTag(Math, 'Math', true);
  // 24.3.3 JSON[@@toStringTag]
  setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var $            = __webpack_require__(3)
    , redefine     = __webpack_require__(22)
    , weak         = __webpack_require__(143)
    , isObject     = __webpack_require__(6)
    , has          = __webpack_require__(15)
    , frozenStore  = weak.frozenStore
    , WEAK         = weak.WEAK
    , isExtensible = Object.isExtensible || isObject
    , tmp          = {};
  
  // 23.3 WeakMap Objects
  var $WeakMap = __webpack_require__(66)('WeakMap', function(get){
    return function WeakMap(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
  }, {
    // 23.3.3.3 WeakMap.prototype.get(key)
    get: function get(key){
      if(isObject(key)){
        if(!isExtensible(key))return frozenStore(this).get(key);
        if(has(key, WEAK))return key[WEAK][this._i];
      }
    },
    // 23.3.3.5 WeakMap.prototype.set(key, value)
    set: function set(key, value){
      return weak.def(this, key, value);
    }
  }, weak, true, true);
  
  // IE11 WeakMap frozen keys fix
  if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
    $.each.call(['delete', 'has', 'get', 'set'], function(key){
      var proto  = $WeakMap.prototype
        , method = proto[key];
      redefine(proto, key, function(a, b){
        // store frozen objects on leaky map
        if(isObject(a) && !isExtensible(a)){
          var result = frozenStore(this)[key](a, b);
          return key == 'set' ? this : result;
        // store all the rest on native weakmap
        } return method.call(this, a, b);
      });
    });
  }

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var weak = __webpack_require__(143);
  
  // 23.4 WeakSet Objects
  __webpack_require__(66)('WeakSet', function(get){
    return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
  }, {
    // 23.4.3.1 WeakSet.prototype.add(value)
    add: function add(value){
      return weak.def(this, value, true);
    }
  }, weak, false, true);

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var $export   = __webpack_require__(1)
    , $includes = __webpack_require__(140)(true);
  
  $export($export.P, 'Array', {
    // https://github.com/domenic/Array.prototype.includes
    includes: function includes(el /*, fromIndex = 0 */){
      return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
  
  __webpack_require__(44)('includes');

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

  // https://github.com/DavidBruant/Map-Set.prototype.toJSON
  var $export  = __webpack_require__(1);
  
  $export($export.P, 'Map', {toJSON: __webpack_require__(142)('Map')});

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

  // http://goo.gl/XkBrjD
  var $export  = __webpack_require__(1)
    , $entries = __webpack_require__(155)(true);
  
  $export($export.S, 'Object', {
    entries: function entries(it){
      return $entries(it);
    }
  });

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

  // https://gist.github.com/WebReflection/9353781
  var $          = __webpack_require__(3)
    , $export    = __webpack_require__(1)
    , ownKeys    = __webpack_require__(156)
    , toIObject  = __webpack_require__(23)
    , createDesc = __webpack_require__(36);
  
  $export($export.S, 'Object', {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
      var O       = toIObject(object)
        , setDesc = $.setDesc
        , getDesc = $.getDesc
        , keys    = ownKeys(O)
        , result  = {}
        , i       = 0
        , key, D;
      while(keys.length > i){
        D = getDesc(O, key = keys[i++]);
        if(key in result)setDesc(result, key, createDesc(0, D));
        else result[key] = D;
      } return result;
    }
  });

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

  // http://goo.gl/XkBrjD
  var $export = __webpack_require__(1)
    , $values = __webpack_require__(155)(false);
  
  $export($export.S, 'Object', {
    values: function values(it){
      return $values(it);
    }
  });

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

  // https://github.com/benjamingr/RexExp.escape
  var $export = __webpack_require__(1)
    , $re     = __webpack_require__(276)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
  
  $export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

  // https://github.com/DavidBruant/Map-Set.prototype.toJSON
  var $export  = __webpack_require__(1);
  
  $export($export.P, 'Set', {toJSON: __webpack_require__(142)('Set')});

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  // https://github.com/mathiasbynens/String.prototype.at
  var $export = __webpack_require__(1)
    , $at     = __webpack_require__(101)(true);
  
  $export($export.P, 'String', {
    at: function at(pos){
      return $at(this, pos);
    }
  });

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var $export = __webpack_require__(1)
    , $pad    = __webpack_require__(159);
  
  $export($export.P, 'String', {
    padLeft: function padLeft(maxLength /*, fillString = ' ' */){
      return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
    }
  });

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  var $export = __webpack_require__(1)
    , $pad    = __webpack_require__(159);
  
  $export($export.P, 'String', {
    padRight: function padRight(maxLength /*, fillString = ' ' */){
      return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
    }
  });

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  // https://github.com/sebmarkbage/ecmascript-string-left-right-trim
  __webpack_require__(73)('trimLeft', function($trim){
    return function trimLeft(){
      return $trim(this, 1);
    };
  });

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

  'use strict';
  // https://github.com/sebmarkbage/ecmascript-string-left-right-trim
  __webpack_require__(73)('trimRight', function($trim){
    return function trimRight(){
      return $trim(this, 2);
    };
  });

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

  // JavaScript 1.6 / Strawman array statics shim
  var $       = __webpack_require__(3)
    , $export = __webpack_require__(1)
    , $ctx    = __webpack_require__(25)
    , $Array  = __webpack_require__(31).Array || Array
    , statics = {};
  var setStatics = function(keys, length){
    $.each.call(keys.split(','), function(key){
      if(length == undefined && key in $Array)statics[key] = $Array[key];
      else if(key in [])statics[key] = $ctx(Function.call, [][key], length);
    });
  };
  setStatics('pop,reverse,shift,keys,values,entries', 1);
  setStatics('indexOf,every,some,forEach,map,filter,find,findIndex,includes', 3);
  setStatics('join,slice,concat,push,splice,unshift,sort,lastIndexOf,' +
             'reduce,reduceRight,copyWithin,fill');
  $export($export.S, 'Array', statics);

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

  __webpack_require__(163);
  var global      = __webpack_require__(10)
    , hide        = __webpack_require__(27)
    , Iterators   = __webpack_require__(52)
    , ITERATOR    = __webpack_require__(8)('iterator')
    , NL          = global.NodeList
    , HTC         = global.HTMLCollection
    , NLProto     = NL && NL.prototype
    , HTCProto    = HTC && HTC.prototype
    , ArrayValues = Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;
  if(NLProto && !NLProto[ITERATOR])hide(NLProto, ITERATOR, ArrayValues);
  if(HTCProto && !HTCProto[ITERATOR])hide(HTCProto, ITERATOR, ArrayValues);

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

  var $export = __webpack_require__(1)
    , $task   = __webpack_require__(161);
  $export($export.G + $export.B, {
    setImmediate:   $task.set,
    clearImmediate: $task.clear
  });

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

  // ie9- setTimeout & setInterval additional parameters fix
  var global     = __webpack_require__(10)
    , $export    = __webpack_require__(1)
    , invoke     = __webpack_require__(68)
    , partial    = __webpack_require__(274)
    , navigator  = global.navigator
    , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
  var wrap = function(set){
    return MSIE ? function(fn, time /*, ...args */){
      return set(invoke(
        partial,
        [].slice.call(arguments, 2),
        typeof fn == 'function' ? fn : Function(fn)
      ), time);
    } : set;
  };
  $export($export.G + $export.B + $export.F * MSIE, {
    setTimeout:  wrap(global.setTimeout),
    setInterval: wrap(global.setInterval)
  });

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

  __webpack_require__(279);
  __webpack_require__(362);
  __webpack_require__(317);
  __webpack_require__(325);
  __webpack_require__(329);
  __webpack_require__(330);
  __webpack_require__(318);
  __webpack_require__(328);
  __webpack_require__(327);
  __webpack_require__(323);
  __webpack_require__(324);
  __webpack_require__(322);
  __webpack_require__(319);
  __webpack_require__(321);
  __webpack_require__(326);
  __webpack_require__(320);
  __webpack_require__(288);
  __webpack_require__(287);
  __webpack_require__(307);
  __webpack_require__(308);
  __webpack_require__(309);
  __webpack_require__(310);
  __webpack_require__(311);
  __webpack_require__(312);
  __webpack_require__(313);
  __webpack_require__(314);
  __webpack_require__(315);
  __webpack_require__(316);
  __webpack_require__(290);
  __webpack_require__(291);
  __webpack_require__(292);
  __webpack_require__(293);
  __webpack_require__(294);
  __webpack_require__(295);
  __webpack_require__(296);
  __webpack_require__(297);
  __webpack_require__(298);
  __webpack_require__(299);
  __webpack_require__(300);
  __webpack_require__(301);
  __webpack_require__(302);
  __webpack_require__(303);
  __webpack_require__(304);
  __webpack_require__(305);
  __webpack_require__(306);
  __webpack_require__(355);
  __webpack_require__(358);
  __webpack_require__(361);
  __webpack_require__(357);
  __webpack_require__(353);
  __webpack_require__(354);
  __webpack_require__(356);
  __webpack_require__(359);
  __webpack_require__(360);
  __webpack_require__(284);
  __webpack_require__(285);
  __webpack_require__(163);
  __webpack_require__(286);
  __webpack_require__(280);
  __webpack_require__(281);
  __webpack_require__(283);
  __webpack_require__(282);
  __webpack_require__(346);
  __webpack_require__(347);
  __webpack_require__(348);
  __webpack_require__(349);
  __webpack_require__(350);
  __webpack_require__(351);
  __webpack_require__(331);
  __webpack_require__(289);
  __webpack_require__(352);
  __webpack_require__(363);
  __webpack_require__(364);
  __webpack_require__(332);
  __webpack_require__(333);
  __webpack_require__(334);
  __webpack_require__(335);
  __webpack_require__(336);
  __webpack_require__(339);
  __webpack_require__(337);
  __webpack_require__(338);
  __webpack_require__(340);
  __webpack_require__(341);
  __webpack_require__(342);
  __webpack_require__(343);
  __webpack_require__(345);
  __webpack_require__(344);
  __webpack_require__(365);
  __webpack_require__(372);
  __webpack_require__(373);
  __webpack_require__(374);
  __webpack_require__(375);
  __webpack_require__(376);
  __webpack_require__(370);
  __webpack_require__(368);
  __webpack_require__(369);
  __webpack_require__(367);
  __webpack_require__(366);
  __webpack_require__(371);
  __webpack_require__(377);
  __webpack_require__(380);
  __webpack_require__(379);
  __webpack_require__(378);
  module.exports = __webpack_require__(31);

/***/ },
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */
/***/ function(module, exports, __webpack_require__) {

  exports = module.exports = __webpack_require__(389)();
  // imports
  
  
  // module
  exports.push([module.id, "/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}", ""]);
  
  // exports


/***/ },
/* 389 */
/***/ function(module, exports) {

  /*
  	MIT License http://www.opensource.org/licenses/mit-license.php
  	Author Tobias Koppers @sokra
  */
  // css base code, injected by the css-loader
  module.exports = function() {
  	var list = [];
  
  	// return the list of modules as css string
  	list.toString = function toString() {
  		var result = [];
  		for(var i = 0; i < this.length; i++) {
  			var item = this[i];
  			if(item[2]) {
  				result.push("@media " + item[2] + "{" + item[1] + "}");
  			} else {
  				result.push(item[1]);
  			}
  		}
  		return result.join("");
  	};
  
  	// import a list of modules into the list
  	list.i = function(modules, mediaQuery) {
  		if(typeof modules === "string")
  			modules = [[null, modules, ""]];
  		var alreadyImportedModules = {};
  		for(var i = 0; i < this.length; i++) {
  			var id = this[i][0];
  			if(typeof id === "number")
  				alreadyImportedModules[id] = true;
  		}
  		for(i = 0; i < modules.length; i++) {
  			var item = modules[i];
  			// skip already imported module
  			// this implementation is not 100% perfect for weird media query combinations
  			//  when a module is imported multiple times with different media queries.
  			//  I hope this will never occur (Hey this way we have smaller bundles)
  			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
  				if(mediaQuery && !item[2]) {
  					item[2] = mediaQuery;
  				} else if(mediaQuery) {
  					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
  				}
  				list.push(item);
  			}
  		}
  	};
  	return list;
  };


/***/ },
/* 390 */
/***/ function(module, exports) {

  // removed by extract-text-webpack-plugin
  module.exports = {"Grid":"_1zACjP8zZJiFiw1TljRkLx","row":"_3lOEIl3C5hzcf2CwJNHq78","cell":"_21eKr11DF3Vs5G5_skG-U1"};

/***/ },
/* 391 */
/***/ function(module, exports) {

  // removed by extract-text-webpack-plugin
  module.exports = {"Layout":"_3XKyj8WgQ9s0ebWd1kQ9tk","Description":"_1toYIzgteb24dBQXVD-kK8","Title":"_3Lc__9kkC3pQ3mogZQnDEw","scores":"_1uiKmFqbxZFBZWWpuZB9Gk"};

/***/ },
/* 392 */
/***/ function(module, exports) {

  // removed by extract-text-webpack-plugin
  module.exports = {"Tile":"_1apu6Sou8bTaIe-ehpxUeR","inner":"_3srUT7-vtDNRpoM1DCWXOf","value-2":"_1P4PWA5-R9o8xWvLKMwNCX","value-4":"_1p6IwLEQHn7R0iBF7gy1ZN","value-8":"mS-iTF6B8ZkMNp4pRZw_q","value-16":"Ciq4EH4eS2f1OJdSRzqGK","value-32":"_2pXqm3LELbr1TVAk9pWW_o","value-64":"_12L2BAVOj-PsXqYQTefsc3","value-128":"_2gd-6mnLQVOv8zGQD7VNcK","value-256":"_1CTu7s3xz6kf4KMiCt__KW","value-512":"_3UUxwUTxHe-4y2D_biQ4SN","value-1024":"SCEMnugM3AgMGfbAmWncO","value-2048":"qtpauSjTBUQWPcryDHf1g","value-super":"_1Nj5sO0QIdEwgVUGhEhSjj"};

/***/ },
/* 393 */
/***/ function(module, exports) {

  // removed by extract-text-webpack-plugin
  module.exports = {"Tiles":"v5ma4IQgDPxgngxDc70mk"};

/***/ },
/* 394 */
/***/ function(module, exports) {

  // removed by extract-text-webpack-plugin
  module.exports = {"Game":"_1J0YO6JsdcSy5QCIsyWvNx"};

/***/ },
/* 395 */
/***/ function(module, exports) {

  // removed by extract-text-webpack-plugin
  module.exports = {"Message":"Tbivx-jvypoO6ME5tXX0s"};

/***/ },
/* 396 */
/***/ function(module, exports) {

  // removed by extract-text-webpack-plugin
  module.exports = {"NewGameButton":"_3q35joUF9_VN1dzZnIlP1h"};

/***/ },
/* 397 */
/***/ function(module, exports) {

  // removed by extract-text-webpack-plugin
  module.exports = {"Score":"Qe_FtbGO35oWy_pIj4qk_","title":"VURh4_WpaEm0xn8DVHUc-","value":"_1UcmNV5rdd87CX_KRDcwCN"};

/***/ },
/* 398 */
/***/ function(module, exports) {

  // removed by extract-text-webpack-plugin

/***/ },
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */
/***/ function(module, exports, __webpack_require__) {

  var nativeCreate = __webpack_require__(78);
  
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  
  /**
   * Creates an hash object.
   *
   * @private
   * @constructor
   * @returns {Object} Returns the new hash object.
   */
  function Hash() {}
  
  // Avoid inheriting from `Object.prototype` when possible.
  Hash.prototype = nativeCreate ? nativeCreate(null) : objectProto;
  
  module.exports = Hash;


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

  var mapClear = __webpack_require__(461),
      mapDelete = __webpack_require__(462),
      mapGet = __webpack_require__(463),
      mapHas = __webpack_require__(464),
      mapSet = __webpack_require__(465);
  
  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [values] The values to cache.
   */
  function MapCache(values) {
    var index = -1,
        length = values ? values.length : 0;
  
    this.clear();
    while (++index < length) {
      var entry = values[index];
      this.set(entry[0], entry[1]);
    }
  }
  
  // Add functions to the `MapCache`.
  MapCache.prototype.clear = mapClear;
  MapCache.prototype['delete'] = mapDelete;
  MapCache.prototype.get = mapGet;
  MapCache.prototype.has = mapHas;
  MapCache.prototype.set = mapSet;
  
  module.exports = MapCache;


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

  var root = __webpack_require__(37);
  
  /** Built-in value references. */
  var Reflect = root.Reflect;
  
  module.exports = Reflect;


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

  var getNative = __webpack_require__(76),
      root = __webpack_require__(37);
  
  /* Built-in method references that are verified to be native. */
  var Set = getNative(root, 'Set');
  
  module.exports = Set;


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

  var root = __webpack_require__(37);
  
  /** Built-in value references. */
  var Uint8Array = root.Uint8Array;
  
  module.exports = Uint8Array;


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

  var getNative = __webpack_require__(76),
      root = __webpack_require__(37);
  
  /* Built-in method references that are verified to be native. */
  var WeakMap = getNative(root, 'WeakMap');
  
  module.exports = WeakMap;


/***/ },
/* 421 */
/***/ function(module, exports) {

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    map.set(pair[0], pair[1]);
    return map;
  }
  
  module.exports = addMapEntry;


/***/ },
/* 422 */
/***/ function(module, exports) {

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    set.add(value);
    return set;
  }
  
  module.exports = addSetEntry;


/***/ },
/* 423 */
/***/ function(module, exports) {

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {...*} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    var length = args.length;
    switch (length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }
  
  module.exports = apply;


/***/ },
/* 424 */
/***/ function(module, exports) {

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array.length,
        result = Array(length);
  
    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }
  
  module.exports = arrayMap;


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

  var copyObject = __webpack_require__(104),
      keys = __webpack_require__(109);
  
  /**
   * The base implementation of `_.assign` without support for multiple sources
   * or `customizer` functions.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @returns {Object} Returns `object`.
   */
  function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
  }
  
  module.exports = baseAssign;


/***/ },
/* 426 */
/***/ function(module, exports) {

  /**
   * The base implementation of `_.clamp` which doesn't coerce arguments to numbers.
   *
   * @private
   * @param {number} number The number to clamp.
   * @param {number} [lower] The lower bound.
   * @param {number} upper The upper bound.
   * @returns {number} Returns the clamped number.
   */
  function baseClamp(number, lower, upper) {
    if (number === number) {
      if (upper !== undefined) {
        number = number <= upper ? number : upper;
      }
      if (lower !== undefined) {
        number = number >= lower ? number : lower;
      }
    }
    return number;
  }
  
  module.exports = baseClamp;


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

  var Stack = __webpack_require__(172),
      arrayEach = __webpack_require__(174),
      assignValue = __webpack_require__(177),
      baseAssign = __webpack_require__(425),
      baseForOwn = __webpack_require__(430),
      cloneBuffer = __webpack_require__(442),
      copyArray = __webpack_require__(103),
      copySymbols = __webpack_require__(449),
      getTag = __webpack_require__(183),
      initCloneArray = __webpack_require__(458),
      initCloneByTag = __webpack_require__(459),
      initCloneObject = __webpack_require__(460),
      isArray = __webpack_require__(57),
      isBuffer = __webpack_require__(473),
      isHostObject = __webpack_require__(105),
      isObject = __webpack_require__(38);
  
  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      weakMapTag = '[object WeakMap]';
  
  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';
  
  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
  cloneableTags[dateTag] = cloneableTags[float32Tag] =
  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
  cloneableTags[mapTag] = cloneableTags[numberTag] =
  cloneableTags[objectTag] = cloneableTags[regexpTag] =
  cloneableTags[setTag] = cloneableTags[stringTag] =
  cloneableTags[symbolTag] = cloneableTags[uint8Tag] =
  cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] =
  cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;
  
  /**
   * The base implementation of `_.clone` and `_.cloneDeep` which tracks
   * traversed objects.
   *
   * @private
   * @param {*} value The value to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @param {Function} [customizer] The function to customize cloning.
   * @param {string} [key] The key of `value`.
   * @param {Object} [object] The parent object of `value`.
   * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
   * @returns {*} Returns the cloned value.
   */
  function baseClone(value, isDeep, customizer, key, object, stack) {
    var result;
    if (customizer) {
      result = object ? customizer(value, key, object, stack) : customizer(value);
    }
    if (result !== undefined) {
      return result;
    }
    if (!isObject(value)) {
      return value;
    }
    var isArr = isArray(value);
    if (isArr) {
      result = initCloneArray(value);
      if (!isDeep) {
        return copyArray(value, result);
      }
    } else {
      var tag = getTag(value),
          isFunc = tag == funcTag || tag == genTag;
  
      if (isBuffer(value)) {
        return cloneBuffer(value, isDeep);
      }
      if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
        if (isHostObject(value)) {
          return object ? value : {};
        }
        result = initCloneObject(isFunc ? {} : value);
        if (!isDeep) {
          return copySymbols(value, baseAssign(result, value));
        }
      } else {
        if (!cloneableTags[tag]) {
          return object ? value : {};
        }
        result = initCloneByTag(value, tag, isDeep);
      }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) {
      return stacked;
    }
    stack.set(value, result);
  
    // Recursively populate clone (susceptible to call stack limits).
    (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
      assignValue(result, key, baseClone(subValue, isDeep, customizer, key, value, stack));
    });
    return isArr ? result : copySymbols(value, result);
  }
  
  module.exports = baseClone;


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

  var isObject = __webpack_require__(38);
  
  /** Built-in value references. */
  var objectCreate = Object.create;
  
  /**
   * The base implementation of `_.create` without support for assigning
   * properties to the created object.
   *
   * @private
   * @param {Object} prototype The object to inherit from.
   * @returns {Object} Returns the new object.
   */
  function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
  }
  
  module.exports = baseCreate;


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

  var createBaseFor = __webpack_require__(451);
  
  /**
   * The base implementation of `baseForIn` and `baseForOwn` which iterates
   * over `object` properties returned by `keysFunc` invoking `iteratee` for
   * each property. Iteratee functions may exit iteration early by explicitly
   * returning `false`.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @returns {Object} Returns `object`.
   */
  var baseFor = createBaseFor();
  
  module.exports = baseFor;


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

  var baseFor = __webpack_require__(429),
      keys = __webpack_require__(109);
  
  /**
   * The base implementation of `_.forOwn` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Object} Returns `object`.
   */
  function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
  }
  
  module.exports = baseForOwn;


/***/ },
/* 431 */
/***/ function(module, exports) {

  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  
  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;
  
  /** Built-in value references. */
  var getPrototypeOf = Object.getPrototypeOf;
  
  /**
   * The base implementation of `_.has` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} key The key to check.
   * @returns {boolean} Returns `true` if `key` exists, else `false`.
   */
  function baseHas(object, key) {
    // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
    // that are composed entirely of index properties, return `false` for
    // `hasOwnProperty` checks of them.
    return hasOwnProperty.call(object, key) ||
      (typeof object == 'object' && key in object && getPrototypeOf(object) === null);
  }
  
  module.exports = baseHas;


/***/ },
/* 432 */
/***/ function(module, exports) {

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeKeys = Object.keys;
  
  /**
   * The base implementation of `_.keys` which doesn't skip the constructor
   * property of prototypes or treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeys(object) {
    return nativeKeys(Object(object));
  }
  
  module.exports = baseKeys;


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

  var Reflect = __webpack_require__(417),
      iteratorToArray = __webpack_require__(187);
  
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  
  /** Built-in value references. */
  var enumerate = Reflect ? Reflect.enumerate : undefined,
      propertyIsEnumerable = objectProto.propertyIsEnumerable;
  
  /**
   * The base implementation of `_.keysIn` which doesn't skip the constructor
   * property of prototypes or treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeysIn(object) {
    object = object == null ? object : Object(object);
  
    var result = [];
    for (var key in object) {
      result.push(key);
    }
    return result;
  }
  
  // Fallback for IE < 9 with es6-shim.
  if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
    baseKeysIn = function(object) {
      return iteratorToArray(enumerate(object));
    };
  }
  
  module.exports = baseKeysIn;


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

  var Stack = __webpack_require__(172),
      arrayEach = __webpack_require__(174),
      assignMergeValue = __webpack_require__(176),
      baseMergeDeep = __webpack_require__(435),
      isArray = __webpack_require__(57),
      isObject = __webpack_require__(38),
      isTypedArray = __webpack_require__(193),
      keysIn = __webpack_require__(194);
  
  /**
   * The base implementation of `_.merge` without support for multiple sources.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @param {number} srcIndex The index of `source`.
   * @param {Function} [customizer] The function to customize merged values.
   * @param {Object} [stack] Tracks traversed source values and their merged counterparts.
   */
  function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) {
      return;
    }
    var props = (isArray(source) || isTypedArray(source))
      ? undefined
      : keysIn(source);
  
    arrayEach(props || source, function(srcValue, key) {
      if (props) {
        key = srcValue;
        srcValue = source[key];
      }
      if (isObject(srcValue)) {
        stack || (stack = new Stack);
        baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
      }
      else {
        var newValue = customizer
          ? customizer(object[key], srcValue, (key + ''), object, source, stack)
          : undefined;
  
        if (newValue === undefined) {
          newValue = srcValue;
        }
        assignMergeValue(object, key, newValue);
      }
    });
  }
  
  module.exports = baseMerge;


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

  var assignMergeValue = __webpack_require__(176),
      baseClone = __webpack_require__(427),
      copyArray = __webpack_require__(103),
      isArguments = __webpack_require__(190),
      isArray = __webpack_require__(57),
      isArrayLikeObject = __webpack_require__(191),
      isFunction = __webpack_require__(47),
      isObject = __webpack_require__(38),
      isPlainObject = __webpack_require__(82),
      isTypedArray = __webpack_require__(193),
      toPlainObject = __webpack_require__(479);
  
  /**
   * A specialized version of `baseMerge` for arrays and objects which performs
   * deep merges and tracks traversed objects enabling objects with circular
   * references to be merged.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @param {string} key The key of the value to merge.
   * @param {number} srcIndex The index of `source`.
   * @param {Function} mergeFunc The function to merge values.
   * @param {Function} [customizer] The function to customize assigned values.
   * @param {Object} [stack] Tracks traversed source values and their merged counterparts.
   */
  function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = object[key],
        srcValue = source[key],
        stacked = stack.get(srcValue);
  
    if (stacked) {
      assignMergeValue(object, key, stacked);
      return;
    }
    var newValue = customizer
      ? customizer(objValue, srcValue, (key + ''), object, source, stack)
      : undefined;
  
    var isCommon = newValue === undefined;
  
    if (isCommon) {
      newValue = srcValue;
      if (isArray(srcValue) || isTypedArray(srcValue)) {
        if (isArray(objValue)) {
          newValue = objValue;
        }
        else if (isArrayLikeObject(objValue)) {
          newValue = copyArray(objValue);
        }
        else {
          isCommon = false;
          newValue = baseClone(srcValue, true);
        }
      }
      else if (isPlainObject(srcValue) || isArguments(srcValue)) {
        if (isArguments(objValue)) {
          newValue = toPlainObject(objValue);
        }
        else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
          isCommon = false;
          newValue = baseClone(srcValue, true);
        }
        else {
          newValue = objValue;
        }
      }
      else {
        isCommon = false;
      }
    }
    stack.set(srcValue, newValue);
  
    if (isCommon) {
      // Recursively merge objects and arrays (susceptible to call stack limits).
      mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    }
    assignMergeValue(object, key, newValue);
  }
  
  module.exports = baseMergeDeep;


/***/ },
/* 436 */
/***/ function(module, exports) {

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }
  
  module.exports = baseProperty;


/***/ },
/* 437 */
/***/ function(module, exports) {

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeFloor = Math.floor,
      nativeRandom = Math.random;
  
  /**
   * The base implementation of `_.random` without support for returning
   * floating-point numbers.
   *
   * @private
   * @param {number} lower The lower bound.
   * @param {number} upper The upper bound.
   * @returns {number} Returns the random number.
   */
  function baseRandom(lower, upper) {
    return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
  }
  
  module.exports = baseRandom;


/***/ },
/* 438 */
/***/ function(module, exports) {

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeCeil = Math.ceil,
      nativeMax = Math.max;
  
  /**
   * The base implementation of `_.range` and `_.rangeRight` which doesn't
   * coerce arguments to numbers.
   *
   * @private
   * @param {number} start The start of the range.
   * @param {number} end The end of the range.
   * @param {number} step The value to increment or decrement by.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Array} Returns the new array of numbers.
   */
  function baseRange(start, end, step, fromRight) {
    var index = -1,
        length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
        result = Array(length);
  
    while (length--) {
      result[fromRight ? length : ++index] = start;
      start += step;
    }
    return result;
  }
  
  module.exports = baseRange;


/***/ },
/* 439 */
/***/ function(module, exports) {

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);
  
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }
  
  module.exports = baseTimes;


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

  var arrayMap = __webpack_require__(424);
  
  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }
  
  module.exports = baseValues;


/***/ },
/* 441 */
/***/ function(module, exports) {

  /**
   * Checks if `value` is a global object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {null|Object} Returns `value` if it's a global object, else `null`.
   */
  function checkGlobal(value) {
    return (value && value.Object === Object) ? value : null;
  }
  
  module.exports = checkGlobal;


/***/ },
/* 442 */
/***/ function(module, exports) {

  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var Ctor = buffer.constructor,
        result = new Ctor(buffer.length);
  
    buffer.copy(result);
    return result;
  }
  
  module.exports = cloneBuffer;


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

  var addMapEntry = __webpack_require__(421),
      arrayReduce = __webpack_require__(175),
      mapToArray = __webpack_require__(188);
  
  /**
   * Creates a clone of `map`.
   *
   * @private
   * @param {Object} map The map to clone.
   * @returns {Object} Returns the cloned map.
   */
  function cloneMap(map) {
    var Ctor = map.constructor;
    return arrayReduce(mapToArray(map), addMapEntry, new Ctor);
  }
  
  module.exports = cloneMap;


/***/ },
/* 444 */
/***/ function(module, exports) {

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;
  
  /**
   * Creates a clone of `regexp`.
   *
   * @private
   * @param {Object} regexp The regexp to clone.
   * @returns {Object} Returns the cloned regexp.
   */
  function cloneRegExp(regexp) {
    var Ctor = regexp.constructor,
        result = new Ctor(regexp.source, reFlags.exec(regexp));
  
    result.lastIndex = regexp.lastIndex;
    return result;
  }
  
  module.exports = cloneRegExp;


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

  var addSetEntry = __webpack_require__(422),
      arrayReduce = __webpack_require__(175),
      setToArray = __webpack_require__(189);
  
  /**
   * Creates a clone of `set`.
   *
   * @private
   * @param {Object} set The set to clone.
   * @returns {Object} Returns the cloned set.
   */
  function cloneSet(set) {
    var Ctor = set.constructor;
    return arrayReduce(setToArray(set), addSetEntry, new Ctor);
  }
  
  module.exports = cloneSet;


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

  var Symbol = __webpack_require__(173);
  
  /** Used to convert symbols to primitives and strings. */
  var symbolProto = Symbol ? Symbol.prototype : undefined,
      symbolValueOf = Symbol ? symbolProto.valueOf : undefined;
  
  /**
   * Creates a clone of the `symbol` object.
   *
   * @private
   * @param {Object} symbol The symbol object to clone.
   * @returns {Object} Returns the cloned symbol object.
   */
  function cloneSymbol(symbol) {
    return Symbol ? Object(symbolValueOf.call(symbol)) : {};
  }
  
  module.exports = cloneSymbol;


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

  var cloneArrayBuffer = __webpack_require__(182);
  
  /**
   * Creates a clone of `typedArray`.
   *
   * @private
   * @param {Object} typedArray The typed array to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned typed array.
   */
  function cloneTypedArray(typedArray, isDeep) {
    var arrayBuffer = typedArray.buffer,
        buffer = isDeep ? cloneArrayBuffer(arrayBuffer) : arrayBuffer,
        Ctor = typedArray.constructor;
  
    return new Ctor(buffer, typedArray.byteOffset, typedArray.length);
  }
  
  module.exports = cloneTypedArray;


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

  var assignValue = __webpack_require__(177);
  
  /**
   * This function is like `copyObject` except that it accepts a function to
   * customize copied values.
   *
   * @private
   * @param {Object} source The object to copy properties from.
   * @param {Array} props The property names to copy.
   * @param {Object} [object={}] The object to copy properties to.
   * @param {Function} [customizer] The function to customize copied values.
   * @returns {Object} Returns `object`.
   */
  function copyObjectWith(source, props, object, customizer) {
    object || (object = {});
  
    var index = -1,
        length = props.length;
  
    while (++index < length) {
      var key = props[index];
  
      var newValue = customizer
        ? customizer(object[key], source[key], key, object, source)
        : source[key];
  
      assignValue(object, key, newValue);
    }
    return object;
  }
  
  module.exports = copyObjectWith;


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

  var copyObject = __webpack_require__(104),
      getSymbols = __webpack_require__(454);
  
  /**
   * Copies own symbol properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy symbols from.
   * @param {Object} [object={}] The object to copy symbols to.
   * @returns {Object} Returns `object`.
   */
  function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
  }
  
  module.exports = copySymbols;


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

  var isIterateeCall = __webpack_require__(186),
      rest = __webpack_require__(476);
  
  /**
   * Creates a function like `_.assign`.
   *
   * @private
   * @param {Function} assigner The function to assign values.
   * @returns {Function} Returns the new assigner function.
   */
  function createAssigner(assigner) {
    return rest(function(object, sources) {
      var index = -1,
          length = sources.length,
          customizer = length > 1 ? sources[length - 1] : undefined,
          guard = length > 2 ? sources[2] : undefined;
  
      customizer = typeof customizer == 'function'
        ? (length--, customizer)
        : undefined;
  
      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        customizer = length < 3 ? undefined : customizer;
        length = 1;
      }
      object = Object(object);
      while (++index < length) {
        var source = sources[index];
        if (source) {
          assigner(object, source, index, customizer);
        }
      }
      return object;
    });
  }
  
  module.exports = createAssigner;


/***/ },
/* 451 */
/***/ function(module, exports) {

  /**
   * Creates a base function for methods like `_.forIn`.
   *
   * @private
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
      var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;
  
      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }
  
  module.exports = createBaseFor;


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

  var baseRange = __webpack_require__(438),
      isIterateeCall = __webpack_require__(186),
      toNumber = __webpack_require__(197);
  
  /**
   * Creates a `_.range` or `_.rangeRight` function.
   *
   * @private
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new range function.
   */
  function createRange(fromRight) {
    return function(start, end, step) {
      if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
        end = step = undefined;
      }
      // Ensure the sign of `-0` is preserved.
      start = toNumber(start);
      start = start === start ? start : 0;
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toNumber(end) || 0;
      }
      step = step === undefined ? (start < end ? 1 : -1) : (toNumber(step) || 0);
      return baseRange(start, end, step, fromRight);
    };
  }
  
  module.exports = createRange;


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

  var baseProperty = __webpack_require__(436);
  
  /**
   * Gets the "length" property value of `object`.
   *
   * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
   * that affects Safari on at least iOS 8.1-8.3 ARM64.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {*} Returns the "length" value.
   */
  var getLength = baseProperty('length');
  
  module.exports = getLength;


/***/ },
/* 454 */
/***/ function(module, exports) {

  /** Built-in value references. */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  
  /**
   * Creates an array of the own symbol properties of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */
  var getSymbols = getOwnPropertySymbols || function() {
    return [];
  };
  
  module.exports = getSymbols;


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

  var hashHas = __webpack_require__(184);
  
  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function hashDelete(hash, key) {
    return hashHas(hash, key) && delete hash[key];
  }
  
  module.exports = hashDelete;


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

  var nativeCreate = __webpack_require__(78);
  
  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';
  
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  
  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;
  
  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @param {Object} hash The hash to query.
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function hashGet(hash, key) {
    if (nativeCreate) {
      var result = hash[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(hash, key) ? hash[key] : undefined;
  }
  
  module.exports = hashGet;


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

  var nativeCreate = __webpack_require__(78);
  
  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';
  
  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   */
  function hashSet(hash, key, value) {
    hash[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  }
  
  module.exports = hashSet;


/***/ },
/* 458 */
/***/ function(module, exports) {

  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  
  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;
  
  /**
   * Initializes an array clone.
   *
   * @private
   * @param {Array} array The array to clone.
   * @returns {Array} Returns the initialized clone.
   */
  function initCloneArray(array) {
    var length = array.length,
        result = array.constructor(length);
  
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
      result.index = array.index;
      result.input = array.input;
    }
    return result;
  }
  
  module.exports = initCloneArray;


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

  var cloneArrayBuffer = __webpack_require__(182),
      cloneMap = __webpack_require__(443),
      cloneRegExp = __webpack_require__(444),
      cloneSet = __webpack_require__(445),
      cloneSymbol = __webpack_require__(446),
      cloneTypedArray = __webpack_require__(447);
  
  /** `Object#toString` result references. */
  var boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]';
  
  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';
  
  /**
   * Initializes an object clone based on its `toStringTag`.
   *
   * **Note:** This function only supports cloning values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {string} tag The `toStringTag` of the object to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the initialized clone.
   */
  function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch (tag) {
      case arrayBufferTag:
        return cloneArrayBuffer(object);
  
      case boolTag:
      case dateTag:
        return new Ctor(+object);
  
      case float32Tag: case float64Tag:
      case int8Tag: case int16Tag: case int32Tag:
      case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
        return cloneTypedArray(object, isDeep);
  
      case mapTag:
        return cloneMap(object);
  
      case numberTag:
      case stringTag:
        return new Ctor(object);
  
      case regexpTag:
        return cloneRegExp(object);
  
      case setTag:
        return cloneSet(object);
  
      case symbolTag:
        return cloneSymbol(object);
    }
  }
  
  module.exports = initCloneByTag;


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

  var baseCreate = __webpack_require__(428),
      isFunction = __webpack_require__(47),
      isPrototype = __webpack_require__(107);
  
  /** Built-in value references. */
  var getPrototypeOf = Object.getPrototypeOf;
  
  /**
   * Initializes an object clone.
   *
   * @private
   * @param {Object} object The object to clone.
   * @returns {Object} Returns the initialized clone.
   */
  function initCloneObject(object) {
    return (isFunction(object.constructor) && !isPrototype(object))
      ? baseCreate(getPrototypeOf(object))
      : {};
  }
  
  module.exports = initCloneObject;


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

  var Hash = __webpack_require__(415),
      Map = __webpack_require__(46);
  
  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */
  function mapClear() {
    this.__data__ = {
      'hash': new Hash,
      'map': Map ? new Map : [],
      'string': new Hash
    };
  }
  
  module.exports = mapClear;


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

  var Map = __webpack_require__(46),
      assocDelete = __webpack_require__(178),
      hashDelete = __webpack_require__(455),
      isKeyable = __webpack_require__(77);
  
  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function mapDelete(key) {
    var data = this.__data__;
    if (isKeyable(key)) {
      return hashDelete(typeof key == 'string' ? data.string : data.hash, key);
    }
    return Map ? data.map['delete'](key) : assocDelete(data.map, key);
  }
  
  module.exports = mapDelete;


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

  var Map = __webpack_require__(46),
      assocGet = __webpack_require__(179),
      hashGet = __webpack_require__(456),
      isKeyable = __webpack_require__(77);
  
  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function mapGet(key) {
    var data = this.__data__;
    if (isKeyable(key)) {
      return hashGet(typeof key == 'string' ? data.string : data.hash, key);
    }
    return Map ? data.map.get(key) : assocGet(data.map, key);
  }
  
  module.exports = mapGet;


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

  var Map = __webpack_require__(46),
      assocHas = __webpack_require__(180),
      hashHas = __webpack_require__(184),
      isKeyable = __webpack_require__(77);
  
  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function mapHas(key) {
    var data = this.__data__;
    if (isKeyable(key)) {
      return hashHas(typeof key == 'string' ? data.string : data.hash, key);
    }
    return Map ? data.map.has(key) : assocHas(data.map, key);
  }
  
  module.exports = mapHas;


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

  var Map = __webpack_require__(46),
      assocSet = __webpack_require__(181),
      hashSet = __webpack_require__(457),
      isKeyable = __webpack_require__(77);
  
  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache object.
   */
  function mapSet(key, value) {
    var data = this.__data__;
    if (isKeyable(key)) {
      hashSet(typeof key == 'string' ? data.string : data.hash, key, value);
    } else if (Map) {
      data.map.set(key, value);
    } else {
      assocSet(data.map, key, value);
    }
    return this;
  }
  
  module.exports = mapSet;


/***/ },
/* 466 */
/***/ function(module, exports) {

  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */
  function stackClear() {
    this.__data__ = { 'array': [], 'map': null };
  }
  
  module.exports = stackClear;


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

  var assocDelete = __webpack_require__(178);
  
  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function stackDelete(key) {
    var data = this.__data__,
        array = data.array;
  
    return array ? assocDelete(array, key) : data.map['delete'](key);
  }
  
  module.exports = stackDelete;


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

  var assocGet = __webpack_require__(179);
  
  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function stackGet(key) {
    var data = this.__data__,
        array = data.array;
  
    return array ? assocGet(array, key) : data.map.get(key);
  }
  
  module.exports = stackGet;


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

  var assocHas = __webpack_require__(180);
  
  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function stackHas(key) {
    var data = this.__data__,
        array = data.array;
  
    return array ? assocHas(array, key) : data.map.has(key);
  }
  
  module.exports = stackHas;


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

  var MapCache = __webpack_require__(416),
      assocSet = __webpack_require__(181);
  
  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;
  
  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache object.
   */
  function stackSet(key, value) {
    var data = this.__data__,
        array = data.array;
  
    if (array) {
      if (array.length < (LARGE_ARRAY_SIZE - 1)) {
        assocSet(array, key, value);
      } else {
        data.array = null;
        data.map = new MapCache(array);
      }
    }
    var map = data.map;
    if (map) {
      map.set(key, value);
    }
    return this;
  }
  
  module.exports = stackSet;


/***/ },
/* 471 */
/***/ function(module, exports) {

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
      rsComboSymbolsRange = '\\u20d0-\\u20f0',
      rsVarRange = '\\ufe0e\\ufe0f';
  
  /** Used to compose unicode capture groups. */
  var rsAstral = '[' + rsAstralRange + ']',
      rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsZWJ = '\\u200d';
  
  /** Used to compose unicode regexes. */
  var reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
  
  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reComplexSymbol = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
  
  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return string.match(reComplexSymbol);
  }
  
  module.exports = stringToArray;


/***/ },
/* 472 */
/***/ function(module, exports) {

  /**
   * Creates a function that returns `value`.
   *
   * @static
   * @memberOf _
   * @category Util
   * @param {*} value The value to return from the new function.
   * @returns {Function} Returns the new function.
   * @example
   *
   * var object = { 'user': 'fred' };
   * var getter = _.constant(object);
   *
   * getter() === object;
   * // => true
   */
  function constant(value) {
    return function() {
      return value;
    };
  }
  
  module.exports = constant;


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

  /* WEBPACK VAR INJECTION */(function(module) {var constant = __webpack_require__(472),
      root = __webpack_require__(37);
  
  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };
  
  /** Detect free variable `exports`. */
  var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
    ? exports
    : undefined;
  
  /** Detect free variable `module`. */
  var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
    ? module
    : undefined;
  
  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = (freeModule && freeModule.exports === freeExports)
    ? freeExports
    : undefined;
  
  /** Built-in value references. */
  var Buffer = moduleExports ? root.Buffer : undefined;
  
  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */
  var isBuffer = !Buffer ? constant(false) : function(value) {
    return value instanceof Buffer;
  };
  
  module.exports = isBuffer;
  
  /* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(239)(module)))

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

  var isFunction = __webpack_require__(47),
      isHostObject = __webpack_require__(105),
      isObjectLike = __webpack_require__(58);
  
  /** Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns). */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  
  /** Used to detect host constructors (Safari > 5). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  
  /** Used to resolve the decompiled source of functions. */
  var funcToString = Function.prototype.toString;
  
  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;
  
  /** Used to detect if a method is native. */
  var reIsNative = RegExp('^' +
    funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
    .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
  );
  
  /**
   * Checks if `value` is a native function.
   *
   * @static
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
   * @example
   *
   * _.isNative(Array.prototype.push);
   * // => true
   *
   * _.isNative(_);
   * // => false
   */
  function isNative(value) {
    if (value == null) {
      return false;
    }
    if (isFunction(value)) {
      return reIsNative.test(funcToString.call(value));
    }
    return isObjectLike(value) &&
      (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
  }
  
  module.exports = isNative;


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

  var createRange = __webpack_require__(452);
  
  /**
   * Creates an array of numbers (positive and/or negative) progressing from
   * `start` up to, but not including, `end`. A step of `-1` is used if a negative
   * `start` is specified without an `end` or `step`. If `end` is not specified
   * it's set to `start` with `start` then set to `0`.
   *
   * **Note:** JavaScript follows the IEEE-754 standard for resolving
   * floating-point values which can produce unexpected results.
   *
   * @static
   * @memberOf _
   * @category Util
   * @param {number} [start=0] The start of the range.
   * @param {number} end The end of the range.
   * @param {number} [step=1] The value to increment or decrement by.
   * @returns {Array} Returns the new array of numbers.
   * @example
   *
   * _.range(4);
   * // => [0, 1, 2, 3]
   *
   * _.range(-4);
   * // => [0, -1, -2, -3]
   *
   * _.range(1, 5);
   * // => [1, 2, 3, 4]
   *
   * _.range(0, 20, 5);
   * // => [0, 5, 10, 15]
   *
   * _.range(0, -4, -1);
   * // => [0, -1, -2, -3]
   *
   * _.range(1, 4, 0);
   * // => [1, 1, 1]
   *
   * _.range(0);
   * // => []
   */
  var range = createRange();
  
  module.exports = range;


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

  var apply = __webpack_require__(423),
      toInteger = __webpack_require__(196);
  
  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';
  
  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeMax = Math.max;
  
  /**
   * Creates a function that invokes `func` with the `this` binding of the
   * created function and arguments from `start` and beyond provided as an array.
   *
   * **Note:** This method is based on the [rest parameter](https://mdn.io/rest_parameters).
   *
   * @static
   * @memberOf _
   * @category Function
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @returns {Function} Returns the new function.
   * @example
   *
   * var say = _.rest(function(what, names) {
   *   return what + ' ' + _.initial(names).join(', ') +
   *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
   * });
   *
   * say('hello', 'fred', 'barney', 'pebbles');
   * // => 'hello fred, barney, & pebbles'
   */
  function rest(func, start) {
    if (typeof func != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
    return function() {
      var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);
  
      while (++index < length) {
        array[index] = args[start + index];
      }
      switch (start) {
        case 0: return func.call(this, array);
        case 1: return func.call(this, args[0], array);
        case 2: return func.call(this, args[0], args[1], array);
      }
      var otherArgs = Array(start + 1);
      index = -1;
      while (++index < start) {
        otherArgs[index] = args[index];
      }
      otherArgs[start] = array;
      return apply(func, this, otherArgs);
    };
  }
  
  module.exports = rest;


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

  var baseClamp = __webpack_require__(426),
      baseRandom = __webpack_require__(437),
      toArray = __webpack_require__(478),
      toInteger = __webpack_require__(196);
  
  /**
   * Gets `n` random elements at unique keys from `collection` up to the
   * size of `collection`.
   *
   * @static
   * @memberOf _
   * @category Collection
   * @param {Array|Object} collection The collection to sample.
   * @param {number} [n=0] The number of elements to sample.
   * @returns {Array} Returns the random elements.
   * @example
   *
   * _.sampleSize([1, 2, 3], 2);
   * // => [3, 1]
   *
   * _.sampleSize([1, 2, 3], 4);
   * // => [2, 3, 1]
   */
  function sampleSize(collection, n) {
    var index = -1,
        result = toArray(collection),
        length = result.length,
        lastIndex = length - 1;
  
    n = baseClamp(toInteger(n), 0, length);
    while (++index < n) {
      var rand = baseRandom(index, lastIndex),
          value = result[rand];
  
      result[rand] = result[index];
      result[index] = value;
    }
    result.length = n;
    return result;
  }
  
  module.exports = sampleSize;


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

  var Symbol = __webpack_require__(173),
      copyArray = __webpack_require__(103),
      getTag = __webpack_require__(183),
      isArrayLike = __webpack_require__(81),
      isString = __webpack_require__(192),
      iteratorToArray = __webpack_require__(187),
      mapToArray = __webpack_require__(188),
      setToArray = __webpack_require__(189),
      stringToArray = __webpack_require__(471),
      values = __webpack_require__(480);
  
  /** `Object#toString` result references. */
  var mapTag = '[object Map]',
      setTag = '[object Set]';
  
  /** Built-in value references. */
  var iteratorSymbol = typeof (iteratorSymbol = Symbol && Symbol.iterator) == 'symbol' ? iteratorSymbol : undefined;
  
  /**
   * Converts `value` to an array.
   *
   * @static
   * @memberOf _
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {Array} Returns the converted array.
   * @example
   *
   * _.toArray({ 'a': 1, 'b': 2 });
   * // => [1, 2]
   *
   * _.toArray('abc');
   * // => ['a', 'b', 'c']
   *
   * _.toArray(1);
   * // => []
   *
   * _.toArray(null);
   * // => []
   */
  function toArray(value) {
    if (!value) {
      return [];
    }
    if (isArrayLike(value)) {
      return isString(value) ? stringToArray(value) : copyArray(value);
    }
    if (iteratorSymbol && value[iteratorSymbol]) {
      return iteratorToArray(value[iteratorSymbol]());
    }
    var tag = getTag(value),
        func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
  
    return func(value);
  }
  
  module.exports = toArray;


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

  var copyObject = __webpack_require__(104),
      keysIn = __webpack_require__(194);
  
  /**
   * Converts `value` to a plain object flattening inherited enumerable
   * properties of `value` to own properties of the plain object.
   *
   * @static
   * @memberOf _
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {Object} Returns the converted plain object.
   * @example
   *
   * function Foo() {
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.assign({ 'a': 1 }, new Foo);
   * // => { 'a': 1, 'b': 2 }
   *
   * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
   * // => { 'a': 1, 'b': 2, 'c': 3 }
   */
  function toPlainObject(value) {
    return copyObject(value, keysIn(value));
  }
  
  module.exports = toPlainObject;


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

  var baseValues = __webpack_require__(440),
      keys = __webpack_require__(109);
  
  /**
   * Creates an array of the own enumerable property values of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property values.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.values(new Foo);
   * // => [1, 2] (iteration order is not guaranteed)
   *
   * _.values('hi');
   * // => ['h', 'i']
   */
  function values(object) {
    return object ? baseValues(object, keys(object)) : [];
  }
  
  module.exports = values;


/***/ }
]);


/** WEBPACK FOOTER **
 ** main.15d20839b88974cfc48c.js
 **/